function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  fill: "none"
}, /*#__PURE__*/React.createElement("g", {
  opacity: 0.13
}, /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M312.875 503.347l14.68-10.85.039.041-14.662 10.87z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M295.212 475.366l.041-.038 32.342 17.17-.022.06z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M295.212 475.366l.041-.038 17.68 28.04-.059.018z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M295.234 475.307l22.662-4.397.017.06-22.662 4.397z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M275.446 455.67l.04-.04 19.767 19.698-.04.038z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M291.066 449.395l.06-.017 4.145 25.97-.078-.003z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M275.468 455.61l15.6-6.255.017.06-15.6 6.255z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M275.447 455.63l16.011-28.07.038.04-15.99 28.05z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M291.438 427.58l.078.002-.39 21.796-.08-.004z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M291.067 449.355l21.112-6.018.019.06-21.113 6.018z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M291.106 449.357l29.036 5.071-.004.078-29.053-5.09z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M291.066 449.395l.04-.038 26.81 21.574-.041.038z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M295.213 475.326l24.908-20.879.038.04-24.908 20.88z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M295.213 475.326l16.947-31.97.058.022-16.947 31.97z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M312.158 443.395l.04-.038 8.232 11.22-.04.037zm15.418 49.083l25.042 2.736-.021.059-25.024-2.716z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M337.214 463.007l.057.021-9.657 29.49-.059-.02z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M317.875 470.969l.04-.038 9.7 21.588-.061.018z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M317.896 470.91l19.337-7.922.018.059-19.338 7.923z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M320.1 454.466l.08.002-2.246 16.483-.058-.022z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M317.876 470.93l15.84-24.2.037.041-15.82 24.18z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M320.121 454.447l13.595-7.716.037.04-13.594 7.716z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M320.12 454.487l.04-.038 17.093 8.56-.04.037zm17.092 8.56l.04-.038 13.75 7.852-.022.058z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M337.212 463.046l.04-.037 15.386 32.225-.06.018z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M350.961 470.899l.06-.018 1.617 24.353-.06.018zM341.424 452.605l.06-.017 9.536 18.293-.059.018z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M351.002 470.861l20.481-1.303-.003.078L351 470.939zm-9.597-18.276l.078.003-4.212 10.44-.057-.021zM333.78 446.651l7.492 6.15zM336.354 434.248l-2.526 12.583z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M333.736 446.712l18.752 3.49-.021.058-18.734-3.47zm7.728 5.856l25.098 8.59-.002.08-25.117-8.613z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M341.464 452.568l10.985-2.368.018.06-11.024 2.365z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M341.464 452.568l42.152-.118.018.059-42.191.116zm25.077 8.649l.04-.038 4.921 8.4-.04.037z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M366.542 461.177l17.074-8.727.018.059-17.054 8.71z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M356.325 450.22l.04-.037 10.216 10.996-.04.038z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M352.45 450.2l3.896-.037-.002.078-3.877.019z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M356.326 450.182l5.448-7.656.038.041-5.428 7.637z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M356.346 450.163l27.27 2.287.018.059-27.29-2.268zM344.432 434.175l16.904 10.57z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M361.795 442.507l21.84 9.964-.04.037-21.821-9.943z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M336.26 434.136l25.535 8.371-.021.058-25.537-8.372z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M336.26 434.136l8.624-2.061.018.059-8.626 2.06z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M328.823 420.811l.041-.038 16.039 11.322-.04.038z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M303.108 413.138l41.776 18.937-.021.058-41.777-18.938zm-8.103-9.257l.022-.059 33.837 16.951-.04.038z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M313.65 425.457l15.196-4.704.017.06-15.195 4.703z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M292.642 416.914l36.204 3.84-.004.078-36.2-3.88zm2.363-13.033l.04-.038 8.063 9.295-.04.037z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M292.623 416.893l10.446-3.757.017.059-10.444 3.757z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M303.068 413.175l.04-.037 10.582 12.32-.041.038z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M302.64 422.283l11.031 3.155-.022.058-11.032-3.155zm11.009 3.213l.04-.038 8.137 9.414-.04.037z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M291.067 449.355l22.565-23.919.056.061-22.583 23.899zM292.57 417.303l-.981 10.329zM291.458 427.56l11.142-5.279.017.06-11.121 5.26z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M291.478 427.542l30.329 7.31-.002.078-30.349-7.33zm11.57-14.387l.078.003-.488 9.163-.058-.02z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M294.658 403.712l.06-.017 7.94 18.607-.079.037z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M302.58 422.3l.058.021-11.533 27.075-.058-.022zm19.206 12.57l7.04-14.098.057.021-7.059 14.118z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M321.018 434.452l15.241-.316.017.059-15.261.335zm-8.858 8.903l9.626-8.485.038.041-9.626 8.485z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#333",
  d: "M366.142 462.005a.915.915 0 01-.39-1.189.855.855 0 011.188-.387.858.858 0 01.41 1.169.91.91 0 01-1.208.407zm-15.561 9.703a.887.887 0 01-.39-1.19.889.889 0 011.598.783.91.91 0 01-1.207.406zm5.365-20.717a.86.86 0 01-.39-1.189.886.886 0 011.188-.389.884.884 0 01-.797 1.578zm-3.877.057a.892.892 0 01-.498-.74.886.886 0 011.275-.857.887.887 0 11-.778 1.597zm-18.754-3.49a.886.886 0 01-.383-1.184.886.886 0 011.592.777.911.911 0 01-1.209.407zm3.518 16.258a.884.884 0 111.07-1.366c.233.272.28.658.118.977a.855.855 0 01-1.188.389zm-17.092-8.56a.857.857 0 01-.41-1.17.89.89 0 111.089 1.232.857.857 0 01-.679-.063zm21.324-1.861a.883.883 0 01-.43-1.19.91.91 0 01.765-.634.915.915 0 01.852 1.436.886.886 0 01-1.188.389zm-27.815-27.11a.888.888 0 01-.39-1.19.89.89 0 011.598.782.938.938 0 01-1.207.407zm-22.192 2.103a.885.885 0 01-.39-1.189.887.887 0 111.597.782.91.91 0 01-1.207.407zm-.39 21.795a.915.915 0 01-.391-1.189.855.855 0 011.188-.387.857.857 0 01.41 1.168.91.91 0 01-1.207.408zm21.112-6.018a.884.884 0 11.797-1.578.885.885 0 01-.797 1.578zm-19.537-26.424a.888.888 0 111.275-.859.886.886 0 01-1.275.86zm43.616 17.222a.884.884 0 111.07-1.366.885.885 0 01-1.07 1.366zm-41.025 41.172a.886.886 0 111.187-.388.857.857 0 01-1.187.388zm-19.748-19.677a.887.887 0 11.779-1.597.888.888 0 11-.779 1.597zm52.09 36.849a.887.887 0 01-.39-1.19.884.884 0 011.166-.347c.42.214.6.717.412 1.148a.855.855 0 01-1.188.389zm-14.661 10.87a.888.888 0 11.778-1.598c.43.235.608.761.41 1.21a.884.884 0 01-1.189.386zm39.704-8.135a.862.862 0 01-.411-1.17.884.884 0 011.19-.427c.429.235.607.761.408 1.209a.884.884 0 01-1.187.388zm-34.723-24.304a.886.886 0 11.712-1.622.886.886 0 01-.712 1.622zm53.68-1.213a.942.942 0 01-.41-1.208.886.886 0 011.189-.39.86.86 0 01.41 1.17.88.88 0 01-1.189.428zm12.04-17.247a.888.888 0 01-.116-1.561.887.887 0 011.262 1.151.885.885 0 01-1.146.41zm-21.841-9.924a.887.887 0 01-.391-1.188.889.889 0 111.598.781.911.911 0 01-1.207.406zm-16.892-10.452a.886.886 0 111.19-.388.855.855 0 01-1.19.388zm-16.037-11.321a.885.885 0 11.796-1.577.914.914 0 01.39 1.189.855.855 0 01-1.187.387zm-7.039 14.098a.857.857 0 01-.411-1.17.912.912 0 011.208-.407c.436.222.61.753.39 1.19a.855.855 0 01-1.187.387zm-19.188-12.55a.89.89 0 01-.108-1.536.89.89 0 11.108 1.536zm.449-9.165a.915.915 0 01-.39-1.19.886.886 0 111.578.8.885.885 0 01-1.187.389zm-8.042-9.313a.862.862 0 01-.41-1.17c.153-.326.487-.527.846-.508a.888.888 0 01.544 1.548.884.884 0 01-.979.13z"
})), /*#__PURE__*/React.createElement("g", {
  opacity: 0.58
}, /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M383.445 374.154l-18.284 4.025.003-.078 18.285-4.025z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M388.333 407.689l-.041.038-23.15-29.569.04-.037z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M388.351 407.708l-.078-.002-4.865-33.592.06-.018z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M388.31 407.746l-23.073-5.367.021-.058 23.056 5.347z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M398.641 434.35l-.06.017-10.29-26.64.042-.038z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M381.416 433.714l-.078-.003 6.955-26.024.058.021z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M398.62 434.408l-17.244-.656.021-.058 17.225.635z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M398.64 434.389l-26.684 19.582-.038-.04 26.684-19.583z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M371.956 453.971l-.059-.022 9.44-20.238.059.022z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M381.376 433.752l-22.268-3.166.003-.077 22.286 3.185z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M381.376 433.752l-25.11-16.874.022-.058 25.11 16.874z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M381.416 433.714l-.06.017-16.119-31.352.04-.037z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M388.33 407.727l-32.044 9.172-.017-.098 32.045-9.133z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M388.33 407.727l-29.202 22.84-.037-.04 29.202-22.84z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M359.148 430.549l-.078-.003-3.01-13.929.06-.018zm6.013-52.37l-22.324-12.995.021-.058 22.324 12.995zM365.267 378.205l-21.332 23.574z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M365.297 402.362l-.079-.003-.094-24.22.077.002z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M365.256 402.4l-21.434-.65.003-.077 21.433.648z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M356.306 416.88l-.057-.06 8.97-14.461.058.022z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M365.256 402.4l-24.9 16.024-.037-.04 24.92-16.044z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M356.267 416.878l-15.949 1.544.022-.057 15.948-1.545z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M356.307 416.84l-.06.018-12.443-15.127.04-.038zm-12.463-15.147l-.04.038-9.616-13.11.06-.016zM342.934 365.22l.956 36.571z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M334.266 388.624l-.058-.02 8.61-23.44.079.003z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M335.564 409.717l-.078-.003-1.298-21.092.06-.017z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M334.208 388.642L314.47 381.3l.022-.058 19.737 7.343zm1.336 21.093l-.037-.04 8.298-8.004.038.04z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M340.358 418.385l-.058.017-4.796-8.668.04-.038z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M332.73 429.134l-.038-.041 7.627-10.71.038.041z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M340.318 418.422l-16.106-11.07.04-.037 16.088 11.05zm-4.814-8.688l-19.943-18.509.06-.057 19.924 18.528z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M335.524 409.754l-11.293-2.38.003-.079 11.292 2.382zM295.88 392.303l39.555 17.474zM315.62 391.208l-.058-.023-1.11-9.906.059-.017z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M315.6 391.226l-19.631 1.04.002-.077 19.61-1.022z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M320.587 405.735l-.06.017-4.965-14.567.06-.017zm3.625 1.618l-3.665-1.58.04-.038 3.647 1.56zM312.203 410.718l8.282-4.898z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M320.547 405.773l-24.578-13.506.02-.058 24.618 13.508zm3.255 21.652l-.061.056-11.485-16.816.06-.057z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M312.256 410.665l-16.306-18.419.04-.037 16.326 18.399zM312.21 410.738l20.429 18.49zM332.71 429.153l-8.93-1.67-.016-.06 8.967 1.672z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M334.098 444.708l-.04.037-10.317-17.264.06-.056z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M355.04 462.627l-31.299-35.146.06-.056 31.28 35.164zm3.702 12.035l-.041.038-24.643-29.955.04-.037z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M350.258 446.715l-16.181-1.95.002-.078 16.182 1.95z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M366.386 463.443l-32.31-18.677.022-.058 32.329 18.698zm-7.644 11.219l-.06.017-3.66-12.073.059-.017z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M366.406 463.464l-11.365-.837.001-.04 11.366.798z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M355.08 462.59l-.058.016-4.783-15.912.06-.017z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M359.3 454.262l-9.061-7.568.04-.037 9.042 7.548z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M350.298 446.677l-.06.017-3.713-12.211.06-.017z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M381.396 433.733l-31.118 12.963-.017-.059 31.097-12.945zm-14.689 29.486l-.058-.02 5.269-9.269.038.041z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M371.935 453.99l-12.636.272.002-.039 12.637-.312zM346.474 434.543l25.387 19.498z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M355.08 462.627l-.078-.041 4.26-8.364.058.021z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M358.985 474.964h-.039l.335-20.722.039.001zm.354-20.7l-.057-.061 22.076-20.51.038.04zm-12.756-19.76l-12.487 10.243-.038-.04 12.468-10.264z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M347.126 435.208l-14.417-6.055.022-.058 14.417 6.056zM346.501 434.532l12.565-3.928-12.565 3.928z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#333",
  d: "M316.286 390.624a.913.913 0 11-1.41 1.162.913.913 0 011.41-1.162zm18.626-2.564a.857.857 0 01-.121 1.248.878.878 0 01-.656.218.889.889 0 01-.613-.321.913.913 0 111.314-1.226l.076.081zm-13.64 17.112c.32.39.265.964-.124 1.285a.914.914 0 01-1.165-1.409.911.911 0 011.288.124zm3.644 1.599a.913.913 0 11-1.584.825.912.912 0 011.586-.825zm16.167 11.013a.887.887 0 01-.14 1.268.863.863 0 01-.65.21.864.864 0 01-.6-.333.888.888 0 01.103-1.27.917.917 0 011.288.125zm3.405-16.616c.156.186.23.428.207.669a.905.905 0 01-.33.618.912.912 0 01-1.245-1.336.912.912 0 011.369.049zm12.483 15.129a.913.913 0 01-.14 1.165.914.914 0 01-1.174.06.912.912 0 01.123-1.288.913.913 0 011.191.063zm-20.761-7.144a.884.884 0 01-.102 1.27.914.914 0 01-1.247-1.338.883.883 0 011.349.068zm14.754 36.941a.94.94 0 01-.122 1.288.914.914 0 01-1.288-.124.884.884 0 01.141-1.268.887.887 0 011.27.104zm21.658 7.293a.916.916 0 01-.123 1.289.89.89 0 01-1.268-.143.86.86 0 01.121-1.249.885.885 0 011.27.103zm9.338-20.143a.913.913 0 11-1.248-.123.884.884 0 011.248.123zm-22.166-3.26a.884.884 0 01-.102 1.27.914.914 0 01-1.246-1.337.883.883 0 011.348.068zm7.354 32.938c.155.187.23.428.205.67a.908.908 0 01-.327.618.886.886 0 01-1.268-.143.89.89 0 01.102-1.27.94.94 0 011.288.126zm-33.753-34.37a.912.912 0 01-.122 1.286.886.886 0 01-1.268-.143.86.86 0 01.121-1.248.89.89 0 011.27.104zm55.622-21.426a.94.94 0 01-.122 1.288.914.914 0 01-1.163-1.41.913.913 0 011.285.122zm10.309 26.66a.941.941 0 01-.122 1.289.913.913 0 01-1.162-1.41.913.913 0 011.284.121zm-33.479-56.209a.884.884 0 01-.101 1.27.915.915 0 01-1.289-.125.912.912 0 01.142-1.268.858.858 0 011.247.122zm18.285-4.025a.885.885 0 01-.102 1.269.94.94 0 01-1.288-.125.91.91 0 01.122-1.287.885.885 0 011.268.143zm-40.59-8.95c.158.18.237.417.219.657a.888.888 0 01-.32.612.913.913 0 01-1.248-1.337.884.884 0 011.349.068zm22.4 37.196a.913.913 0 11-1.334 1.243.939.939 0 01.122-1.287.912.912 0 011.212.044zm-50.767-21.08a.914.914 0 01-.395 1.628.914.914 0 01-.92-.403.913.913 0 111.314-1.226zm-18.52 10.947a.91.91 0 01-.122 1.287.885.885 0 01-1.268-.143.86.86 0 01.121-1.248.89.89 0 011.27.103zm16.326 18.399a.913.913 0 11-1.335 1.244.886.886 0 01.141-1.268.886.886 0 011.194.024zm11.542 16.878a.913.913 0 11-1.408 1.16.913.913 0 011.408-1.16zm10.24 17.222c.158.18.236.417.218.657a.89.89 0 01-.32.612.913.913 0 01-1.288-.124.888.888 0 01.14-1.268.863.863 0 01.65-.211.864.864 0 01.6.334zm12.506-10.262a.912.912 0 01-.142 1.268.909.909 0 01-.944.337.915.915 0 01-.283-1.653.912.912 0 011.369.049zm12.716 19.759a.912.912 0 11-1.558.873.914.914 0 01.29-.978.914.914 0 011.268.105zm-4.084 8.389a.887.887 0 01-.14 1.268.913.913 0 01-1.289-.125c-.343-.368-.324-.947.045-1.29s.946-.323 1.29.046l.095.101zm3.606 11.973a.942.942 0 01-.122 1.289.913.913 0 01-1.163-1.411.914.914 0 011.285.122z"
})), /*#__PURE__*/React.createElement("g", {
  opacity: 0.54
}, /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M432.036 433.273l16.32 4.245-.022.058-16.319-4.245z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M441.848 404.395l.04.002 6.486 33.141-.06.017z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M441.848 404.395l.06.022-9.853 28.877-.058-.022z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M441.909 404.377l16.309 13.72-.04.038-16.31-13.72zm2.593-25.553l.058.021-2.672 25.552-.04-.002z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M458.065 386.396l.058.021-16.216 18-.038-.04z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M444.561 378.807l13.562 7.572-.04.037-13.562-7.572z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M444.522 378.805l29.429-4.761.018.058-29.43 4.762z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M473.95 374.044l.019.058-15.867 12.335-.017-.06z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M458.123 386.379l16.556 11.673-.04.037-16.576-11.654z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M458.123 386.379l13.207 23.808-.041.038-13.206-23.809z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M458.065 386.396l.058.021.093 31.72-.057-.023z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M441.869 404.376l29.46 5.811v.04l-29.461-5.811z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M441.869 404.376l32.771-6.326.018.06-32.771 6.326z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M474.62 398.069l.058.022-3.28 12.372-.04-.001zm-26.265 39.449l12.567 19.557-.04.038-12.567-19.558z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M475.09 427.393l.016.06-26.772 10.123-.018-.06z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M458.159 418.114l.057.023-9.862 19.42-.058-.022z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M458.218 418.097l16.91 9.297-.022.059-16.928-9.318z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M471.31 410.167l.018.06-13.131 7.928-.019-.06z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M458.178 418.096l26.577-2.632-.021.058-26.537 2.633z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M471.33 410.187l13.425 5.277-.021.058-13.425-5.316z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M471.31 410.206l.039.002 3.798 17.207-.06.017zm3.777 17.226l.06-.017 2.328 14.413-.06.019z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M475.069 427.412l.058.022-14.186 29.66-.058-.02z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M477.436 441.828l.037.04-16.552 15.245-.038-.04z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M484.999 424.4l.057.022-7.583 17.446-.058-.021z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M477.475 441.828l12.817 13.948-.04.038-12.818-13.947zm7.544-17.447l.017.06-9.93 3.012-.017-.06z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M484.715 415.501l.059-.017.303 8.919-.06.017z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M495.238 410.005l.018.06-10.484 5.459-.038-.041z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M484.774 415.484l8.361 15.452-.04.038-8.38-15.473zm.303 8.919l8.398 22.99-.06.018-8.397-22.99zM484.993 424.47l8.097 6.545z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M485.058 424.383l24.577 30.205-.04.038-24.577-30.206zm8.357 23.028l.058.02-3.183 8.384-.039-.001z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M493.455 447.373l16.16 7.234-.02.019-16.16-7.195z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M495.39 433.718l.039.001-1.956 13.713-.058-.021z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M493.135 430.936l2.294 2.783-.041.039-2.294-2.784z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M495.41 433.699l8.65-.532v.04l-8.652.531z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M495.429 433.72l14.206 20.868-.04.038-14.206-20.908zm6.274-18.688l.06-.017 2.317 18.172-.06.018z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M504.08 433.187l5.553 21.44-.039-.001-5.574-21.421zM495.278 410.006l8.802 23.181-.06.018-8.783-23.16z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M495.278 410.006l6.485 5.009-.041.038-6.485-5.009z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M500.518 396.978l.059-.017 1.186 18.054-.06.017z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M491.08 374.049l10.683 40.966-.06.017-10.683-40.966zm1.945-11.128l.059-.018 7.493 34.058-.06.017z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M488.386 388.754l12.172 8.187-.021.058-12.191-8.208z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M482.314 368.743l18.263 28.218-.06.017-18.262-28.217zm10.692-5.843l.078.003-2.005 11.185-.059-.022z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M482.295 368.723l8.785 5.326-.04.038-8.767-5.306z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M491.02 374.066l.059.022-2.694 14.704-.058-.021z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M484.234 379.031l4.152 9.723-.04.037-4.17-9.742z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M488.327 388.77l.058.022-2.03 11.283-.038-.002z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M458.085 386.377l30.262 2.374.018.06-30.263-2.374zm23.875-17.568l.037.04-8.028 5.253-.018-.058z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M473.99 374.044l10.226 4.968-.002.038-10.245-4.948z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M473.99 374.044l12.366 26.03-.059.018-12.347-26.01zm17.05.003l.018.06-6.844 4.943-.017-.059z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M492.96 362.565l.038.002-8.764 16.464-.057-.021z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M484.197 378.991l.017.059-26.112 7.387-.017-.06zm2.14 21.064l14.2-3.095V397l-14.201 3.094zM486.23 399.395l9.101 10.764zM474.679 398.052l11.658 2.003-.001.038-11.678-1.983z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#333",
  d: "M492.645 447.598a.807.807 0 01.6-.977.86.86 0 01.998.623.829.829 0 01-.64.976.777.777 0 01-.958-.622zm-16-5.564a.803.803 0 01.601-.977.86.86 0 01.997.623.828.828 0 01-.64.976.81.81 0 01-.609-.111.807.807 0 01-.349-.51zm17.974-8.127a.806.806 0 01.602-.978.831.831 0 01.976.642.802.802 0 01-.62.956.77.77 0 01-.615-.1.778.778 0 01-.342-.52zm-2.313-2.765a.856.856 0 01.64-.976.774.774 0 01.957.621c.054.21.02.432-.094.616a.807.807 0 01-.506.362.861.861 0 01-.997-.623zm-8.36-15.453a.829.829 0 011.059-1.088c.31.117.52.405.538.734a.775.775 0 01-.62.957.807.807 0 01-.978-.602zm-9.647 11.911a.804.804 0 01.62-.957.802.802 0 01.978.602.828.828 0 01-1.062 1.089.832.832 0 01-.536-.734zm-3.778-17.226a.804.804 0 011.036-.935.808.808 0 01.293 1.366.808.808 0 01-1.33-.431zm13.708 14.213a.806.806 0 01.11-.608c.117-.179.3-.305.51-.348a.832.832 0 011.09 1.063.83.83 0 01-.734.536.81.81 0 01-.626-.11.808.808 0 01-.35-.533zm3.328-35.629a.774.774 0 01.62-.956.8.8 0 01.978.602.856.856 0 01-.622.997.832.832 0 01-.976-.643zM473.16 374.25a.776.776 0 01.62-.957.798.798 0 01.616.096.81.81 0 01.363.507.856.856 0 01-.622.995.832.832 0 01-.977-.64zm-15.94 12.253a.774.774 0 01.619-.957.805.805 0 01.978.603.857.857 0 01-.621.996.832.832 0 01-.977-.642zm16.63 11.753a.77.77 0 01.1-.613.766.766 0 01.52-.343.8.8 0 01.615.096.801.801 0 01.363.507.83.83 0 11-1.598.354zm7.616-29.328a.83.83 0 01.62-.957.83.83 0 11.357 1.6.832.832 0 01-.977-.643zm12.982 41.284a.773.773 0 01.62-.957.806.806 0 01.338 1.578.774.774 0 01-.958-.62zm-53.369-5.629a.803.803 0 01.601-.977.859.859 0 01.996.623.827.827 0 01-1.248.865.807.807 0 01-.349-.51zm2.653-25.572a.807.807 0 01.6-.977.861.861 0 01.998.624.829.829 0 01-.64.976.806.806 0 01-.958-.623zm3.795 58.712a.799.799 0 01.619-.956.803.803 0 01.978.602.856.856 0 01-.622.996.831.831 0 01-.975-.642zm-16.26-4.3a.856.856 0 01.64-.977.806.806 0 01.958.622.804.804 0 01-.6.977.861.861 0 01-.998-.623zm28.846 23.838a.806.806 0 111.577-.336.806.806 0 01-1.577.336zm-2.724-38.958a.772.772 0 01.62-.957.807.807 0 01.978.602.856.856 0 01-.622.996.833.833 0 01-.976-.64zm32.073 37.678a.812.812 0 01.11-.608c.117-.18.3-.305.51-.348a.803.803 0 01.978.602.833.833 0 01-.621.997.806.806 0 01-.977-.643zm19.343-1.187a.774.774 0 01.62-.957.807.807 0 01.978.602.857.857 0 01-.621.996.834.834 0 01-.977-.641zm-5.656-21.307a.857.857 0 01.622-.996.831.831 0 01.976.642.802.802 0 01-.62.956.803.803 0 01-.978-.602zm-2.216-18.266a.833.833 0 01.622-.997.887.887 0 01.976.642.828.828 0 01-.64.975.805.805 0 01-.958-.62zm-1.185-18.055a.798.798 0 01.6-.977.832.832 0 011.09 1.063.828.828 0 01-.733.536.806.806 0 01-.957-.622zm-14.2 3.095a.799.799 0 01.6-.977.806.806 0 01.977.642.812.812 0 01-.11.608.804.804 0 01-.51.348.774.774 0 01-.958-.621zm-2.14-21.063a.8.8 0 01.633-.927.804.804 0 01.342 1.569.807.807 0 01-.976-.643zm6.843-4.943a.773.773 0 01.62-.957.806.806 0 01.337 1.577.774.774 0 01-.958-.62zm1.986-11.167a.802.802 0 01.639-.976.804.804 0 01.958.622.829.829 0 01-1.06 1.088.834.834 0 01-.538-.734z"
})), /*#__PURE__*/React.createElement("g", {
  opacity: 0.81
}, /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M416.848 389.502l16.32 4.245-.022.057-16.32-4.243z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M426.66 360.624l.08.003 6.446 33.14-.059.018z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M426.66 360.624l.06.022-9.853 28.877-.04-.002z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M426.72 360.607l16.31 13.72-.04.038-16.31-13.72z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M429.314 335.053l.058.021-2.653 25.572-.058-.022z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M442.897 342.606l.038.04-16.216 18-.038-.04z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M429.373 335.036l13.563 7.572-.022.058-13.58-7.592z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M429.334 335.034l29.448-4.742-.002.04-29.428 4.761z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M458.763 330.273l.038.04-15.866 12.334-.038-.04z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M442.936 342.608l16.555 11.673-.02.058-16.576-11.694z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M442.936 342.608l13.244 23.81-.059.017-13.226-23.79z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M442.895 342.645l.04.002.094 31.719-.04-.001z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M426.702 360.586l29.44 5.83-.002.04-29.441-5.79z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M426.681 360.605l32.77-6.326.02.06-32.772 6.326z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M459.432 354.298l.058.022-3.261 12.394-.058-.023zm-26.246 39.469l12.587 19.538-.059.018-12.587-19.538z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M459.92 383.642l.019.02-26.774 10.163-.037-.08z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M442.99 374.325l.039.041-9.845 19.44-.076-.042z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M443.03 374.326l16.91 9.298-.022.058-16.91-9.297z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M456.123 366.396l.017.06-13.111 7.91-.038-.04z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M443.01 374.346l26.557-2.653.018.06-26.577 2.632z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M456.142 366.416l13.425 5.277-.021.058-13.406-5.296z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M456.121 366.435l.04.001 3.798 17.208-.06.017zm3.778 17.226l.06-.017 2.347 14.434-.08-.003z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M459.92 383.642l.019.02-14.186 29.662-.058-.021z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M462.247 398.056l.039.041-16.533 15.227-.038-.04zm7.582-17.407l.058.022-7.601 17.426-.039-.04z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M462.287 398.058l12.835 13.967-.059.018-12.817-13.947zm7.562-17.428v.04l-9.91 2.993-.02-.02z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M469.547 371.712l.04.001.302 8.919-.06.017z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M480.05 366.234l.017.059-10.482 5.46-.038-.041z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M469.586 371.713l8.38 15.472h-.04l-8.38-15.434zm.303 8.919l8.416 23.01-.058.018-8.418-23.011zM469.802 380.704l8.097 6.545-8.097-6.545z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M469.889 380.632l24.576 30.205-.06.019-24.556-30.187zm8.338 23.008l.058.021-3.164 8.403-.058-.02z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M478.287 403.623l16.16 7.194-.023.058-16.16-7.195z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M480.201 389.947l.058.023-1.974 13.691-.058-.021z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M477.966 387.185l2.274 2.764-.02.019-2.293-2.784z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M480.221 389.929l8.652-.533.017.06-8.65.532z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M480.24 389.95l14.225 20.887-.06.019-14.185-20.888zm6.275-18.688l.078.003 2.3 18.151h-.04z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M488.892 389.416l5.573 21.421-.06.019-5.552-21.44z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M480.107 366.256l8.785 23.16-.04.039-8.803-23.182z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M480.089 366.236l6.485 5.008-.04.038-6.485-5.009z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M485.329 353.208l.06-.017 1.204 18.074-.078-.003z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M475.91 330.298l10.664 40.946-.04.038-10.683-40.966zm1.927-11.149l.06-.017 7.492 34.059-.06.017z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M473.198 344.983l12.172 8.187-.022.059-12.172-8.189z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M467.126 324.972l18.263 28.219-.06.017-18.243-28.198zm10.731-5.842l.04.002-2.007 11.185-.058-.021z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M467.126 324.972l8.766 5.307-.022.057-8.784-5.326z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M475.832 330.296l.058.02-2.693 14.705h-.039zM469.124 335.353l4.148 9.76z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M473.158 345.02h.039l-2.01 11.304-.058-.022z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M442.936 342.608l30.262 2.375-.022.057-30.262-2.374zM458.656 330.295l8.113-5.068-8.113 5.068zM458.802 330.273l10.246 4.948-.021.058-10.247-4.947z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M458.821 330.294l12.367 25.99-.059.018-12.368-25.99zM468.944 335.312l6.841-4.977zM477.77 318.795l.059.021-8.764 16.465-.058-.023z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M469.027 335.24l.019.06-26.132 7.366-.017-.06zm2.122 21.043l14.2-3.094v.04l-14.182 3.114zM471.032 355.567l9.103 10.762z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M459.491 354.28l11.658 2.003v.04l-11.679-1.984z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#333",
  d: "M477.457 403.829a.775.775 0 01.62-.959.806.806 0 01.978.603.858.858 0 01-.621.997.86.86 0 01-.977-.643zm-16-5.565a.828.828 0 011.258-.891.828.828 0 01-.3 1.511.805.805 0 01-.957-.62zm17.975-8.129a.8.8 0 01.619-.947.805.805 0 01.95.617.8.8 0 01-.612.952.775.775 0 01-.957-.622zm-2.294-2.783a.828.828 0 01.62-.957.831.831 0 01.976.642.814.814 0 11-1.596.315zm-8.362-15.414a.828.828 0 01.64-.975.806.806 0 01.957.622.777.777 0 01-.62.957.804.804 0 01-.978-.603zm-9.647 11.91a.832.832 0 01.622-.995.832.832 0 01.337 1.619.808.808 0 01-.959-.623zm-3.797-17.246a.806.806 0 01.11-.608c.117-.179.3-.305.51-.348a.831.831 0 01.893 1.259.832.832 0 01-1.513-.303zm13.788 14.18a.803.803 0 01.601-.978.859.859 0 01.996.622.854.854 0 01-.64.976.808.808 0 01-.608-.11.807.807 0 01-.349-.51zm3.249-35.595a.806.806 0 01.11-.608c.117-.18.3-.305.51-.348a.801.801 0 01.978.602.833.833 0 01-.621.997.832.832 0 01-.977-.643zm-14.396-14.708a.804.804 0 01.62-.957.834.834 0 01.996.623.882.882 0 01-.64.975.832.832 0 01-.976-.64zm-15.866 12.334a.799.799 0 01.62-.956.798.798 0 01.615.096.8.8 0 01.363.506.857.857 0 01-.622.996.805.805 0 01-.976-.642zm16.556 11.673a.826.826 0 01.656-.896.833.833 0 01.96.562.804.804 0 01-.62.957.83.83 0 01-.996-.623zm7.619-29.446a.832.832 0 011.061-1.088c.309.117.52.404.537.734a.804.804 0 01-.64.976.806.806 0 01-.958-.622zm12.978 41.4a.812.812 0 01.11-.608c.117-.179.3-.305.509-.348a.806.806 0 01.979.602.856.856 0 01-.622.997.86.86 0 01-.976-.643zm-53.369-5.627a.773.773 0 01.62-.957.807.807 0 01.978.602.856.856 0 01-.621.996.859.859 0 01-.977-.641zm2.654-25.572a.774.774 0 01.62-.958.806.806 0 01.977.604.858.858 0 01-.621.996.86.86 0 01-.977-.642zm3.771 58.77a.796.796 0 01.095-.616.798.798 0 01.506-.362.86.86 0 01.997.623.857.857 0 01-.64.976.807.807 0 01-.608-.11.81.81 0 01-.35-.512zm-16.278-4.282a.826.826 0 01.621-.997.805.805 0 01.976.642.799.799 0 01-.619.956.798.798 0 01-.616-.096.8.8 0 01-.363-.506zm28.888 23.762a.804.804 0 01.619-.957.805.805 0 01.979.602.831.831 0 01-.622.997.806.806 0 01-.977-.643zm-2.726-38.96a.812.812 0 01.11-.608c.117-.179.3-.305.51-.347a.832.832 0 01.996.622.882.882 0 01-.639.976.833.833 0 01-.977-.642zm32.094 37.7a.799.799 0 01.6-.978.86.86 0 01.997.624.858.858 0 01-.64.976.806.806 0 01-.957-.622zm19.283-1.17a.809.809 0 01.11-.609c.117-.18.3-.305.509-.348a.832.832 0 011.09 1.063.83.83 0 01-.733.536.802.802 0 01-.976-.643zm-5.515-21.44a.83.83 0 01.64-.975.805.805 0 01.767.25.805.805 0 01-.429 1.329.805.805 0 01-.978-.603zm-2.316-18.171a.802.802 0 01.64-.976.8.8 0 01.957.621.83.83 0 11-1.597.355zm-1.167-18.034a.827.827 0 011.257-.891.83.83 0 01-.3 1.513.81.81 0 01-.608-.11.81.81 0 01-.35-.512zm-14.22 3.075a.805.805 0 111.577-.336.804.804 0 01-.62.956.774.774 0 01-.958-.62zm-2.122-21.044a.8.8 0 01.602-.977.86.86 0 01.996.623.855.855 0 01-.64.975.774.774 0 01-.958-.62zm6.866-5.001a.81.81 0 01.11-.61.806.806 0 01.51-.347.805.805 0 01.978.602.857.857 0 01-.621.997.86.86 0 01-.977-.642zm1.946-11.13a.856.856 0 01.64-.975.81.81 0 01.608.11.81.81 0 01.35.512.802.802 0 01-.601.977.86.86 0 01-.997-.623z"
})), /*#__PURE__*/React.createElement("g", {
  opacity: 0.12
}, /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M371.02 433.753l16.319 4.245-.021.058-16.3-4.263z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M380.833 404.875l.06-.017 6.465 33.16-.06.018z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M380.853 404.856l.058.022-9.872 28.896-.059-.022z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M380.892 404.858l16.31 13.72-.04.037-16.31-13.72z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M383.506 379.285l.058.021-2.653 25.572-.078-.003z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M397.069 386.857l.037.04-16.215 18-.038-.04z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M383.545 379.286l13.563 7.572-.041.038-13.563-7.571z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M383.526 379.266l29.408-4.742.018.058-29.409 4.743z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M412.934 374.524l.038.04-15.866 12.334-.037-.04z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M397.108 386.858l16.555 11.674-.04.037-16.556-11.673z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M397.108 386.858l13.226 23.79-.041.038-13.226-23.79z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M397.048 386.876l.079.002.094 31.72-.06.017z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M380.873 404.837l29.46 5.811-.021.059-29.46-5.812z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M380.873 404.837l32.77-6.326.019.06-32.771 6.326z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M413.624 398.53l.058.022-3.3 12.391-.04-.001zm-26.285 39.468l12.587 19.538-.04.038-12.588-19.538z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M414.093 427.854l.017.06-26.772 10.123-.038-.041z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M397.162 418.576l.038.04-9.862 19.42-.038-.04z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M397.201 418.577l16.91 9.297-.021.059-16.91-9.298z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M410.294 410.647l.038.04-13.132 7.93-.038-.041z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M397.182 418.557l26.556-2.613v.039l-26.538 2.634z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M410.334 410.648l13.404 5.296v.039l-13.426-5.276z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M410.293 410.686l.06-.017 3.778 17.226-.06.017zm3.778 17.226l.06-.017 2.327 14.413-.059.018z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M414.073 427.873l.058.022-14.207 29.68-.057-.022z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M416.419 442.307l.038.041-16.533 15.227-.037-.04zm7.584-17.446l.037.04-7.563 17.428-.058-.022z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M416.458 442.308l12.818 13.948-.041.038-12.817-13.948zm7.545-17.447l.017.06-9.91 2.993-.017-.06z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M423.719 415.962l.038.002.303 8.919-.06.017z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M434.222 410.485l.038.04-10.503 5.478-.019-.06z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M423.757 415.964l8.401 15.453-.06.018-8.4-15.454zm.303 8.919l8.399 22.99-.06.018L424 424.9zM423.993 424.96l8.097 6.547-8.097-6.547z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M424.06 424.883l24.558 30.185-.04.038-24.577-30.206zm8.36 22.989l.057.02-3.203 8.403h-.04z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M432.44 447.853l16.178 7.215-.022.058-16.178-7.215z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M434.373 434.198l.04.001-1.936 13.694-.078-.002z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M432.14 431.397l2.292 2.784-.04.038-2.294-2.784z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M434.393 434.179l8.651-.532.017.06-8.67.512z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M434.432 434.181l14.186 20.887-.04.038-14.186-20.887zm6.275-18.688l.04.002 2.316 18.172-.04-.001z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M443.084 433.648l5.553 21.44-.059.018-5.554-21.44zM434.28 410.506l8.804 23.142-.06.018-8.803-23.142z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M434.261 410.486l6.485 5.009-.04.037-6.485-5.008z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M439.501 397.459l.06-.017 1.185 18.053-.04-.002z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M430.083 374.55l10.663 40.945-.06.017-10.682-40.966zm1.926-11.15l.06-.018 7.491 34.06-.059.017z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M427.37 389.233l12.171 8.188-.02.058-12.192-8.208z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M421.298 369.223l18.262 28.219-.059.017-18.262-28.218zm10.712-5.862l.058.021-1.985 11.167-.079-.003z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M421.28 369.203l8.784 5.326-.04.037-8.767-5.305z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M430.004 374.546l.079.003-2.694 14.704-.079-.002z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M423.238 379.492l4.15 9.76-.059.02-4.15-9.762z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M427.31 389.25l.079.003-2.05 11.301-.039-.001z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M397.09 386.838l30.261 2.374-.003.079-30.262-2.374zm23.854-17.55l.038.041-8.01 5.235-.038-.04z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M412.973 374.524l10.247 4.949-.022.057-10.246-4.948z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M412.973 374.524l12.387 26.012-.06.017-12.367-25.991zm17.051.003l.038.041-6.844 4.943-.037-.04z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M431.924 363.025l.077.041-8.783 16.445-.037-.04zm-8.743 16.445l.017.06-26.112 7.387-.017-.06zm2.14 21.064l14.22-3.113v.039l-14.222 3.113z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M425.172 399.726l9.09 10.76-.041.038-9.09-10.76zm-11.51-1.194l11.679 1.983-.022.058-11.678-1.983z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#333",
  d: "M431.704 448.16a.804.804 0 01.64-.977.806.806 0 01.958.623.777.777 0 01-.62.956.805.805 0 01-.978-.603zm-16.075-5.647a.829.829 0 01.64-.975.806.806 0 01.958.623.772.772 0 01-.62.955.807.807 0 01-.978-.602zm17.974-8.127a.803.803 0 01.6-.977.859.859 0 01.998.623.856.856 0 01-.64.976.806.806 0 01-.958-.622zm-2.293-2.783a.804.804 0 01.62-.957.807.807 0 01.978.602.856.856 0 01-.622.996.859.859 0 01-.976-.641zm-8.361-15.452a.807.807 0 111.576-.335.807.807 0 01-1.576.335zm-9.667 11.93a.857.857 0 01.64-.977.777.777 0 01.958.622c.053.21.02.431-.095.615a.807.807 0 01-.506.363.862.862 0 01-.997-.624zm-3.778-17.228a.812.812 0 01.11-.608c.117-.18.3-.305.51-.348a.807.807 0 01.978.602.857.857 0 01-.621.996.86.86 0 01-.977-.642zm13.708 14.214a.83.83 0 111.617-.333.812.812 0 01-.11.608.803.803 0 01-.51.348.832.832 0 01-.996-.622zm3.328-35.629a.83.83 0 01.64-.976.805.805 0 01.958.622.828.828 0 01-1.06 1.089.834.834 0 01-.538-.735zm-14.395-14.709a.8.8 0 01.64-.975.81.81 0 01.608.11c.18.118.305.301.35.512a.827.827 0 01-1.061 1.088.83.83 0 01-.537-.735zm-15.867 12.335a.83.83 0 01.64-.976.806.806 0 01.958.622.83.83 0 11-1.598.354zm16.556 11.673a.856.856 0 01.64-.976.774.774 0 01.957.621.798.798 0 01-.6.978.86.86 0 01-.997-.623zm7.635-29.309a.858.858 0 01.621-.996.832.832 0 01.977.643.806.806 0 01-.11.608.804.804 0 01-.51.348.806.806 0 01-.978-.603zm12.962 41.263a.8.8 0 01.641-.975.803.803 0 01.957.621.799.799 0 01-.6.977.86.86 0 01-.998-.623zm-53.368-5.628a.854.854 0 01.621-.996.859.859 0 01.976.642.77.77 0 01-.62.956.807.807 0 01-.978-.602zm2.652-25.571a.83.83 0 01.64-.976.806.806 0 01.958.622.773.773 0 01-.62.957.805.805 0 01-.978-.603zm3.835 58.673a.83.83 0 01.64-.975.803.803 0 01.958.621.799.799 0 01-.601.978.86.86 0 01-.997-.624zm-16.34-4.225a.804.804 0 01.62-.957.774.774 0 01.958.62.805.805 0 11-1.577.337zm28.887 23.8a.806.806 0 01.11-.608c.117-.179.3-.304.51-.348a.801.801 0 01.978.603.858.858 0 01-.621.996.86.86 0 01-.977-.642zm-2.724-38.957a.827.827 0 011.248-.865c.18.117.305.3.35.51a.803.803 0 01-.602.977.83.83 0 01-.996-.622zm32.073 37.678a.83.83 0 011.267-.866.828.828 0 01-.29 1.508.834.834 0 01-.977-.642zm19.383-1.226a.809.809 0 01.11-.608c.117-.179.3-.305.51-.348a.806.806 0 01.978.603.829.829 0 11-1.598.353zm-5.575-21.381a.802.802 0 01.6-.978.86.86 0 01.998.624.828.828 0 01-.64.975.774.774 0 01-.958-.621zm-2.337-18.153a.856.856 0 01.621-.997.859.859 0 01.976.642.77.77 0 01-.62.956.803.803 0 01-.978-.602zm-1.186-18.055a.856.856 0 01.621-.995.832.832 0 01.977.641.804.804 0 01-.62.957.802.802 0 01-.979-.602zm-14.2 3.094a.804.804 0 01.6-.976.86.86 0 01.998.623.856.856 0 01-.641.975.803.803 0 01-.957-.621zm-2.14-21.063a.806.806 0 01.11-.608c.116-.18.3-.305.509-.348a.83.83 0 01.997.622.827.827 0 01-.657.897.831.831 0 01-.96-.563zm6.843-4.944a.803.803 0 01.64-.974.803.803 0 01.958.621.83.83 0 11-1.598.354zm1.986-11.165a.83.83 0 01.64-.976.775.775 0 01.958.622c.053.21.019.43-.095.615a.798.798 0 01-.506.362.86.86 0 01-.997-.623z"
})), /*#__PURE__*/React.createElement("g", {
  opacity: 0.3
}, /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M451.57 338.003l-20.386-18.173.061-.057 20.387 18.134z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M416.143 372.328l-.098-.023 15.12-52.495.079.003z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M416.122 372.347l-.056-.061 35.507-34.361.057.06z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M416.044 372.343l-13.422-31.822.098-.017 13.423 31.785z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M393.439 407.205l-.057-.06 22.684-34.859.056.06zM379.37 386.315l36.66-13.99-36.66 13.99z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M393.38 407.223l-13.989-20.92.06-.056 13.99 20.92z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M393.399 407.243l-45.948-14.858.002-.078 45.969 14.839z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M347.45 392.385l-.016-.099 31.999-6.06.016.099z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M379.391 386.304l-15.299-29.014.081-.075 15.297 29.052z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M379.393 386.264l-1.554-44.027.097.024 1.534 44.006z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M379.49 386.287l-.097-.023 23.23-45.783.097.062z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M416.063 372.364l-38.206-30.067.062-.096 38.205 30.067z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M416.083 372.345l-51.972-15.034.023-.097 51.952 15.053z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M364.171 357.293l-.056-.06 13.856-15.421.057.06zm66.995-37.483l-3.756-37.43.078.004 3.756 37.429z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M385.1 314.717l.023-.097 46.083 5.153-.003.077z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M402.7 340.562l-.056-.1 28.523-20.69.075.08z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M402.64 340.54l-17.578-25.863.08-.037 17.56 25.844z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M377.896 342.299l-.017-.1 24.784-1.716-.003.078z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M402.66 340.561l-40.278-15.79.042-.078 40.259 15.771z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M377.837 342.277l-15.455-17.507.06-.056L377.92 342.2z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M377.936 342.261l-.097-.024 7.225-27.6.096.023z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M385.16 314.66l-.096-.023 7.265-22.488.097.023z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M385.14 314.68l-.057-.061 42.347-32.257.056.06z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M392.386 292.21l-.016-.099 35.08-9.768.016.098z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M368.602 311.7l-.057-.06 23.805-19.51.056.06z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M392.309 292.168l-8.213-29.563.099-.016 8.212 29.562zm-23.746 19.53l.003-.078 16.557 3-.023.097z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M362.44 324.752l-.076-.042 6.162-13.052.097.023z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M343.232 324.907l.002-.078 19.17-.156.017.098z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M362.383 324.73l-.714-28.452.097.024.695 28.431zm6.143-13.072l4.804-39.316.097.023-4.804 39.316zM361.76 296.376l6.85 15.377z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M368.524 311.696l-13.209-61.632.1-.015 13.188 61.611zm4.903-39.33l-.057-.062 10.747-9.757.076.081z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M373.349 272.362l-18.015-22.277.081-.076 18.013 22.317zM373.428 272.424l-12.921 18.29zM361.688 296.299l-1.275-5.664.098-.016 1.236 5.663z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M360.432 290.655l-12.866-5.609.041-.077 12.866 5.61z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M360.433 290.616l-5.118-40.552.1-.015 5.096 40.57zm-22.821 22.266l-.097-.023 10.032-27.872.098.022z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M347.547 284.987l7.789-34.942.097.023-7.788 34.941z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M343.194 324.866l4.353-39.88.098.023-4.373 39.86z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M343.194 324.866l-5.681-11.969.08-.036 5.68 11.97zM337.606 312.946l-11.595 26.891z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M322.766 379.736l14.749-66.877.097.023-14.769 66.856zm-11.031 14.641l-.097-.023 14.291-54.6.097.024z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M337.474 360.567l-11.546-20.773.1-.056 11.526 20.793z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M331.485 393.87l-5.556-54.116.097.024 5.558 54.075zm-19.77.526l-.057-.061 11.089-14.62.077.042z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M331.484 393.909l-8.739-14.154.08-.036 8.74 14.114z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M322.824 379.757l-.077-.042 14.75-19.206.056.06z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M336.267 377.635l1.21-17.107.096.023-1.21 17.107z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M337.553 360.57l-.056-.06 11.229-14.752.078.042z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M379.41 386.323l-41.917-25.735.042-.077 41.917 25.736zm-47.383 7.723l.002-.079 15.405-1.68.017.098z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M347.412 392.384l-11.147-14.71.1-.056 11.128 14.69z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M347.413 392.344l1.313-46.586.08.003-1.315 46.586zM322.721 379.824l13.531-2.092zM311.579 394.939l-.075-.08 24.783-17.243.057.06z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M336.304 377.675l.003-.078 43.126 8.63-.023.096zm12.44-31.858l-22.777-6.022.022-.058 22.778 5.983z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M348.388 347.057l-5.194-22.19.099-.016 5.194 22.19zM348.727 345.824l15.37 11.49-15.37-11.49z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#333",
  d: "M374.669 272.684a1.328 1.328 0 11-2.612-.48 1.328 1.328 0 012.612.48zm18.979 19.824a1.33 1.33 0 01-2.56-.678 1.3 1.3 0 011.618-.941c.705.19 1.125.913.942 1.62zm-31.915-1.551a1.298 1.298 0 01-1.59.897 1.299 1.299 0 01.647-2.517 1.33 1.33 0 01.942 1.62zm1.255 5.683a1.329 1.329 0 11-.943-1.62 1.33 1.33 0 01.943 1.62zm.695 28.432a1.326 1.326 0 01-2.265.675 1.326 1.326 0 011.297-2.2 1.33 1.33 0 01.968 1.524zm22.7-10.075a1.326 1.326 0 01-2.265.677 1.328 1.328 0 112.265-.677zm-7.224 27.601a1.327 1.327 0 01-2.433.331 1.326 1.326 0 011.489-1.95c.705.19 1.127.912.944 1.619zm-9.314-30.58a1.327 1.327 0 01-2.433.33 1.326 1.326 0 011.489-1.95c.706.19 1.127.913.944 1.62zm-31.05 48.87a1.325 1.325 0 01-1.618.94 1.305 1.305 0 01-.943-1.618 1.327 1.327 0 011.593-.847 1.33 1.33 0 01.968 1.525zm9.919 31.797a1.301 1.301 0 01-1.619.94 1.332 1.332 0 01-.98-1.106 1.324 1.324 0 012.12-1.233c.428.327.617.88.479 1.399zm31.998-6.06a1.326 1.326 0 01-2.266.676 1.33 1.33 0 01-.295-1.355 1.3 1.3 0 011.618-.941c.705.189 1.126.913.943 1.62zm-15.299-29.013a1.328 1.328 0 11-2.56-.68 1.293 1.293 0 011.616-.94c.706.19 1.127.913.944 1.62zm-32.61 36.619a1.326 1.326 0 01-1.592.845 1.33 1.33 0 01-.968-1.526 1.326 1.326 0 011.593-.845 1.33 1.33 0 01.967 1.525zm11.69-69.023a1.297 1.297 0 01-1.617.94 1.331 1.331 0 01-.68-2.267c.36-.345.883-.458 1.354-.293.344.083.638.303.815.61.179.305.225.67.129 1.01zm72.871 47.457c-.135.52-.571.907-1.104.98a1.33 1.33 0 01-1.237-2.124 1.33 1.33 0 012.342 1.144zm-22.682 34.858a1.327 1.327 0 01-1.6.962 1.3 1.3 0 01-.942-1.62 1.297 1.297 0 011.617-.94 1.303 1.303 0 01.925 1.598zm37.784-87.373a1.3 1.3 0 01-1.599.962 1.33 1.33 0 01-.943-1.62 1.31 1.31 0 011.597-.941c.703.181 1.125.898.945 1.599zm20.406 18.154a1.297 1.297 0 01-1.618.94 1.332 1.332 0 01-.981-1.106 1.326 1.326 0 012.121-1.233c.428.326.616.88.478 1.4zm-24.143-55.563a1.328 1.328 0 11-2.57-.672 1.328 1.328 0 012.57.672zm-24.788 58.14a1.328 1.328 0 11-2.56-.679 1.294 1.294 0 011.597-.96c.714.193 1.143.922.963 1.639zm-18.506-77.933a1.327 1.327 0 01-1.593.845 1.332 1.332 0 01-.968-1.525 1.295 1.295 0 011.618-.94 1.33 1.33 0 01.943 1.619zm-28.78-12.542a1.327 1.327 0 01-1.593.846 1.33 1.33 0 01-.968-1.525 1.295 1.295 0 011.618-.94 1.33 1.33 0 01.943 1.618zm-7.789 34.94a1.297 1.297 0 01-1.618.941 1.332 1.332 0 01-.98-1.105 1.324 1.324 0 01.646-1.328 1.331 1.331 0 011.953 1.494zm-10.032 27.873a1.328 1.328 0 11-2.561-.679 1.327 1.327 0 011.592-.847 1.33 1.33 0 01.969 1.526zm-11.586 26.896a1.328 1.328 0 11-2.568-.674 1.328 1.328 0 012.568.674zm22.697 6.098a1.327 1.327 0 01-1.619.94 1.331 1.331 0 01-.68-2.267c.36-.344.884-.457 1.355-.292a1.33 1.33 0 01.944 1.619zm-12.36 31.782c-.135.52-.57.907-1.104.98a1.33 1.33 0 01-1.236-2.124 1.325 1.325 0 011.397-.475c.706.19 1.128.913.944 1.619zm-13.52 2.08a1.298 1.298 0 01-1.59.9 1.303 1.303 0 01-.92-1.581 1.298 1.298 0 011.567-.937 1.33 1.33 0 01.944 1.619zm-11.108 14.64a1.327 1.327 0 01-2.433.33 1.326 1.326 0 011.489-1.95 1.33 1.33 0 01.944 1.62z"
})), /*#__PURE__*/React.createElement("g", {
  opacity: 0.87
}, /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M335.4 446.711l11 28.174-.118.036-10.961-28.173z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M387.684 430.746l.096.063-41.4 44.134-.076-.081z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M387.723 430.747l.037.08-52.382 15.943-.036-.08zM387.787 430.842l-2.779 38.107z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M427.677 407.802l.055.1-39.972 22.926-.056-.1z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M430.982 435.466l-.023.098-43.239-4.738.023-.097z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M427.753 407.845l3.267 27.662-.099.016-3.266-27.662z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M427.755 407.806l37.883 37.827-.08.075-37.884-37.827zM430.964 435.532l34.63 10.174-34.63-10.174zM431.02 435.507l.465 36.332-.097-.022-.467-36.294z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M431.019 435.546l-20.67 44.152-.096-.063 20.67-44.15z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M430.944 435.465l.054.1-46.005 33.359-.076-.081z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M387.78 430.77l22.57 48.89-.099.054-22.55-48.908z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M387.762 430.75l43.706 41.03-.062.096-43.705-41.07z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M431.429 471.779l.036.08-21.481 8.217-.016-.098zm-85.03 3.146l-15.18 38.768-.077-.042 15.142-38.77z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M389.267 503.18l-.041.078L346.3 474.94l.08-.075zM346.351 475.208l38.53-6.549-38.53 6.549z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M385.014 468.866l4.292 34.356-.1.015-4.31-34.336z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M410.312 479.618l-.042.116-25.336-10.793.043-.115z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M384.996 468.846l31.783 35.866-.081.076-31.783-35.867z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M410.35 479.66l6.448 25.073-.119.035-6.427-25.093z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M410.253 479.635l.076.081-21.045 23.563-.076-.081zm-21.045 23.563l.076.081-18.504 18.505-.076-.081z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M389.229 503.179l.016.1-58.067 10.452-.016-.098z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M370.744 521.704l-.023.097-39.562-8.09.023-.097z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M404.055 514.457l.035.12-33.33 7.225-.035-.119zM370.785 521.824l-6.798 33.282z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M404.113 514.48l-.081.075-14.826-11.279.061-.095z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M416.701 504.71l.076.08-12.667 9.767-.075-.081zM416.692 504.73l18.922 9.7z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M416.797 504.773l-13.672 28.387-.096-.062 13.652-28.37zm-12.687 9.784l-24.572 36.318-.095-.061 24.592-36.338zM404.119 514.575l-.993 18.623z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M404.112 514.519l-18.037 67.405-.116-.043 18.055-67.386zm-24.649 36.276l.036.08-15.55 4.2-.016-.098z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M379.54 550.837l6.537 31.049-.1.015-6.537-31.048z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M401.446 539.306l.036.08-21.964 11.508-.055-.1z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M403.145 533.141l-1.642 6.225-.097-.023 1.641-6.226z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M401.505 539.327l9.868 12.002-.08.075-9.888-12.021z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M401.503 539.366l-15.428 42.558-.095-.062 15.426-42.519zm33.753-10.422l.056.06-23.941 22.403-.076-.081z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M411.37 551.407l-25.295 30.517-.095-.062 25.315-30.536z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M435.793 514.32l-24.422 37.087-.096-.062 24.422-37.087z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M435.774 514.3l-.422 14.667-.117-.004.46-14.666z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M460.274 508.266l.037.079-24.999 20.66-.037-.08z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M483.621 470.552l-48.29 58.434-.075-.042 48.29-58.473zm18.254-8.881l.096.063-41.64 46.592-.077-.042z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M459.426 482.02l.925 26.287-.117-.004-.926-26.287z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M482.132 452.214l-21.802 56.112-.076-.042 21.783-56.133zM483.53 470.515l18.351-8.793zM482.163 452.227l1.502 18.315z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M483.566 470.453l.035.118-24.216 11.487-.016-.098z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M469.239 465.79l-9.834 16.25-.077-.042 9.814-16.27z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M459.37 481.96l.015.098-18.548 8.891-.055-.1z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M431 435.487l28.427 46.495-.1.055-28.387-46.493zm50.678 16.28l-.042.076-16.04-6.133.023-.097z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M465.657 445.654l3.582 20.097-.097.015-3.584-20.096z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M465.656 445.692l-24.798 45.238-.096-.062 24.798-45.237zm17.949 24.762l-.023.097-14.403-4.744.023-.097zM469.098 465.759l33.155-4.368z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M469.22 465.73l-.06.057-38.22-30.243.06-.057zm-28.36 25.121l19.453 17.415-.042.077-19.492-17.416z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M441.855 489.81l-6.062 24.51-.117-.043 6.081-24.49zm-10.369-18.01l9.393 19.072-.1.055-9.392-19.071z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#333",
  d: "M378.379 549.875a1.493 1.493 0 012.078-.122 1.466 1.466 0 01-1.949 2.189 1.466 1.466 0 01-.13-2.067zm-8.739-29.111a1.439 1.439 0 012.06-.103c.597.547.652 1.468.124 2.08a1.475 1.475 0 01-2.184-1.977zm30.722 17.622a1.494 1.494 0 012.08-.121c.602.546.65 1.477.105 2.079a1.472 1.472 0 01-2.08.101 1.439 1.439 0 01-.106-2.06zm1.602-6.228a1.494 1.494 0 012.08-.12 1.467 1.467 0 01.125 2.08 1.494 1.494 0 01-2.08.12 1.495 1.495 0 01-.125-2.08zm13.672-28.386a1.466 1.466 0 012.06-.103c.597.546.653 1.468.124 2.08a1.467 1.467 0 01-2.06.102 1.495 1.495 0 01-.124-2.08zm-27.492-1.513a1.466 1.466 0 012.067-.114 1.466 1.466 0 01-1.942 2.194 1.494 1.494 0 01-.125-2.08zm21.065-23.58a1.465 1.465 0 012.067-.115 1.466 1.466 0 01-1.942 2.194 1.496 1.496 0 01-.125-2.08zm-6.239 34.859a1.466 1.466 0 012.06-.102c.597.545.653 1.467.125 2.08a1.441 1.441 0 01-2.06.101 1.496 1.496 0 01-.125-2.08zm55.315-32.498a1.47 1.47 0 012.559.905 1.464 1.464 0 01-2.453 1.155 1.412 1.412 0 01-.106-2.06zm6.19-36.33a1.466 1.466 0 012.068-.113 1.466 1.466 0 01-1.943 2.194 1.496 1.496 0 01-.125-2.08zm-34.522-10.064a1.494 1.494 0 012.079-.12 1.466 1.466 0 01-1.95 2.188 1.467 1.467 0 01-.129-2.067zm.39 36.214c.257-.292.62-.468 1.008-.487.387-.019.767.119 1.052.383a1.41 1.41 0 01.125 2.04 1.468 1.468 0 11-2.184-1.938zm50.742-19.525a1.466 1.466 0 112.185 1.937 1.494 1.494 0 01-2.08.122 1.467 1.467 0 01-.105-2.059zm-46.452 61.984a1.473 1.473 0 012.08-.12 1.472 1.472 0 11-1.955 2.2 1.473 1.473 0 01-.125-2.08zm-47.995-83.491c.247-.589.846-.95 1.482-.892a1.47 1.47 0 011.302 1.144 1.465 1.465 0 01-.693 1.585 1.493 1.493 0 01-2.079.12 1.465 1.465 0 01-.012-1.957zm39.955-22.945a1.471 1.471 0 012.08-.12 1.47 1.47 0 11-1.955 2.2 1.472 1.472 0 01-.125-2.08zm-81.353 67.04a1.465 1.465 0 012.058-.102c.598.546.654 1.468.125 2.08a1.467 1.467 0 01-2.06.102 1.495 1.495 0 01-.124-2.079zm-10.983-28.153a1.469 1.469 0 112.091 1.836 1.495 1.495 0 01-2.08.122 1.468 1.468 0 01-.011-1.958zm-4.217 66.902a1.466 1.466 0 012.558.905 1.464 1.464 0 01-2.452 1.154 1.468 1.468 0 01-.107-2.06zm53.813-44.768a1.472 1.472 0 012.184 1.977 1.44 1.44 0 01-2.059.103 1.494 1.494 0 01-.125-2.08zm-21.023 86.133a1.43 1.43 0 011.006-.487c.389-.019.767.119 1.053.384a1.413 1.413 0 01.105 2.059c-.54.593-1.46.639-2.058.103a1.442 1.442 0 01-.106-2.06zm22.085 26.886a1.467 1.467 0 012.191 1.954 1.465 1.465 0 01-2.065.126 1.495 1.495 0 01-.126-2.08zm25.316-30.536a1.473 1.473 0 012.183 1.977 1.438 1.438 0 01-2.058.102 1.466 1.466 0 01-.125-2.079zm23.96-22.38a1.493 1.493 0 012.08-.122c.592.542.64 1.46.106 2.06a1.495 1.495 0 01-2.08.12 1.467 1.467 0 01-.106-2.059zm24.998-20.662a1.495 1.495 0 012.08-.12c.593.541.64 1.46.106 2.058a1.494 1.494 0 01-2.08.121 1.468 1.468 0 01-.106-2.059zm-19.471-17.434a1.41 1.41 0 012.059-.103 1.466 1.466 0 01-.902 2.545 1.443 1.443 0 01-1.052-.383 1.416 1.416 0 01-.5-1.008c-.02-.39.123-.77.395-1.051zm28.36-25.122a1.467 1.467 0 012.19 1.954c-.533.603-1.458.66-2.065.125a1.494 1.494 0 01-.125-2.08zm14.422 4.764c.249-.296.608-.476.993-.5.386-.023.765.114 1.048.377a1.465 1.465 0 11-2.278 1.743 1.465 1.465 0 01.237-1.62zm18.33-8.8a1.47 1.47 0 012.559.905 1.465 1.465 0 01-2.453 1.154 1.466 1.466 0 01-.105-2.06z"
})), /*#__PURE__*/React.createElement("g", {
  opacity: 0.71
}, /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M237.987 332.438l10.981 28.193-.08.036-11-28.173z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M290.29 316.494l.057.06-41.38 44.117-.096-.063z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M290.31 316.476l.017.098-52.381 15.941-.017-.098z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M290.367 316.536l-2.767 38.097-.116-.005 2.786-38.115z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M330.264 293.53l.056.1-39.973 22.925-.056-.06zM290.269 316.56l43.24 4.756-43.24-4.756z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M330.341 293.572l3.247 27.68-.1.017-3.245-27.68z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M330.323 293.552l37.902 37.808-.08.076-37.904-37.808zM333.5 321.32l34.641 10.14-34.641-10.14zM333.588 321.253l.484 36.314-.097.016-.466-36.333zM333.596 321.321l-20.67 44.152z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M333.51 321.211l.076.081-46.026 33.378-.055-.1z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M290.368 316.497l22.55 48.908-.08.036-22.57-48.89z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M290.35 316.476l43.724 41.052-.08.075-43.706-41.031z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M333.996 357.525l.036.08-21.442 8.219-.055-.1zm-85.03 3.146l-15.16 38.75-.097-.024 15.162-38.789z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M291.874 388.928l-.061.096-42.906-28.336.042-.077zM248.847 360.731l38.617-6.022z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M287.6 354.633l4.273 34.334-.098.016-4.291-34.355z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M312.899 365.385l-.042.077-25.336-10.794.042-.076z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M287.563 354.592l31.783 35.867-.06.056-31.783-35.867zM312.964 365.455l6.438 25.07z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M312.86 365.383l.056.06-21.045 23.563-.075-.08zm-21.064 23.543l.075.08-18.523 18.523-.076-.08z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M291.817 388.907l.015.098-58.066 10.453-.017-.098z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M273.331 407.431l-.022.098-39.543-8.071-.017-.098z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M306.641 400.223l.037.08-33.35 7.245-.036-.118zM273.378 407.538l-6.798 33.28z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M306.68 400.225l-.041.078-14.845-11.3.08-.075z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M319.288 390.438l.056.1-12.666 9.765-.055-.1zM319.154 390.777l19.217 9.1z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M319.364 390.519l-13.652 28.369-.097-.024 13.653-28.408zm-12.666 9.765l-24.593 36.337-.075-.08 24.573-36.318zM306.73 400.308l-.994 18.621z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M306.698 400.284l-18.034 67.368-.098-.023 18.055-67.387zm-24.648 36.238l.016.099-15.53 4.182-.036-.08z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M282.127 436.564l6.537 31.049-.118.034-6.538-31.048z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M304.013 425.052l.038.08-21.966 11.508-.055-.1z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M305.712 418.888l-1.62 6.206-.098-.024 1.62-6.206z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M304.093 425.055l9.848 12.02-.08.076-9.869-12.041z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M304.091 425.094l-15.427 42.558-.117-.043 15.447-42.539zm33.751-10.422l.058.061-23.962 22.42-.057-.06z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M313.958 437.134l-25.315 30.537-.076-.082 25.314-30.496zM338.407 400.069l-24.409 37.092zM338.362 400.028l-.442 14.686-.097-.024.44-14.647z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M362.84 394.012l.077.08-25.017 20.641-.058-.061z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M386.208 356.28L337.9 414.733l-.058-.061 48.29-58.435zm18.274-8.862l.057.061-41.622 46.614-.076-.081z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M362.014 367.748l.904 26.305-.098.017-.923-26.326z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M384.72 337.941l-21.802 56.112-.097-.023 21.802-56.112zm19.782 9.459l.016.098-18.33 8.8-.036-.079z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M384.74 337.922l1.489 18.339-.118-.005-1.488-18.338z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M386.152 356.219l.036.08-24.215 11.487-.036-.08z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M371.806 351.536l-9.813 16.231-.077-.041 9.814-16.271z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M361.937 367.706l.036.08-18.548 8.89-.037-.079z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M333.588 321.214l28.407 46.514-.08.036-28.407-46.475zm50.677 16.28l-.062.096-16.039-6.134.043-.115z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M368.225 331.4l3.602 20.078-.118.035-3.582-20.097z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M368.223 331.439l-24.778 45.219-.077-.043 24.76-45.238zm17.968 24.781l-.041.077-14.404-4.744.043-.115z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M404.91 346.944l.015.1-33.14 4.51-.015-.098z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M371.808 351.458l-.08.075-38.22-30.244.08-.075zm-28.38 25.14l19.491 17.416-.08.075-19.473-17.396z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M344.422 375.556l-6.042 24.492-.116-.044 6.06-24.47zm-10.369-18.01l9.393 19.072-.079.037-9.392-19.072z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#333",
  d: "M280.966 435.602a1.467 1.467 0 012.19 1.953c-.534.604-1.459.66-2.065.127a1.495 1.495 0 01-.125-2.08zm-8.758-29.092a1.494 1.494 0 012.08-.121 1.466 1.466 0 01-1.95 2.188 1.466 1.466 0 01-.13-2.066zm30.741 17.603a1.466 1.466 0 012.06-.102c.597.546.652 1.468.125 2.08a1.472 1.472 0 01-2.493-.539c-.16-.5-.043-1.05.308-1.439zm1.622-6.207a1.47 1.47 0 012.091 1.838 1.463 1.463 0 01-2.08.12 1.438 1.438 0 01-.011-1.958zm13.633-28.389a1.474 1.474 0 012.204 1.958 1.492 1.492 0 01-2.08.121 1.493 1.493 0 01-.124-2.079zm-27.533-1.474a1.467 1.467 0 012.06-.102c.596.546.652 1.467.124 2.08a1.438 1.438 0 01-2.06.102 1.465 1.465 0 01-.125-2.08zm21.104-23.58c.247-.589.846-.95 1.482-.892a1.469 1.469 0 01.609 2.73 1.493 1.493 0 01-2.08.12 1.465 1.465 0 01-.01-1.958zm-6.275 34.78a1.466 1.466 0 012.06-.142c.395.35.572.884.466 1.399a1.468 1.468 0 01-2.42.802 1.466 1.466 0 01-.106-2.059zm55.352-32.457a1.494 1.494 0 012.08-.12 1.47 1.47 0 11-1.955 2.2 1.495 1.495 0 01-.125-2.08zm6.25-36.347a1.465 1.465 0 012.06-.101c.596.545.652 1.466.124 2.08a1.437 1.437 0 01-2.06.1 1.467 1.467 0 01-.124-2.079zm-34.656-10.166a1.465 1.465 0 012.059-.102c.598.545.653 1.466.125 2.08a1.44 1.44 0 01-2.058.102 1.495 1.495 0 01-.126-2.081zm.465 36.332a1.469 1.469 0 012.079-.121 1.439 1.439 0 01.106 2.06 1.405 1.405 0 01-.993.498 1.416 1.416 0 01-1.048-.376 1.437 1.437 0 01-.144-2.06zm50.667-19.645a1.44 1.44 0 012.06-.102 1.411 1.411 0 01.106 2.06 1.464 1.464 0 01-1.492.881 1.47 1.47 0 01-1.292-1.158 1.464 1.464 0 01.712-1.58l-.094-.1zm-46.379 62.106a1.494 1.494 0 012.08-.121 1.469 1.469 0 01.125 2.08 1.494 1.494 0 01-2.08.12 1.494 1.494 0 01-.124-2.08zm-47.973-83.511a1.437 1.437 0 012.059-.102 1.412 1.412 0 01.106 2.06c-.25.587-.855.944-1.49.88a1.469 1.469 0 01-.58-2.737l-.095-.101zm39.954-22.944a1.493 1.493 0 012.08-.122c.597.546.652 1.468.124 2.08a1.459 1.459 0 01-1.014.493 1.474 1.474 0 01-1.066-.372 1.495 1.495 0 01-.124-2.08zm-81.373 67.06a1.493 1.493 0 012.079-.123 1.473 1.473 0 01-.511 2.5c-.5.164-1.05.051-1.443-.299a1.494 1.494 0 01-.125-2.08zm-10.962-28.173a1.463 1.463 0 011.581-.406c.56.2.947.717.978 1.31.03.594-.3 1.148-.838 1.4a1.468 1.468 0 01-1.615-.245 1.441 1.441 0 01-.107-2.06zm-4.18 66.942a1.468 1.468 0 012.165 1.957 1.408 1.408 0 01-2.06.102 1.444 1.444 0 01-.106-2.06zm53.775-44.77a1.492 1.492 0 012.078-.12c.593.542.641 1.46.106 2.059a1.493 1.493 0 01-2.079.121 1.467 1.467 0 01-.105-2.06zm-21.024 86.133a1.493 1.493 0 012.08-.12 1.436 1.436 0 01.105 2.059 1.465 1.465 0 01-2.784-.252 1.465 1.465 0 01.694-1.585l-.095-.102zm22.088 26.848a1.473 1.473 0 012.183 1.977 1.44 1.44 0 01-2.058.102 1.493 1.493 0 01-.125-2.08zm25.333-30.515a1.493 1.493 0 012.08-.122c.593.542.64 1.46.105 2.059a1.494 1.494 0 01-2.08.122 1.442 1.442 0 01-.105-2.06zm23.942-22.403a1.44 1.44 0 012.058-.102c.512.554.522 1.405.023 1.968-.5.563-1.345.656-1.957.214a1.468 1.468 0 01-.125-2.08zm24.998-20.66a1.44 1.44 0 012.059-.103c.598.546.653 1.469.125 2.08a1.473 1.473 0 01-2.184-1.977zm-19.472-17.396a1.493 1.493 0 012.078-.121 1.467 1.467 0 11-2.078.12zm28.361-25.161a1.473 1.473 0 012.184 1.977 1.44 1.44 0 01-2.059.103 1.494 1.494 0 01-.125-2.08zm14.32 4.897a1.46 1.46 0 011.014-.493 1.473 1.473 0 011.553 1.38c.02.388-.12.767-.382 1.051a1.494 1.494 0 01-2.08.122 1.467 1.467 0 01-.106-2.059zm18.431-8.932a1.44 1.44 0 012.059-.103 1.41 1.41 0 01.106 2.06 1.432 1.432 0 01-1.007.485 1.467 1.467 0 01-1.158-2.443z"
})), /*#__PURE__*/React.createElement("g", {
  opacity: 0.84
}, /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M436.064 390.327l1.621-15.976.058.021-1.6 15.958z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M407.481 385.214l-.038-.041 30.263-10.84.017.059zM407.335 385.658l28.764 4.312z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M407.443 385.173l10.515-17.302h.04l-10.517 17.343zm-24.453 1.22l.021-.058 24.432-1.162.018.06z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M388.14 372.54l.022-.058 19.32 12.692-.04.038zM388.203 372.576l-5.141 13.844zM382.971 386.373l-8.79-27.018.06-.018 8.79 27.019z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M374.182 359.355l.04-.038 13.94 13.165-.04.037z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M388.123 372.481l8.555-17.255.039.04-8.556 17.255z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M388.123 372.481l20.45-15.85.037.04-20.45 15.85z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M388.14 372.54l.002-.039 29.836-4.65-.001.04z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M407.423 385.191l1.15-28.56.058.02-1.13 28.544z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M407.442 385.212l-10.764-29.947.04-.038 10.764 29.947z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M396.697 355.285l.002-.078 12.151 1.315-.022.059zm40.988 19.066l16.552-14.639.037.04-16.551 14.64z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M424.223 350.632l.04-.038 13.462 23.759-.04.037z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M417.977 367.891l.021-.059 19.708 6.5-.021.058z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M417.958 367.87l6.266-17.278.057.022-6.284 17.258z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M408.571 356.669l.04-.038 9.407 11.222-.041.038z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M417.958 367.87l-6.365-24.621.04.001 6.385 24.603z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M408.573 356.63l3.02-13.381.04.001-3.002 13.402z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M408.61 356.67l-.017-.059 15.65-6.037.019.058zM424.262 350.632l-.018-.058 13.223-4.265.017.06z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M424.241 350.651l.022-.057 29.994 9.1-.002.038z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M437.465 346.348l.04-.038 16.752 13.383-.022.058z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M419.964 341.728l.022-.058 17.52 4.64-.022.058z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M437.467 346.309l11.264-14.065.039.04-11.266 14.065zm-17.521-4.601l.04-.038 4.277 8.924-.04.038z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M411.612 343.27l.001-.04 8.334-1.562.017.06z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M404.894 334.16l.06-.017 6.698 9.089-.06.017zM411.538 343.315l13.324-10.11zM419.947 341.668l20.428-11.211.018.06-20.408 11.192z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M419.947 341.668l4.97-8.534.057.022-4.99 8.553z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M419.947 341.668l24.819-27.46.037.04-24.818 27.46zm20.427-11.172v-.04l8.378 1.769-.021.058zM444.88 314.31l-4.409 16.257z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M427.215 330.613l.001-.04 13.159-.116v.039zm-2.298 2.521l2.26-2.562.038.04-2.26 2.563z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M427.175 330.612l-1.76-8.09.04.001 1.78 8.07z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M444.766 314.208l.682.731-17.57 16.385-.682-.732zm-36.077 13.159l-.018-.06 16.765-4.804.017.06z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M425.436 322.503l19.33-8.295.037.04-19.35 8.315z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M404.935 334.123l20.5-11.62.018.06-20.52 11.6z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M404.915 334.142l3.756-6.836.038.041-3.755 6.796zM392.336 332.346l17.051-2.927z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M371.697 343.232l36.974-15.926.038.041-36.995 15.944zm-10.798-.23l.001-.039 30.966-11.95.017.06z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M385.914 343.682l5.931-12.65.059.021-5.932 12.65z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M367.983 352.262l23.862-21.23.038.04-23.882 21.21zm-7.084-9.26l.001-.039 10.797.269-.001.04z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M367.963 352.28l3.714-9.03.058.022-3.734 9.01z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M371.696 343.271l.001-.04 14.237.432-.002.039z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M377.354 348.974l8.58-5.31.038.04-8.58 5.311z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M385.932 343.702l.002-.039 10.933.293-.002.04z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M388.122 372.52l-2.208-28.838h.039l2.228 28.82zm-20.033-19.942l.041-.038 6.093 6.777-.041.038z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M374.202 359.336l3.152-10.362.04.002-3.173 10.38zM374.14 359.395l22.67-15.387-22.67 15.387z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M371.696 343.271l.04-.037 5.658 5.742-.04.038z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M360.601 343.129l.021-.058 16.753 5.884-.022.059z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M377.334 348.993l.06-.017 10.787 23.526-.06.017zm19.512-5.018l-5.02-12.925.059-.017 5.021 12.924z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M396.134 344.224l8.78-10.082.038.04-8.78 10.082zm.525 11.02l.187-11.27.04.002-.149 11.272z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#333",
  d: "M440.663 331.21a.776.776 0 11.425-1.001.745.745 0 01-.425 1.002zm-2.949 15.89a.751.751 0 01-1.004-.427.802.802 0 01.446-1.022.778.778 0 011.002.467.745.745 0 01-.445.982zm-10.231-15.754a.804.804 0 01-1.002-.466.773.773 0 011.032-.996.78.78 0 01.417.441.83.83 0 01-.446 1.022zm-2.28 2.543a.773.773 0 01-1.001-.468.744.744 0 01.444-.982.748.748 0 011.004.428.777.777 0 01-.005.606.777.777 0 01-.441.416zM411.9 343.985a.775.775 0 01-1.021-.448.83.83 0 01.445-1.022.802.802 0 01.576 1.47zm12.611 7.36a.775.775 0 11-.557-1.449.777.777 0 011.022.449.775.775 0 01-.464 1.001zm-15.651 6.04a.775.775 0 01-.557-1.45.775.775 0 011.022.448.775.775 0 01-.465 1.001zm11.375-14.962a.748.748 0 01-1.004-.427.775.775 0 011.045-.999.78.78 0 01.404.444.748.748 0 01-.445.982zm-34.094 2.07a.78.78 0 01-1.022-.448.777.777 0 01.464-1.002.752.752 0 01.983.446.744.744 0 01-.426 1.003zm-11.652 15.596a.801.801 0 11-.611-1.483.801.801 0 01.612 1.484zm13.94 13.166a.803.803 0 01-1.021-.447.83.83 0 01.445-1.023.802.802 0 01.576 1.47zm8.476-17.218a.776.776 0 01-.982-.447.747.747 0 01.425-1.002.777.777 0 01.557 1.45zm-28.635-3.021a.775.775 0 01-1.022-.448.777.777 0 01.465-1.002.752.752 0 01.983.446.744.744 0 01-.426 1.003zm36.932-18.12a.801.801 0 01-.577-1.47.777.777 0 011.023.448.802.802 0 01-.446 1.022zm2.529 51.031a.748.748 0 01-1.004-.428.777.777 0 01.005-.606.777.777 0 011.443.052.745.745 0 01-.445.982zm-24.358 1.282a.832.832 0 01-1.023-.447.802.802 0 011.47-.575.775.775 0 01-.446 1.022zm54.6-12.103a.777.777 0 01-.983-.446.774.774 0 011.429-.576.777.777 0 01-.446 1.022zm-1.6 15.956a.804.804 0 01-1.005-.427.777.777 0 01.446-1.022.803.803 0 011.003.428.774.774 0 01-.445 1.021zm18.152-30.595a.777.777 0 01-.559-1.45.748.748 0 011.004.427.775.775 0 01-.446 1.022zm-36.26 8.139a.777.777 0 11-.556-1.45.745.745 0 01.982.447.747.747 0 01-.425 1.003zm30.754-35.608a.803.803 0 01-1.021-.447.774.774 0 01.464-1.002c.394-.14.83.056.984.446a.744.744 0 01-.426 1.003zm-3.966-18.036a.773.773 0 11.465-1.001.801.801 0 01-.464 1.002zm-19.33 8.295a.777.777 0 01-1.023-.448.774.774 0 01.446-.982.775.775 0 01.578 1.43zm-16.765 4.805a.832.832 0 01-1.022-.449.802.802 0 011.469-.574.777.777 0 01-.446 1.022zm-16.825 3.724a.778.778 0 01-1.002-.467.774.774 0 01.445-.983.746.746 0 011.003.428.775.775 0 01-.446 1.022zm5.022 12.924a.772.772 0 01-1.023-.448.83.83 0 01.446-1.022.804.804 0 01.577 1.47zm-19.513 5.019a.778.778 0 01-1.002-.467.745.745 0 01.444-.982.748.748 0 011.004.427.775.775 0 01-.446 1.022zm-5.657-5.743a.776.776 0 11.426-1.002.747.747 0 01-.426 1.002zm-10.797-.268a.774.774 0 01-1.023-.448.772.772 0 01.445-.982.747.747 0 011.004.427.75.75 0 01-.426 1.003z"
})), /*#__PURE__*/React.createElement("g", {
  opacity: 0.27
}, /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M240.353 382.486l2.208 10.474h-.04l-2.207-10.475z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M259.546 379.961l.019.02-17.025 12.998-.018-.02z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M259.565 379.943v.039l-19.232 2.523.002-.04z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M259.565 379.982l-3.17 13.14-.057-.021 3.208-13.14zm15.287-5.7l-.001.04-15.286 5.66-.02-.02z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M274.399 384.134l-.02.02L259.544 380l.021-.058z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M274.871 374.303l-.472 9.831h-.04l.473-9.832z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M274.871 374.303l11.026 15.392-.02.019-11.045-15.412z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M285.897 389.695l-.02.019-11.498-5.56.02-.02z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M274.399 384.134l-1.941 12.715-.038-.001 1.94-12.715z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M274.379 384.154l-9.764 14.215-.058-.02 9.802-14.216z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M274.36 384.133l.019.02-18.003 8.988-.018-.059z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M259.584 379.963l5.012 18.387-.02.019-5.05-18.389z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M259.584 379.963l12.855 16.866-.02.019L259.545 380z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M272.44 396.83l-.002.037-7.983 1.614v-.039zm-29.9-3.85l-7.556 12.65-.02-.02 7.558-12.65zm13.342 12.36l-.02.02-13.34-12.4.02-.02z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M256.358 393.082l.018.059-13.836-.162.002-.039z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M256.395 393.123l-.513 12.217-.04-.001.496-12.238z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M264.596 398.35l-.02.019-8.219-5.248.02-.018z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M256.377 393.103l9.023 14.379-.038-.002-9.005-14.359z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M264.596 398.35l.804 9.132-.038-.002-.805-9.132z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M264.577 398.33l.038.04-8.735 7.01-.038-.041zm-8.735 7.009l.038.04-7.543 5.369-.02-.02z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M255.863 405.32l-.002.04-20.877.27v-.039z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M248.338 410.708l-.022.059-13.332-5.136v-.04z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M260.397 410.141l-.02.02-12.061.606.001-.04z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M248.337 410.748l-4.318 11.22-.019-.02 4.317-11.22zm12.06-.607l-.02.02-4.516-4.802.02-.019z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M265.382 407.462l-.001.038-4.986 2.68-.017-.06z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M271.455 411.907l-.02.019-6.054-4.426v-.038z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M265.4 407.482l-6.437 9.108-.02-.02 6.42-9.09zm-5.005 2.698l-10.7 11.227-.018-.02 10.68-11.247z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M260.397 410.141l-1.434 6.449-.04-.002 1.454-6.428z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M260.416 410.161l-10.241 22.461h-.039l10.222-22.482zm-10.74 11.226v.039l-5.657.542-.019-.02z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M249.696 421.407l.479 11.215h-.039l-.48-11.217zm8.316-2.756l.018.02-8.334 2.736-.02-.02zm.95-2.061l-.932 2.08-.018-.019.912-2.063zm-.911 2.062l2.734 4.797-.039-.002-2.735-4.758z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M258.03 418.67l-7.855 13.952h-.039l7.876-13.97zm12.41-1.65l.019.02-9.674 6.409-.02-.02z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M260.785 423.449l-10.61 9.173-.018-.02 10.609-9.174zm10.69-11.521l-10.69 11.52-.02-.02 10.67-11.502z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M271.474 411.928l-.996 5.093-.038-.001.995-5.094zM270.341 417.06l9.969-5.682-9.969 5.682z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M290.732 399.46l-20.273 17.58-.019-.02 20.274-17.619zm6.901-2.043l.02.02-17.268 13.83-.02-.02z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M281.6 402.031l-1.215 9.236-.02-.02 1.196-9.217z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M291.286 392.96l-10.901 18.307-.02-.02 10.884-18.327zm6.347 4.457l.02.02-6.92 2.024-.02-.06zM291.319 393.017l-.542 6.48z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M290.714 399.401l.018.06-9.152 2.59.001-.04z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M285.981 396.961l-4.38 5.07-.02-.02 4.362-5.09zm-4.4 5.05l-.001.04-6.98 2-.018-.02z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M274.399 384.134l7.201 17.897-.02.02-7.201-17.897zm16.756 8.647l-.02.018-5.259-3.085.02-.02z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M285.897 389.695l.086 7.227-.04-.002-.067-7.206z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M285.915 389.714l-11.295 14.358-.038-.04 11.275-14.339zm4.818 9.708l-.02.018-4.75-2.5.02-.018z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M297.814 397.287l-.02.018-11.832-.364.002-.04z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M285.983 396.922l-.02.019-11.604-12.77.04-.037zm-11.382 7.13l5.804 7.196-.04.038-5.784-7.216z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M275.023 403.735l-3.549 8.193-.039-.002 3.549-8.194zm-2.565-6.886l2.143 7.203-.039-.002-2.142-7.202z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#333",
  d: "M249.357 421.004a.525.525 0 11-.083.721.497.497 0 01.083-.721zm-1.359-10.66a.497.497 0 01.722.084.526.526 0 11-.722-.084zm9.694 7.923a.526.526 0 01.722.085.553.553 0 01-.065.741.524.524 0 01-.74-.105.497.497 0 01.083-.72zm.933-2.08a.526.526 0 01.721.084.553.553 0 01-.065.741.499.499 0 01-.721-.084.5.5 0 01.065-.741zm6.417-9.09a.554.554 0 01.742.066.528.528 0 01-.104.74.527.527 0 01-.7-.75l.062-.056zm-9.52-2.142a.554.554 0 01.743.066.554.554 0 01-.085.76.526.526 0 01-.718-.769l.06-.057zm8.735-7.01a.525.525 0 01.741.105.525.525 0 01-.084.721.552.552 0 01-.741-.065.554.554 0 01.084-.76zm-4.22 11.81a.555.555 0 01.761.088.528.528 0 01-.103.74.525.525 0 01-.721-.085.554.554 0 01.064-.742zm21.225-8.128a.526.526 0 01.721.085.553.553 0 01-.064.741.525.525 0 01-.741-.105.498.498 0 01.084-.72zm4.275-12.318a.554.554 0 01.76.087.526.526 0 11-.767.716.551.551 0 01.007-.802zm-11.497-5.56a.553.553 0 01.742.066c.18.236.142.57-.085.76a.526.526 0 01-.717-.769l.06-.056zm-2.036 12.653a.5.5 0 01.742.067.528.528 0 01-.104.739.526.526 0 01-.699-.75l.06-.056zm19.005-3.94a.525.525 0 01.74.104.526.526 0 11-.747.698.496.496 0 01.008-.802zM271.055 411.6a.497.497 0 01.721.084.524.524 0 01-.084.721.552.552 0 01-.74-.065.526.526 0 01.103-.74zm-11.83-32.021a.526.526 0 01.7.749.495.495 0 01-.72-.084.525.525 0 01.02-.665zm15.307-5.679a.526.526 0 01.7.75.497.497 0 01-.723-.085.5.5 0 01.023-.665zm-32.33 18.676a.525.525 0 01.7.749.526.526 0 01-.7-.75zm-2.207-10.475a.525.525 0 01.956.215.526.526 0 01-.257.535.504.504 0 01-.386.133.505.505 0 01-.357-.2.526.526 0 01.044-.683zm-5.35 23.126a.524.524 0 01.956.214.522.522 0 01-.257.535.524.524 0 01-.957-.215.522.522 0 01.258-.534zm21.372-12.51a.555.555 0 01.762.086.526.526 0 11-.77.717.555.555 0 01.008-.803zm-12.337 28.847a.499.499 0 01.723.085.5.5 0 01-.084.721.526.526 0 01-.7-.75l.061-.056zm6.137 10.674a.524.524 0 01.956.215.525.525 0 01-.258.534.504.504 0 01-.385.134.503.503 0 01-.357-.2.524.524 0 01.044-.683zm10.63-9.194a.527.527 0 01.698.75.526.526 0 01-.699-.75zm9.654-6.428a.525.525 0 01.74.105.497.497 0 01-.083.722.527.527 0 01-.721-.085.555.555 0 01.064-.742zm9.945-5.752a.525.525 0 01.721.085.551.551 0 01-.064.74.524.524 0 01-.74-.105.525.525 0 01.083-.72zm-5.784-7.216a.526.526 0 01.722.084.555.555 0 01-.064.743.526.526 0 01-.722-.085.497.497 0 01.064-.742zm11.362-7.111a.553.553 0 01.742.065.553.553 0 01-.084.76.526.526 0 01-.719-.769l.061-.056zm4.75 2.5a.526.526 0 11.718.77.526.526 0 01-.718-.77zm6.94-2.004a.527.527 0 11.474.913.524.524 0 01-.558-.192.499.499 0 01.084-.721z"
})), /*#__PURE__*/React.createElement("g", {
  opacity: 0.3
}, /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M338.569 322.098l2.208 10.474h-.04l-2.208-10.476z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M357.782 319.554l.018.06-17.044 12.977.002-.039z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M357.782 319.554l-.001.04-19.212 2.504-.019-.02z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M357.801 319.575l-3.19 13.159-.018-.02 3.168-13.14z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M373.088 313.876l-.001.04-15.306 5.678v-.04z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M372.615 323.746l-.02.019-14.814-4.171v-.04z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M373.107 313.896l-.474 9.87-.038-.001.473-9.87z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M373.107 313.896l11.025 15.39-.04.039-11.024-15.43z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M384.132 329.287l-.04.038-11.497-5.56.02-.019z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M372.633 323.766l-1.959 12.694-.04-.001 1.961-12.694z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M372.633 323.766l-9.802 14.215-.019-.02 9.784-14.235z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M372.596 323.726l.037.04-18.021 8.968-.02-.02z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M357.801 319.575l5.032 18.368-.04.037-5.012-18.386z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M357.801 319.575l12.854 16.865-.02.019-12.854-16.865z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M370.655 336.44l.02.02-7.984 1.614-.019-.02zm-29.878-3.868l-7.557 12.651-.02-.02 7.538-12.632z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M340.66 332.667l13.315 12.398-13.316-12.398zM354.593 332.713l.019.02-13.856-.142.002-.039z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M354.612 332.734l-.515 12.218-.038-.002.534-12.237z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M362.833 337.943l-.04.037-8.22-5.247.04-.038z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M354.612 332.695l9.005 14.398h-.04l-9.005-14.36z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M362.833 337.943l.784 9.15h-.04l-.765-9.131z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M362.812 337.962l.019.02-8.715 6.99-.038-.04zm-8.734 6.97l.038.04-7.564 5.388.002-.04zM332.995 344.588l20.85-.29zM346.554 350.32l-.002.04-13.352-5.118v-.039z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M358.613 349.753l-.002.04-12.059.567.002-.04z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M346.573 350.34l-4.317 11.221-.04-.002 4.317-11.22zm12.06-.606l-.04.038-4.515-4.801.04-.038zm4.965-2.66l.019.019-4.986 2.68-.018-.02z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M369.691 351.5l-.02.058-6.075-4.446.002-.039z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M363.617 347.093l-6.419 9.129-.038-.041 6.438-9.108zm-4.986 2.68l-10.719 11.246-.019-.02 10.72-11.246z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M358.631 349.773l-1.413 6.43-.058-.022 1.453-6.428z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M358.631 349.773l-10.24 22.461-.019-.02 10.24-22.46zm-10.718 11.207v.039l-5.677.56v-.038z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M347.932 361l.48 11.215h-.04l-.479-11.217z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M356.248 358.243l-.001.04-8.335 2.736v-.04z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M357.198 356.222l-.931 2.042-.04-.002.933-2.081zm-.931 2.042l2.754 4.777-.02.018-2.754-4.777zm-.02.018l-7.856 13.952-.019-.02 7.856-13.952z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M368.677 356.613l.018.02-9.694 6.426-.019-.02zM359 363.059l-10.61 9.175-.019-.02 10.61-9.174z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M369.69 351.539L359 363.059l-.018-.02 10.69-11.52z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M369.71 351.52l-1.015 5.112h-.039l1.016-5.113zM368.575 356.724l9.924-5.757-9.924 5.757z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M388.968 339.053l-20.273 17.58-.018-.02 20.253-17.6zm6.902-2.043l-.002.038L378.62 350.9l-.039-.041z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M379.855 341.644l-1.234 9.216-.02.02 1.215-9.237z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M389.502 332.573L378.62 350.86l-.04-.001 10.902-18.307zM388.878 339.104l6.906-2.005-6.906 2.005z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M389.522 332.553l-.573 6.48.534-6.48zm-.592 6.46l.038.04-9.134 2.61-.017-.06z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M384.218 336.554l-4.384 5.109-.037-.04 4.382-5.11z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M379.817 341.604l.017.059-7.018 2 .002-.038zM372.681 323.864l7.204 17.872zM389.391 332.373l-.04.038-5.26-3.086.041-.038z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M384.131 329.326l.068 7.208-.02.018-.087-7.227z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M384.131 329.326l-11.295 14.358-.038-.04 11.314-14.338zm4.838 9.689l-.04.037-4.75-2.5.04-.038zM384.113 336.554l11.831.492z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M384.219 336.514l-.04.038-11.584-12.787.02-.019zm-11.382 7.13l5.784 7.216-.02.02-5.785-7.216z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M373.24 343.346l-3.55 8.193-.018-.02 3.548-8.194zm-2.566-6.886l2.163 7.184-.02.02-2.182-7.205z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#333",
  d: "M347.573 360.616a.552.552 0 01.742.065.528.528 0 01-.104.74.494.494 0 01-.378.114.495.495 0 01-.343-.198.527.527 0 01.083-.721zm-1.378-10.68a.555.555 0 01.742.065.526.526 0 11-.742-.066zm9.713 7.943a.553.553 0 01.742.066.553.553 0 01-.085.76.525.525 0 01-.721-.085.551.551 0 01.064-.74zm.933-2.081a.526.526 0 01.722.084.499.499 0 01-.066.742.526.526 0 01-.722-.084.553.553 0 01.065-.742zm6.438-9.109a.526.526 0 11-.001 0zm-9.52-2.14a.525.525 0 11-.065.74.496.496 0 01.065-.741zm8.734-6.972zm-4.2 11.792a.497.497 0 01.722.085.527.527 0 01-.214.957.527.527 0 01-.535-.26.497.497 0 01.026-.781zm21.103-8.054a.552.552 0 01.742.065.528.528 0 01-.085.761.527.527 0 01-.721-.085.553.553 0 01.064-.74zm4.397-12.392a.497.497 0 01.721.084.526.526 0 11-.721-.084zm-11.516-5.58a.524.524 0 01.74.105.525.525 0 11-.749.697.493.493 0 01-.198-.403c0-.16.078-.307.207-.4zm-1.942 12.714a.526.526 0 11-.083.722.501.501 0 01.083-.722zm18.829-3.888a.5.5 0 01.74.066.528.528 0 01-.102.74.525.525 0 01-.957-.215.522.522 0 01.258-.535l.06-.056zm-19.849 18.926a.526.526 0 01.72.084.524.524 0 11-.749.698.528.528 0 01.028-.781zm-11.873-31.905a.526.526 0 01.74.065.526.526 0 11-.766.717.522.522 0 01-.161-.397.52.52 0 01.187-.385zm15.307-5.678a.497.497 0 01.721.084.527.527 0 01-.214.957.527.527 0 01-.534-.26.522.522 0 01-.16-.396.523.523 0 01.187-.385zm-32.31 18.656a.526.526 0 01.698.75.554.554 0 01-.742-.066.523.523 0 01.044-.683zm-2.208-10.474a.527.527 0 01.721.084.553.553 0 01-.064.742.524.524 0 01-.741-.105.525.525 0 01.084-.721zm-5.35 23.126a.495.495 0 01.721.084.527.527 0 01-.212.957.528.528 0 01-.536-.26.495.495 0 01.028-.781zm21.392-12.49a.497.497 0 01.721.085.525.525 0 11-.72-.085zm-12.377 28.846a.526.526 0 11.7.75.498.498 0 01-.741-.066.525.525 0 01.042-.683zm6.156 10.654a.526.526 0 01.7.75.499.499 0 01-.723-.085.525.525 0 01.023-.665zm10.61-9.174a.554.554 0 01.742.066.528.528 0 01-.104.74.497.497 0 01-.721-.084.525.525 0 01.084-.721zm9.694-6.427a.499.499 0 01.722.085.526.526 0 11-.749.698.498.498 0 01.027-.783zm9.83-5.835a.529.529 0 01.742.065.525.525 0 11-.805.675.525.525 0 01.063-.74zm-5.708-7.134a.554.554 0 01.742.065.526.526 0 01-.768.717.554.554 0 01.026-.782zm11.382-7.13a.526.526 0 11-.065.741.501.501 0 01.065-.741zm4.75 2.5a.526.526 0 11-.064.741.553.553 0 01.064-.741zm6.92-1.985a.554.554 0 01.741.065.526.526 0 11-.742-.065z"
})), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
  opacity: 0.13
}, /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M110.361 212.35l17.08 6.43-.002.04-17.1-6.412z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M124.115 182.386l.077.003 3.268 36.411h-.04z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M124.115 182.386l.058.021-13.814 29.982-.038-.04z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M124.173 182.368l16.06 16.615-.04.038-16.06-16.615zM130.102 155.306l-6.053 27.128z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M143.594 164.827l.037.04-19.458 17.54-.038-.04z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M129.864 155.157l13.769 9.671-.061.057-13.748-9.69z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M129.846 155.137l32.204-1.81-.002.08-32.205 1.808z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M162.03 153.347l.038.04-18.457 11.5-.017-.06z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M143.633 164.828l16.542 14.424-.06.057-16.543-14.424z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M143.633 164.828l11.606 27.123-.06.017-11.607-27.083z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M143.574 164.846l.057.022-3.418 34.134-.04-.002z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M124.173 182.368l31.047 9.562-.021.058-31.047-9.562zM124.089 182.47l36.005-3.12-36.005 3.12zM160.115 179.27l.058.021-4.905 12.974-.058-.023zm-32.635 39.512l11.352 22.442-.04.037-11.39-22.443zM127.346 218.874l29.937-7.891z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M140.174 199l.057.022L127.46 218.8l-.058-.02zM140.084 199.056l17.19 11.912-17.19-11.912z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M155.201 191.91l.018.06-15.008 7.07-.018-.058z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M140.193 198.982l28.898.14-.003.079-28.895-.18zM155.105 191.997l13.865 7.21z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M155.18 191.968l.06-.017 2.184 18.959-.078-.004z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M157.346 210.906l.078.004.923 15.785-.08-.002z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M157.366 210.888l.038.04-18.554 30.316-.058-.022z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M158.288 226.674l.038.04-19.497 14.549-.037-.04z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M168.379 208.79l.058.022-10.11 17.902-.06-.021z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M158.328 226.675L170.6 243.15l-.059.018-12.254-16.455zm10.071-17.904l.017.06-11.032 2.116-.018-.059z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M169.05 199.16l.078.003-.71 9.628h-.04z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M180.97 194.438l.038.04-11.92 4.723-.018-.06z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M169.11 199.143l7.31 17.583-.058.018-7.311-17.584zm-.673 9.63l6.515 25.704-.06.017-6.513-25.703z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M168.437 208.773l7.983 7.953-.04.038-7.983-7.954z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M168.437 208.773l23.1 35.282-.04.038-23.1-35.283zM174.982 234.58l-4.34 8.686z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M174.933 234.457l16.586 9.578-.022.058-16.605-9.56z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M178.502 219.969l.078.002-3.648 14.525-.058-.022z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M176.42 216.726l2.141 3.226-.04.037-2.16-3.245z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M178.542 219.931l9.366.422.017.06-9.386-.404zM178.62 220.064l12.978 24.083z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M187.391 200.556l.06.022.494 19.815-.058-.02zM187.944 220.478l3.605 23.69z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M181.028 194.46l6.898 25.913-.058.018-6.899-25.914z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M181.01 194.44l6.44 6.099-.06.056-6.42-6.118zM188.165 181.077l-.648 19.572zM180.523 155.366l6.973 45.29zM183.794 143.494l.078.003L188.157 181l-.059.018z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M175.931 170.801l12.208 10.18-.022.058-12.226-10.2z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M171.628 148.559L188.157 181l-.059.018-16.531-32.404zm12.166-5.065l.058.021-3.38 11.778h-.04z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M171.628 148.559l8.825 6.714-.022.059-8.864-6.717z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M180.432 155.292l.04.001-4.522 15.529-.058-.023z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M172.581 159.851l3.37 10.97-.06.018-3.388-10.99z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M175.892 170.8l.058.022-3.425 11.932-.057-.022z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M143.594 164.827l32.337 5.974-.021.058-32.299-5.973zm27.642-16.243l.017.059-9.185 4.745-.038-.041z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M162.07 153.348l10.493 6.483-.04.038-10.494-6.483z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M162.07 153.348l10.436 29.386-.04.037-10.437-29.385zm18.363 1.905l.037.08-7.929 4.556-.017-.06z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M183.768 143.102l.037.04-11.244 16.728-.058-.022z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M172.524 159.83l.017.059-28.93 4.997-.017-.059zm-.036 22.884l15.65-1.732-.021.057-15.612 1.734z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M172.399 181.85l8.61 12.59-.04.037-8.61-12.589zm-12.243-2.618l12.332 3.482-.022.057-12.314-3.46z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#333",
  d: "M173.991 234.579a.884.884 0 01.795-.968.915.915 0 01.99.779.887.887 0 01-.196.65.886.886 0 01-.599.318.915.915 0 01-.99-.78zm-16.567-7.78a.88.88 0 01.756-.97.857.857 0 01.99.779.907.907 0 01-.775.988.884.884 0 01-.97-.798zm20.234-6.724a.855.855 0 01.773-.949.829.829 0 01.972.759.852.852 0 01-.775.987.887.887 0 01-.97-.797zm-2.1-3.263a.826.826 0 01.755-.969.859.859 0 01.99.779.884.884 0 01-1.433.78.863.863 0 01-.312-.59zm-7.352-17.547a.88.88 0 01.755-.967.857.857 0 01.99.779.907.907 0 01-.774.987.889.889 0 01-.971-.798zm-11.704 11.747a.906.906 0 01.776-.987.884.884 0 01.97.798.908.908 0 01-.776.987.88.88 0 01-.65-.198.881.881 0 01-.32-.6zm-2.185-18.958a.878.878 0 01.794-.968.858.858 0 01.952.778.829.829 0 01-.756.969.859.859 0 01-.99-.78zm13.197 16.86a.88.88 0 01.774-.975.886.886 0 01.982.772.88.88 0 01-.765.983.915.915 0 01-.99-.779zm7.514-37.99a.884.884 0 01.795-.968.889.889 0 01.971.76.85.85 0 01-.776.988.915.915 0 01-.99-.78zm-13.862-17.452a.908.908 0 01.776-.988.884.884 0 01.97.798.907.907 0 01-.776.987.884.884 0 01-.97-.797zm-18.457 11.498a.907.907 0 01.775-.987.914.914 0 01.99.779.907.907 0 01-.774.988.916.916 0 01-.99-.78zm16.543 14.424a.906.906 0 01.774-.987.915.915 0 01.99.778.906.906 0 01-.774.988.914.914 0 01-.99-.779zm11.452-30.693a.907.907 0 01.756-.969.915.915 0 01.99.78.907.907 0 01-.775.986.914.914 0 01-.97-.797zm9.402 45.862a.89.89 0 01.195-.65.889.889 0 01.6-.318.858.858 0 01.951.777.863.863 0 01-.17.666.858.858 0 01-.605.323.889.889 0 01-.971-.798zm-56.835-12.071a.853.853 0 01.774-.949.831.831 0 01.971.758.885.885 0 01-.18.657.875.875 0 01-.594.331.888.888 0 01-.97-.797zm5.69-27.21a.907.907 0 01.775-.988.888.888 0 01.97.797.906.906 0 01-.774.988.887.887 0 01-.97-.798zm-2.423 63.622a.884.884 0 01.794-.968.887.887 0 01.971.759.855.855 0 01-.775.988.915.915 0 01-.99-.779zm-17.08-6.43a.853.853 0 01.773-.95.86.86 0 01.99.779.884.884 0 01-1.444.77.889.889 0 01-.32-.6zm28.47 28.873a.88.88 0 01.773-.976.887.887 0 01.982.772.881.881 0 01-.765.983.914.914 0 01-.99-.78zm1.382-42.222a.907.907 0 01.774-.987.916.916 0 01.991.778.882.882 0 01-.794.967.887.887 0 01-.971-.758zm30.387 44.15a.827.827 0 01.756-.97.86.86 0 01.99.78.884.884 0 01-1.434.778.858.858 0 01-.312-.588zm20.937.903a.88.88 0 01.773-.975.887.887 0 01.982.771.88.88 0 01-.764.984.916.916 0 01-.991-.78zm-3.61-23.681a.88.88 0 01.773-.977.887.887 0 01.981.772.88.88 0 01-.764.984.915.915 0 01-.99-.78zm-.497-19.816a.886.886 0 01.776-.988c.488-.058.93.29.99.779a.856.856 0 01-.775.987.915.915 0 01-.99-.778zm.728-19.556a.855.855 0 01.775-.988.881.881 0 01.65.198.88.88 0 01.32.6c0 .45-.337.827-.785.875s-.86-.247-.96-.685zm-15.651 1.732a.907.907 0 01.774-.987.916.916 0 01.991.778.909.909 0 01-.775.988.915.915 0 01-.99-.779zm-.005-22.846a.908.908 0 01.776-.989.888.888 0 01.99.78.907.907 0 01-.775.987.916.916 0 01-.99-.778zm7.95-4.615a.885.885 0 01.794-.968.915.915 0 01.99.78.88.88 0 01-.794.967.915.915 0 01-.99-.779zm3.401-11.796a.88.88 0 01.755-.97.86.86 0 01.99.78.907.907 0 01-.774.987.888.888 0 01-.97-.797z"
})), /*#__PURE__*/React.createElement("g", {
  opacity: 0.58
}, /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M243.566 188.431l13.36 13.129-13.36-13.129z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M231.566 223.751l-.057-.022 12.077-35.4.058.023z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M231.566 223.751l-.038-.04 25.42-22.267.056.061z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M231.507 223.768l-8.114-22.244.059-.018 8.114 22.245z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M214.894 246.826l-.058-.02 16.673-23.077.057.022z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M205.985 232.057l-.018-.06 25.561-8.286.018.059z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M214.835 246.843l-8.868-14.806.04-.038 8.888 14.788z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M214.835 246.843l-30.934-11.746.02-.058 30.974 11.748z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M183.9 235.097l-.017-.059 22.105-3.06-.003.079z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M205.967 232.037l-9.506-20.38.06-.018 9.504 20.38z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M205.947 232.016l.415-30.16.077.003-.414 30.16z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M206.005 232.038l-.038-.04 17.407-30.495.076.042z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M231.507 223.768l-25.126-21.891.04-.038 25.146 21.873z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M231.546 223.77l-35.065-12.093.02-.058 35.027 12.092zM206.543 201.624l-9.962 10.119zM243.606 188.35l-1.336-25.73.079.004 1.316 25.709z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M212.275 183.253l-.019-.06 31.39 5.12-.021.057zM223.318 201.549l20.27-13.087-20.27 13.087z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M223.393 201.524l-11.158-18.272.04-.038 11.177 18.292z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M206.4 201.897l.002-.078 17.01-.314v.038z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M223.412 201.543l-27.032-12.17.021-.057 27.032 12.17z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M206.38 201.877l-10.02-12.524.061-.057 10 12.543z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M206.44 201.86l-.078-.004 5.875-18.644.058.023z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M212.295 183.235l-.058-.023 5.72-15.132.057.023z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M212.275 183.253l-.019-.06 30.034-20.591.038.04z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M217.994 168.121l-.018-.06 24.335-5.478.017.06zm-16.948 12.512l-.017-.06 16.928-12.532.037.08z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M217.956 168.08l-4.635-20.494.058-.018 4.637 20.495zm-16.91 12.553l.002-.039 11.208 2.6-.002.078z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M196.42 189.336l-.058-.021 4.647-8.722.058.02z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M183.267 188.776l.003-.04 13.131.58-.001.04z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M196.38 189.335l.452-19.489.078.004-.49 19.486zM205.725 153.958l-4.612 26.742z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M201.028 180.613l-4.196-10.767.06-.017 4.175 10.785z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M201.028 180.613l-7.009-42.608.099-.016 6.949 42.625zm4.638-26.722l-.037-.04 7.693-6.305.038.04z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M205.627 153.89l-11.589-15.865.06-.057 11.57 15.884z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M196.218 165.954l-.037-.04 9.448-12.063.037.04z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M196.832 169.846l-.672-3.913.06-.017.69 3.934z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M196.18 165.953l-8.613-4.263.042-.077 8.592 4.282z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M196.16 165.933l-2.121-27.947.058.022 2.141 27.928zm-16.346 14.449l-.058-.021 7.793-18.73.058.021z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M187.549 161.63l6.49-23.644.058.022-6.49 23.644z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M183.249 188.756l4.3-27.126.058.022-4.3 27.125z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M183.23 188.774l-3.474-8.413.059-.018 3.493 8.394z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M170.99 198.371l-.057-.022 8.823-17.988.058.02zM179.874 180.443l-12.334 45.239z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M159.392 235.215l-.058-.022 11.599-36.844.058.022z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M178.146 212.998l-7.215-14.61.06-.056 7.195 14.628zM171.058 198.435l2.001 37.217zM159.39 235.254l-.056-.06 8.097-9.633.057.061z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M172.94 235.594l-5.53-9.974.079-.036 5.492 9.973z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M167.488 225.622l-.057-.06 10.716-12.604.039.041z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M176.743 224.633l1.384-11.656.078.004-1.403 11.674z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M178.186 212.999l-.039-.041 8.197-9.725.038.041z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M205.967 232.037l-27.821-19.04.04-.037 27.82 19.04zM173.193 235.74l10.614-.597zM183.881 235.076l-7.118-10.423.04-.037 7.138 10.443z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M183.881 235.076l2.443-31.824.058.022-2.441 31.785zm-16.432-9.454l.001-.04 9.314-.968.018.06z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M159.262 235.6l-.037-.04 17.539-10.946.018.06z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M176.763 224.653l.02-.058L206.008 232l-.022.058zm9.58-21.38l-15.393-4.864.002-.079 15.413 4.884z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M186.041 204.121l-2.812-15.347.059-.018 2.831 15.368zM186.283 203.33l10.122 8.382-10.122-8.381z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#333",
  d: "M206.518 154.157a.911.911 0 01-.454.532.915.915 0 01-1.28-1.1.908.908 0 011.147-.58c.477.156.74.67.587 1.148zm12.308 14.21a.91.91 0 01-1.134.603.943.943 0 01-.55-1.114.907.907 0 011.154-.583c.438.166.67.646.53 1.094zm-21.775-2.167a.953.953 0 01-1.796-.633.882.882 0 01.445-.522.883.883 0 01.686-.042.856.856 0 01.665 1.197zm.67 3.953a.879.879 0 01-1.133.564.86.86 0 01-.589-1.115.913.913 0 01.663-.727.916.916 0 011.058 1.278zm-.47 19.468a.91.91 0 01-1.6.423.91.91 0 01-.12-.975.909.909 0 011.598-.424.913.913 0 01.122.976zm15.874-6.103a.91.91 0 01-1.153.583.917.917 0 01-.587-1.154.91.91 0 011.55-.323c.219.243.29.584.19.894zm-5.936 18.7a.917.917 0 01-1.152.603.925.925 0 01-.608-1.155.911.911 0 01.454-.532.911.911 0 01.7-.051c.47.16.736.658.607 1.136zm-5.29-21.318a.908.908 0 01-1.15.576.914.914 0 01-.584-1.15.908.908 0 011.146-.582.916.916 0 01.586 1.155zm-22.863 32.364a.907.907 0 01-1.153.583.914.914 0 01-.43-1.6.911.911 0 01.977-.118c.48.147.75.655.606 1.135zm5.716 22.099a.908.908 0 01-1.098.472.914.914 0 01-.624-1.023.936.936 0 011.134-.604.916.916 0 01.588 1.155zm22.104-3.059a.908.908 0 01-1.117.55.916.916 0 01-.624-1.083.907.907 0 011.134-.603c.47.16.736.657.608 1.135zm-9.485-20.4a.908.908 0 01-.782.643.912.912 0 01-.796-1.488.91.91 0 01.972-.29c.47.16.735.657.607 1.135zm-23.56 23.937a.905.905 0 01-.66.725.913.913 0 01-1.06-1.277.878.878 0 011.132-.563.855.855 0 01.539.43c.112.21.13.46.05.685zm10.308-46.8a.907.907 0 01-.662.725.914.914 0 01-1.059-1.276.909.909 0 011.599-.425.912.912 0 01.122.976zm48.278 34.995c-.157.476-.67.735-1.148.577s-.74-.672-.585-1.15a.908.908 0 011.146-.582.916.916 0 01.587 1.155zm-16.672 23.075a.906.906 0 01-1.152.583.914.914 0 01-.476-1.1.907.907 0 011.022-.62c.48.148.75.656.606 1.137zm28.75-58.476a.908.908 0 01-1.098.473.915.915 0 01-.623-1.024.935.935 0 011.134-.603.916.916 0 01.587 1.155zm13.38 13.136a.935.935 0 01-1.133.603.916.916 0 01-.587-1.155.907.907 0 011.598-.424.91.91 0 01.122.976zm-14.695-38.883a.91.91 0 01-1.599.423.91.91 0 01-.121-.975.879.879 0 011.132-.564.856.856 0 01.538.43c.112.212.13.46.051.686zm-18.897 38.921a.907.907 0 01-1.134.603.924.924 0 01-.607-1.155.918.918 0 011.153-.602.917.917 0 01.588 1.154zm-10.033-53.936a.911.911 0 01-.454.532.911.911 0 01-.7.051.915.915 0 01-.475-1.1.908.908 0 011.022-.62c.469.16.736.658.607 1.137zm-19.303-9.58a.904.904 0 01-1.152.582.883.883 0 01-.568-1.134.91.91 0 011.134-.604.917.917 0 01.587 1.155zm-6.47 23.625a.907.907 0 01-1.152.583.915.915 0 01.565-1.738.916.916 0 01.587 1.155zm-7.812 18.749a.91.91 0 01-1.149.577.917.917 0 01-.585-1.15.91.91 0 011.147-.582.915.915 0 01.587 1.155zm-8.767 18.049a.909.909 0 01-1.148.578.916.916 0 01-.585-1.15.908.908 0 011.146-.583.916.916 0 01.587 1.155zm15.335 4.842a.909.909 0 01-1.148.578.91.91 0 111.095-1.277c.11.218.129.468.053.699zm-9.6 21.361a.883.883 0 01-1.113.585.916.916 0 01-.727-.664.909.909 0 011.272-1.056.887.887 0 01.568 1.136zm-9.314.968a.85.85 0 01-1.114.584.916.916 0 01-.727-.664.91.91 0 011.274-1.055.885.885 0 01.567 1.135zm-8.075 9.613a.936.936 0 01-1.135.603.921.921 0 01-.534-.456.919.919 0 01-.053-.7.908.908 0 011.097-.472c.435.14.7.576.624 1.024z"
})), /*#__PURE__*/React.createElement("g", {
  opacity: 0.54
}, /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M234.016 274.204l5.352 15.968-.059.018-5.352-15.969z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M263.534 266.805l.037.04-24.204 23.366-.056-.06z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M263.534 266.805l.018.059-29.537 7.38-.039-.041z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M263.552 266.825l-2.556 21.11-.058-.02 2.576-21.091z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M286.353 255.173l.037.04-22.838 11.651-.018-.059z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M287.442 270.652l-.002.04-23.907-3.848v-.039z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M286.41 255.194l1.05 15.478h-.038l-1.07-15.46z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M286.392 255.174l20.039 22.096-.04.038-20.039-22.096zM287.337 270.746l18.978 6.62zM287.46 270.672l-.708 20.183-.06.017.73-20.2z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M287.46 270.672l-12.675 23.965-.058-.022 12.695-23.944z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M287.423 270.632l.017.06-26.464 17.263-.038-.04z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M263.552 266.825l11.233 27.812-.06.017-11.21-27.83z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M263.573 266.806l23.179 24.049-.04.037-23.18-24.048z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M286.713 290.852l.038.041-12.17 3.97-.016-.059zm-47.346-.641l-9.494 21.111-.058-.022 9.494-21.11z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M262.432 307.102l-.022.058-23.082-16.95.021-.058z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M260.959 287.896l.017.059-21.648 2.255.002-.04z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M260.996 287.936l1.455 19.186-.06.018-1.473-19.207z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M274.766 294.617l-.021.058-13.808-6.721.04-.038z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M260.978 287.916l16.7 20.82-.04.038-16.7-20.82z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M274.785 294.637l2.912 14.119-.078-.003-2.894-14.099z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M274.727 294.615l.038.04-12.316 12.507-.038-.041zM262.41 307.12l.038.04-10.798 9.767-.038-.04z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M262.411 307.12l-.001.04-32.557 4.181-.018-.06z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M251.634 316.868l-.022.06-21.759-5.587.021-.058zM251.112 315.41l18.656-3.082z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M251.671 316.909l-4.691 18.297-.059.018 4.672-18.317zm18.706-3.105l-.04.038-7.927-6.682.04-.038zM270.267 313.895l7.32-5.072zM287.978 314.566l-.021.059-10.319-5.851.04-.038z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M277.677 308.775l-8.346 15.388-.059-.022 8.367-15.406zm-7.3 5.067l-14.659 19.495-.038-.04 14.659-19.495zM270.406 313.902l-1.057 10.329z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M270.376 313.842l-11.855 36.934-.058-.023 11.855-36.932zm-14.696 19.455l.018.059-8.759 1.887.003-.038z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M255.738 333.318l2.783 17.458-.04-.002-2.801-17.438z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M268.222 327.542l.037.04-12.541 5.755-.038-.04z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M269.33 324.163l-1.09 3.4-.038-.002 1.07-3.42zm-1.069 3.38l5.163 6.952-.04.037-5.163-6.951z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M268.26 327.582l-9.74 23.194-.057-.023 9.739-23.192zm19.037-4.852l.038.04-13.913 11.764-.038-.04z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M273.422 334.534l-14.901 16.242-.058-.023 14.921-16.26z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M287.977 314.606l-14.555 19.928-.057-.022 14.575-19.947z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M287.998 314.586l-.662 8.146-.039-.002.622-8.146z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M301.764 311.926l.018.058-14.447 10.787-.038-.041z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M315.765 291.605l-28.43 31.166-.038-.041 28.43-31.125zm10.405-4.406l.038.04-24.406 24.727-.057-.022z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M302.015 297.316l-.213 14.65-.057-.022.19-14.63z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M315.44 281.392l-13.638 30.574-.057-.022 13.637-30.574zm10.73 5.807l.018.059-10.443 4.366.002-.039z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M315.441 281.353l.324 10.252h-.039l-.344-10.235z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M315.747 291.585l-.002.04-13.75 5.71-.039-.04z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M307.892 288.58l-5.898 8.755-.038-.04 5.899-8.754zm-5.936 8.714l.038.041-10.563 4.44-.017-.059z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M287.48 270.654l14.516 26.642-.041.038-14.533-26.663zm27.715 10.475l-.022.058-8.782-3.88.04-.037z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M306.45 277.29l1.445 11.252-.06.017-1.424-11.27z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M306.45 277.29l-14.999 24.466-.057-.022 14.999-24.465zm9.317 14.276l-.022.058-7.89-3.045.02-.058zM307.804 288.754l18.522-1.778z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M307.895 288.542l-.04.037-20.415-17.888.022-.057zm-16.442 13.175l10.35 10.21-.06.056-10.33-10.229z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M292.02 301.151l-4.043 13.455-.058-.022 4.06-13.434zm-5.268-10.296l4.7 10.862-.058.017-4.702-10.862z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#333",
  d: "M255.206 332.87a.8.8 0 011.154-.017.829.829 0 01.02 1.154.826.826 0 01-.858.31c-.324-.078-.57-.341-.625-.67s.09-.656.37-.834l-.06.057zm-4.18-16.532a.823.823 0 01.586-.24c.22 0 .43.088.587.245a.828.828 0 01-1.19 1.109.828.828 0 01.017-1.114zm16.608 10.655a.793.793 0 01.573-.254.807.807 0 01.581.238.803.803 0 01.02 1.153.8.8 0 01-1.154.016.828.828 0 01-.02-1.153zm1.071-3.42a.855.855 0 011.172.004.802.802 0 01-.018 1.152.772.772 0 01-1.133-.002.828.828 0 01-.02-1.154zm8.365-15.367a.8.8 0 011.154-.017.831.831 0 01.314.86c-.077.324-.34.569-.668.623s-.657-.093-.836-.373a.774.774 0 01.036-1.093zm-15.246-1.634a.854.854 0 011.249.045.797.797 0 01.02 1.154.802.802 0 01-1.154.016.831.831 0 01-.115-1.215zm12.254-12.41a.772.772 0 011.132.002.8.8 0 01.02 1.154.826.826 0 01-.858.311c-.323-.078-.569-.342-.624-.67s.09-.657.37-.835l-.04.038zm-4.308 19.11a.825.825 0 01.86-.31.828.828 0 01.255 1.505.828.828 0 01-1.174-.004.771.771 0 01.059-1.19zm31.599-16.527a.857.857 0 011.172.004.83.83 0 01.02 1.154.855.855 0 01-1.171-.004.829.829 0 01-.021-1.154zm4.475-20.024a.776.776 0 011.133.003.828.828 0 01.02 1.153.857.857 0 01-1.172-.003.803.803 0 01.019-1.153zm-18.99-6.618a.826.826 0 01.86-.312c.322.079.569.343.624.67a.825.825 0 01-.37.836.771.771 0 01-1.134-.002.835.835 0 01-.242-.602.824.824 0 01.263-.59zm-.728 20.2a.828.828 0 011.153-.015.797.797 0 01.02 1.153.803.803 0 01-1.153.016.829.829 0 01-.02-1.154zm28.688-9.5a.855.855 0 011.173.003.802.802 0 01-.019 1.152.77.77 0 01-1.133-.001.829.829 0 01-.02-1.154zm-27.35 33.334a.802.802 0 011.154-.016.83.83 0 01.021 1.154.83.83 0 01-1.052-.136.829.829 0 01-.061-1.059l-.061.057zm-24.518-47.881a.856.856 0 011.173.004.799.799 0 01-.019 1.153.779.779 0 01-1.133-.003.83.83 0 01-.02-1.154zm22.838-11.612a.83.83 0 11.93 1.332.829.829 0 01-.91-.178.805.805 0 01-.02-1.154zm-47.043 34.978a.828.828 0 011.154-.017.826.826 0 010 1.172.771.771 0 01-1.133-.001.83.83 0 01-.021-1.154zm-5.294-15.908a.827.827 0 011.172.005.778.778 0 01.247.567.765.765 0 01-.246.565.793.793 0 01-.573.254.807.807 0 01-.581-.237.829.829 0 01-.02-1.154zm-4.2 37.058a.829.829 0 11.254 1.504.833.833 0 01-.625-.67.824.824 0 01.37-.834zm31.042-23.312a.773.773 0 011.133.003.83.83 0 01.02 1.154.857.857 0 01-1.172-.004.805.805 0 01.019-1.153zm-13.935 47.195a.827.827 0 01.903-.204.833.833 0 01.53.76.826.826 0 01-1.413.598.801.801 0 01-.02-1.154zm11.56 15.55a.827.827 0 01.859-.31c.323.078.569.342.625.67s-.09.657-.37.835a.776.776 0 01-1.134-.003.803.803 0 01.02-1.19zm14.883-16.261a.857.857 0 011.173.004.799.799 0 01-.019 1.153.776.776 0 01-1.134-.003.83.83 0 01-.02-1.154zm13.933-11.782a.856.856 0 011.172.004.802.802 0 01-.019 1.153.827.827 0 01-1.152.016.856.856 0 010-1.173zm14.466-10.766a.829.829 0 011.153-.016.857.857 0 010 1.172.802.802 0 01-1.152-.023.78.78 0 01-.248-.567c0-.214.089-.42.247-.566zm-10.37-10.23a.829.829 0 011.154-.016.83.83 0 01.314.86.824.824 0 01-.668.623.832.832 0 01-.836-.373.83.83 0 01.036-1.094zm16.498-13.114a.832.832 0 011.172.003.772.772 0 01.001 1.134.83.83 0 01-1.112-1.193l-.06.056zm7.835 2.984a.826.826 0 01.858-.311.828.828 0 01.255 1.505.773.773 0 01-1.133-.003.83.83 0 01.02-1.191zm10.443-4.366a.829.829 0 011.154-.017.859.859 0 010 1.174.8.8 0 01-1.153-.024.772.772 0 01-.001-1.134z"
})), /*#__PURE__*/React.createElement("g", {
  opacity: 0.81
}, /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M262.346 237.797l5.353 15.969-.06.017-5.351-15.968z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M291.846 230.377l.038.041-24.205 23.366-.038-.04z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M291.846 230.377l.018.06-29.538 7.38-.017-.06z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M291.904 230.4l-2.596 21.11-.039-.003 2.557-21.11z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M314.704 218.748l.017.059-22.837 11.611-.038-.04z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M315.774 234.207l-.003.078-23.907-3.848.02-.058z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M314.742 218.788l1.07 15.46-.079-.004-1.05-15.477z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M314.723 218.767l20.06 22.078-.04.037-20.06-22.077zM315.662 234.339l18.985 6.6zM315.812 234.247l-.728 20.2-.08-.002.73-20.201z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M315.792 234.266l-12.677 23.964-.057-.021 12.675-23.965z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M315.754 234.225l.038.04-26.504 17.263-.017-.059z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M291.904 230.4l11.213 27.79-.06.019-11.212-27.792z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M291.885 230.38l23.18 24.047-.041.038-23.18-24.048z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M315.045 254.407l.018.06-12.149 3.951-.037-.04zm-47.366-.623l-9.475 21.131-.038-.04 9.475-21.132z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M290.763 270.695l-.04.038-23.083-16.95.04-.038z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M289.289 251.489v.039l-21.63 2.275.002-.078z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M289.308 251.51l1.474 19.206-.078-.004-1.435-19.205z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M303.098 258.171l-.022.057-13.788-6.7.021-.058z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M289.329 251.49l16.68 20.84-.06.016-16.7-20.82z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M303.096 258.21l2.913 14.12-.06.016-2.891-14.137z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M303.058 258.209l.057.021-12.354 12.505-.038-.041zm-12.335 12.485l.038.04-10.798 9.767-.038-.04z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M290.744 270.675l.017.06-32.557 4.18-.017-.06zM258.075 274.976l21.767 5.58zM298.69 277.378l-.002.038-18.725 3.085-.017-.06z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M279.983 280.482l-4.671 18.317-.06-.022 4.673-18.316zm18.707-3.104l-.022.057-7.945-6.702.04-.038z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M305.951 272.308l.038.04-7.282 5.088-.056-.06z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M316.29 278.14l-.02.057-10.301-5.83.021-.058z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M306.01 272.33l-8.368 15.405-.037-.04 8.365-15.367zm-7.303 5.106l-14.657 19.495-.038-.041 14.639-19.515zM298.737 277.487l-1.057 10.329z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M298.708 277.397L286.85 314.37l-.057-.022 11.876-36.951zm-14.677 19.474l.019.06-8.759 1.887-.018-.06z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M284.05 296.892l2.803 17.437-.06.018-2.802-17.438z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M296.534 291.115l.037.04-12.521 5.776-.019-.06zm1.129-3.399l-1.071 3.42-.058-.02 1.05-3.402z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M296.573 291.116l5.162 6.952-.04.037-5.163-6.951z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M296.592 291.137l-9.74 23.232-.058-.022 9.74-23.232zM301.658 298.14L315.6 286.36l-13.942 11.781z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M301.734 298.107l-14.883 16.262-.037-.04 14.882-16.262zm14.574-19.908l-14.574 19.908-.038-.04 14.574-19.909z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M316.31 278.16l-.644 8.165-.057-.022.641-8.126z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M330.076 275.498l.056.061-14.466 10.766-.037-.04z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M344.096 255.2l-28.43 31.125-.037-.04 28.429-31.127zm10.386-4.428l.038.04-24.388 24.747-.056-.06z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M330.326 260.889l-.212 14.65-.039-.002.212-14.649z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M343.752 244.965l-13.638 30.574-.058-.022 13.638-30.574zm10.73 5.807l.038.04-10.424 4.387-.038-.04z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M343.771 244.946l.346 10.234-.079-.003-.325-10.213z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M344.058 255.158l.038.041-13.79 5.709-.017-.06z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M336.225 252.135l-5.899 8.754-.058-.021 5.9-8.755z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M330.289 260.848l.017.06-10.542 4.42-.038-.04z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M315.793 234.227l14.533 26.662-.058.017-14.516-26.642zm27.714 10.475l-.002.039-8.763-3.859.021-.058z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M334.782 240.845l1.443 11.29-.06.017-1.442-11.29z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M334.78 240.884l-15.016 24.445-.038-.04 14.997-24.427zm9.318 14.275l-.04.038-7.873-3.024.02-.058z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M354.745 250.528l.017.059-18.557 1.567-.018-.06z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M336.206 252.115l-.04.037-20.414-17.888.04-.037zm-16.441 13.175l10.35 10.21-.02.058-10.37-10.23z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M320.35 264.744l-4.022 13.436-.058-.022 4.022-13.435zm-5.285-10.317l4.7 10.863-.04.038-4.701-10.863z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#333",
  d: "M283.424 296.341a.832.832 0 01.586-.242c.22.002.431.09.587.246a.773.773 0 01.001 1.134.83.83 0 01-1.114-1.194l-.06.056zm-3.992-16.328a.802.802 0 011.154-.016.803.803 0 01.02 1.153.828.828 0 01-1.153.017.797.797 0 01-.02-1.154zm16.533 10.573a.8.8 0 011.154-.016.828.828 0 01.02 1.153.856.856 0 01-1.173-.003.77.77 0 01-.001-1.134zm1.07-3.42a.801.801 0 011.155-.016.83.83 0 01.02 1.154.805.805 0 01-.572.253.805.805 0 01-.582-.237.803.803 0 01-.02-1.154zm8.368-15.406a.772.772 0 011.133.003.799.799 0 01.02 1.153.828.828 0 01-1.153.017.858.858 0 010-1.173zm-15.324-1.676a.802.802 0 011.154-.016.828.828 0 01.02 1.153.855.855 0 01-1.172-.003.78.78 0 01-.248-.568.765.765 0 01.246-.566zm12.41-12.444a.856.856 0 011.174.005.8.8 0 01-.02 1.152.774.774 0 01-1.133-.003.83.83 0 01-.02-1.154zm-4.408 19.207a.828.828 0 01.903-.205.828.828 0 11-.882 1.358.83.83 0 01-.02-1.154zm31.638-16.527a.779.779 0 011.134.002.804.804 0 01.02 1.154.829.829 0 11-1.114-1.194l-.04.037zm4.455-20.006a.856.856 0 011.154-.016.834.834 0 010 1.173.773.773 0 01-1.133-.003.83.83 0 01-.02-1.154zm-18.988-6.618a.829.829 0 011.113 1.194.828.828 0 01-1.173-.004.775.775 0 01.06-1.19zm-.73 20.2a.803.803 0 011.175-.074.828.828 0 01.02 1.154.855.855 0 01-1.172-.003.774.774 0 01-.023-1.076zm28.69-9.501a.803.803 0 011.153-.016.83.83 0 01.02 1.154.803.803 0 01-1.153.016.8.8 0 01-.02-1.154zm-27.463 33.214a.832.832 0 011.172.003.77.77 0 01.001 1.134.829.829 0 01-1.051-.135.828.828 0 01-.061-1.058l-.061.056zm-24.406-47.76a.826.826 0 01.903-.204c.314.122.524.423.53.76a.825.825 0 01-1.412.598.808.808 0 01-.255-.574.795.795 0 01.234-.58zm22.84-11.651a.8.8 0 011.152.023.828.828 0 01.02 1.153.828.828 0 01-1.171-.043.829.829 0 01.039-1.17l-.04.037zm-47.044 35.017a.799.799 0 011.153-.016.828.828 0 11-1.19 1.108.773.773 0 01.037-1.092zm-5.353-15.968a.805.805 0 01.572-.254.806.806 0 01.582.238.83.83 0 01.02 1.154.856.856 0 01-1.154.016.802.802 0 01-.02-1.154zm-4.142 37.078a.834.834 0 011.173.004.776.776 0 01.001 1.134.805.805 0 01-.572.254.805.805 0 01-.581-.238.83.83 0 01-.02-1.154zm31.124-23.385a.826.826 0 01.858-.311c.324.078.57.341.625.67s-.09.657-.37.834a.772.772 0 01-1.133-.002.828.828 0 01.02-1.191zm-13.997 47.29a.77.77 0 011.133.002.829.829 0 01.02 1.154.855.855 0 01-1.172-.004.802.802 0 01.019-1.152zm11.52 15.549a.856.856 0 011.174.004.772.772 0 01.001 1.134.805.805 0 01-.573.253.809.809 0 01-.58-.237.83.83 0 01-.021-1.154zm14.94-16.201a.826.826 0 01.859-.311c.323.078.57.342.624.67a.825.825 0 01-1.421.7.83.83 0 01-.062-1.06zm13.895-11.823a.829.829 0 011.154-.016.859.859 0 010 1.173.802.802 0 01-1.152-.023.774.774 0 01-.001-1.134zm14.43-10.805a.827.827 0 011.152-.017.799.799 0 01.02 1.153.793.793 0 01-.573.254.807.807 0 01-.58-.237.797.797 0 01-.02-1.153zm-10.334-10.19a.806.806 0 011.155-.016.828.828 0 01.02 1.153.857.857 0 01-1.173-.003.78.78 0 01-.247-.568c0-.216.089-.42.246-.566zm16.463-13.194a.776.776 0 011.133.002.826.826 0 01-.565 1.432.83.83 0 01-.568-1.434zm7.87 3.064a.8.8 0 011.155-.017.828.828 0 11-1.19 1.109.774.774 0 01.036-1.092zm10.344-4.312a.827.827 0 01.902-.204.827.827 0 11-.882 1.358.797.797 0 01-.02-1.154z"
})), /*#__PURE__*/React.createElement("g", {
  opacity: 0.12
}, /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M200.315 223.348l5.351 15.968-.059.017-5.333-15.947z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M229.832 215.949l.038.04-24.204 23.366-.038-.041z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M229.832 215.949l.018.06-29.537 7.378-.038-.04z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M229.87 215.99l-2.575 21.09-.058-.021 2.575-21.092z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M252.67 204.337l.038.04-22.858 11.631-.018-.06z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M253.74 219.796l-.001.04-23.908-3.848v-.04zM252.763 204.438l1.062 15.465zM252.71 204.338l20.02 22.076-.02.018-20.04-22.056z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M272.73 226.414l-.001.039-18.99-6.618.021-.058zM253.846 219.87l-.72 20.205z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M253.779 219.837L241.102 243.8l-.077-.042 12.695-23.944z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M253.74 219.796l.039.04-26.505 17.263-.017-.06z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M229.871 215.95l11.212 27.83-.059.018-11.212-27.83z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M229.871 215.95L253.051 240l-.04.037-23.18-24.048z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M253.012 239.997l.037.04-12.169 3.97-.017-.059zm-47.346-.642l-9.495 21.11-.058-.02 9.494-21.112zM205.552 239.414l23.087 16.938z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M227.257 237.04l.017.059-21.648 2.255.002-.04z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M227.295 237.08l1.454 19.186-.06.018-1.472-19.207z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M241.064 243.76l-.022.058-13.788-6.7.022-.059z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M227.276 237.06l16.7 20.82-.04.037-16.7-20.82zM241.151 243.871l2.898 14.107z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M241.025 243.759l.057.06-12.334 12.487-.038-.041zm-12.315 12.506l.038.04-10.798 9.767-.038-.04z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M228.73 256.246l-.002.079-32.577 4.16.022-.058zM196.088 260.493l21.744 5.672zM217.712 264.636l18.656-3.081z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M217.97 266.053l-4.673 18.317-.058-.022 4.653-18.297zm18.705-3.106l-.04.038-7.927-6.68.041-.039zM236.482 262.851l7.555-4.717zM254.277 263.71l-.022.059-10.319-5.852.04-.037z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M243.975 257.92l-8.346 15.386-.058-.021 8.367-15.406zm-7.3 5.066l-14.64 19.516-.056-.06 14.658-19.496z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M236.694 262.968l-1.065 10.338-.058-.021 1.046-10.32z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M236.675 262.986l-11.856 36.933-.039-.001 11.837-36.953zm-14.678 19.475v.039l-8.72 1.889-.018-.06z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M222.037 282.462l2.802 17.438-.059.018-2.802-17.439z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M234.52 276.686l.038.04-12.541 5.756-.038-.04z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M235.629 273.306l-1.071 3.42-.058-.021 1.07-3.42z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M234.56 276.687l5.162 6.951-.04.038-5.163-6.952z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M234.558 276.726l-9.74 23.193-.038-.001 9.74-23.232zM239.587 283.754l13.93-11.796z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M239.72 283.678l-14.882 16.261-.038-.04 14.883-16.261z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M254.294 263.77l-14.573 19.908-.058-.022 14.574-19.947z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M254.296 263.73l-.643 8.166-.057-.022.64-8.126z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M268.062 261.069l.019.06-14.448 10.785-.018-.059z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M282.083 240.77l-28.43 31.126-.057-.022 28.449-31.145zm10.386-4.427l.038.04L268.1 261.11l-.038-.041z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M268.313 246.46l-.213 14.65-.057-.023.191-14.63z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M281.738 230.535L268.1 261.11l-.057-.023 13.637-30.573zm10.731 5.808l.038.04-10.445 4.406-.017-.06z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M281.758 230.517l.306 10.232-.04-.001-.344-10.234z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M282.045 240.729l.017.06-13.77 5.69-.037-.04z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M274.191 237.725l-5.899 8.753-.037-.04 5.899-8.753zm-5.936 8.713l.037.04-10.562 4.44-.018-.059z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M253.78 219.798l14.514 26.642-.04.038-14.534-26.663zm27.713 10.475l-.022.058-8.742-3.878v-.039z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M272.749 226.435l1.443 11.25-.058.018-1.424-11.27z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M272.749 226.435l-15 24.465-.037-.04 14.979-24.448zm9.316 14.275l-.022.058-7.89-3.045.021-.057z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M292.732 236.098l-.022.058-18.519 1.569-.017-.06z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M274.192 237.685l-.04.038-20.413-17.888.04-.037zm-16.44 13.176l10.35 10.21-.04.037-10.351-10.21z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M258.317 250.295l-4.02 13.435-.08-.002 4.061-13.434zm-5.267-10.296l4.701 10.862-.06.017-4.7-10.862z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#333",
  d: "M221.41 281.912a.83.83 0 11.93 1.332.83.83 0 01-.91-.178.804.804 0 01-.02-1.154zm-4.147-16.335a.799.799 0 011.153-.015.831.831 0 01.314.86.824.824 0 01-.668.622.834.834 0 01-.836-.373.774.774 0 01.037-1.094zm16.67 10.56a.83.83 0 011.173.004.774.774 0 01.001 1.134.805.805 0 01-.573.253.805.805 0 01-.581-.238.83.83 0 01-.02-1.154zm1.071-3.42a.882.882 0 011.172.004c.31.33.309.843 0 1.173a.798.798 0 01-1.152-.024.828.828 0 01-.02-1.153zm8.445-15.442a.8.8 0 011.154-.017.828.828 0 01.02 1.154.856.856 0 01-1.172-.004.78.78 0 01-.248-.567.767.767 0 01.246-.566zm-15.327-1.559a.826.826 0 011.174.004.778.778 0 01.247.567c0 .215-.09.42-.247.566a.8.8 0 01-1.154.016.828.828 0 01-.02-1.153zm12.354-12.505a.775.775 0 011.248.085.797.797 0 01.02 1.154.826.826 0 01-.858.31c-.323-.078-.569-.341-.624-.67s.09-.656.37-.834l-.156-.045zm-4.408 19.206a.828.828 0 01.909-.202.834.834 0 01.525.773.825.825 0 01-1.431.563.776.776 0 01-.002-1.134zm31.638-16.526a.771.771 0 011.134.002.83.83 0 01.02 1.154.856.856 0 01-1.173-.005.802.802 0 01.019-1.151zm4.436-20.026a.828.828 0 011.153-.017.858.858 0 010 1.173.826.826 0 01-.858.311c-.323-.078-.569-.342-.625-.67s.09-.657.37-.834l-.04.037zm-18.949-6.656a.855.855 0 011.172.004.8.8 0 01-.018 1.152.772.772 0 01-1.133-.002.828.828 0 01-.02-1.154zm-.769 20.239a.823.823 0 011.173.004.773.773 0 010 1.133.799.799 0 01-1.153.016.828.828 0 01-.02-1.153zm28.707-9.482a.828.828 0 011.154-.016.8.8 0 01-.018 1.152.775.775 0 01-1.134-.002.776.776 0 01-.001-1.134zM253.67 263.18a.826.826 0 01.903-.204.833.833 0 01.53.76.826.826 0 01-1.412.598.802.802 0 01-.02-1.154zm-24.424-47.78a.856.856 0 011.172.003.798.798 0 01-.019 1.153.765.765 0 01-.566.245.779.779 0 01-.567-.247.829.829 0 01-.02-1.154zm22.838-11.613a.83.83 0 011.113 1.195.825.825 0 01-.859.31.828.828 0 01-.255-1.505zm-47.043 34.978a.856.856 0 011.172.004.775.775 0 01.001 1.134.8.8 0 01-1.154.016.83.83 0 01-.02-1.153zm-5.352-15.967a.832.832 0 011.173.004.778.778 0 01.247.567.765.765 0 01-.246.566.8.8 0 01-1.154.016.828.828 0 01-.02-1.153zm-4.141 37.078a.827.827 0 011.152-.016.828.828 0 01-.55 1.432.834.834 0 01-.778-.507.826.826 0 01.176-.909zm31.141-23.366a.772.772 0 011.134.003.828.828 0 01.02 1.153.856.856 0 01-1.173-.003.799.799 0 01.019-1.153zM212.652 283.8a.828.828 0 011.153-.016c.16.148.253.356.256.573a.796.796 0 01-.235.581.803.803 0 01-1.153.016.83.83 0 01-.02-1.154zm11.56 15.55a.826.826 0 01.859-.31.828.828 0 01.255 1.505.773.773 0 01-1.133-.003.803.803 0 01.02-1.192zm14.902-16.24a.829.829 0 011.154-.017.858.858 0 010 1.172.804.804 0 01-1.152-.023.78.78 0 01-.248-.567.765.765 0 01.246-.566zm13.914-11.803a.856.856 0 011.173.004.799.799 0 01-.019 1.153.776.776 0 01-1.134-.003.828.828 0 01-.02-1.154zm14.466-10.766a.828.828 0 011.153-.017.858.858 0 010 1.174.804.804 0 01-1.152-.023.78.78 0 01-.247-.568.765.765 0 01.246-.566zm-10.37-10.23a.83.83 0 011.172.003.78.78 0 01.003 1.135.801.801 0 01-1.154.016.83.83 0 01-.02-1.154zm16.52-13.21a.768.768 0 01.573-.268.78.78 0 01.582.25.828.828 0 01.02 1.154.855.855 0 01-1.172-.004.78.78 0 01-.248-.567.765.765 0 01.246-.566zm7.87 3.14a.857.857 0 011.172.004c.15.15.235.355.236.568a.795.795 0 01-.234.565.803.803 0 01-1.154.016.829.829 0 01-.02-1.153zm10.386-4.426a.829.829 0 011.154-.016.856.856 0 01.02 1.153.832.832 0 01-1.172-.003.78.78 0 01-.248-.568c0-.215.088-.42.246-.566z"
})), /*#__PURE__*/React.createElement("g", {
  opacity: 0.3
}, /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M324.37 238.978l4.058-26.9.098-.016-4.06 26.939z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M276.334 227.894l-.037-.079 52.171-15.774.037.08zM276.276 227.698l48.016 11.573-48.016-11.573z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M276.259 227.813l19.273-28.452.077.042-19.255 28.473z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M234.755 227.777l.003-.078 41.56.097-.023.097z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M244.587 204.725l.06-.057 31.69 23.148-.06.057z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M234.698 227.716l9.871-23.052.076.043-9.85 23.032z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M234.718 227.736l-12.683-46.548.1-.016 12.66 46.567z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M222.054 181.208l.061-.057 22.532 23.517-.06.057z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M244.57 204.664l15.933-28.515.076.042-15.934 28.516z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M244.589 204.646l35.988-25.123.036.08-35.987 25.122z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M244.626 204.725l.002-.078 50.944-5.324.017.099z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M276.257 227.853l4.3-48.311.096.023-4.298 48.271z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M276.257 227.853l-15.774-51.685.098-.016 15.774 51.684z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M260.52 176.208l.023-.097 20.468 3.272-.002.078zm67.93 35.813l29.266-23.395.037.079-29.248 23.415z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M307.583 170.683l.08-.036 20.845 41.396-.08.036z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M295.55 199.421l.041-.077 32.898 12.678-.024.097z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M295.532 199.361l12.052-28.717.077.042-12.052 28.717z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M280.556 179.58l.079-.035 14.976 19.82-.08.036z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M295.53 199.4l-8.757-42.3.078.003 8.76 42.261zM286.875 156.463l-6.184 22.37z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M280.613 179.603l-.036-.08 27.027-8.898.036.08z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M307.64 170.705l-.036-.08 22.793-6.121.016.098zM307.557 170.696l50.096 18.057z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M330.374 164.6l.081-.075 27.3 24.102-.042.076z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M301.081 155.22l.04-.076 29.295 9.38-.023.097z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M330.377 164.522l20.241-22.885.057.06-20.241 22.886zM301.148 155.255l6.523 15.469zM286.81 157.14l.003-.078 14.27-1.92.017.099z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M276.184 141.136l.098-.056 10.55 16.002-.06.057z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M286.775 157.06l23.431-15.987.037.08-23.393 15.988zm14.308-1.918l35.513-17.263.054.1-35.53 17.243z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M301.063 155.161l9.124-14.07.076.043-9.123 14.07z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M301.063 155.161l44.347-44.419.056.061-44.346 44.42zm35.55-17.184l.021-.097 14.044 3.74-.023.096z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M336.575 137.898l8.814-27.137.097.024-8.834 27.154z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M314.287 137.04l-.016-.097 22.363.937-.022.097z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M310.187 141.092l4.064-4.131.057.06-4.065 4.132z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M314.25 137l-2.336-13.824.079.003 2.335 13.824z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M314.251 136.961l31.159-26.219.056.061-31.158 26.219zm-31.09-7.062l.003-.077 28.79-6.684-.002.079z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M311.936 123.117l33.494-12.393.036.08-33.514 12.413z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M276.205 141.078l35.71-17.942.058.062-35.712 17.94zM283.234 129.948l-6.93 11.248zM254.333 134.764l.003-.078 28.828-4.864-.003.077zM219.09 153.774l64.007-23.84-64.007 23.84z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M200.89 152.368l-.016-.099 53.443-17.603.055.1z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M243.206 155.62l11.09-20.935.096.062-11.09 20.935z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M212.075 168.647l42.221-33.962.076.081-42.24 33.942zm-11.224-16.28l.023-.098 18.303 1.395-.023.096z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M212.075 168.647l7.043-14.966.076.042-7.042 14.966zM219.064 153.787l24.095 1.917zM228.277 163.866l14.949-8.265.056.1-14.969 8.245zM242.857 156.81l18.598 1.47z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M244.568 204.704l-1.343-49.064.078.002 1.363 49.046zm-32.316-35.503l.06-.057 9.803 12.007-.06.057z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M222.055 181.17l6.202-17.285.077.042-6.202 17.284z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M222.075 181.15l39.668-24.127.037.079-39.668 24.128zm-2.94-27.41l.061-.056 9.12 10.184-.06.056z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M200.319 152.522l.041-.077 27.956 11.423-.042.076zM228.378 163.926l16.304 40.809zM261.722 157.08l-7.426-22.356.097-.016 7.408 22.336z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M260.478 157.445l15.727-16.367.056.06-15.726 16.368zm.005 18.723l1.22-19.108.097.024-1.22 19.068z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#333",
  d: "M337.017 139.301c-.334.107-.7.077-1.013-.085a1.325 1.325 0 01-.658-.778c-.201-.68.18-1.395.855-1.604a1.302 1.302 0 011.621.836c.224.674-.136 1.4-.804 1.63zm-6.214 26.527a1.33 1.33 0 01-1.586-.871 1.322 1.322 0 012.115-1.424c.378.321.546.827.435 1.311a1.321 1.321 0 01-.964.984zm-16.126-27.562a1.329 1.329 0 01-.835-2.512 1.33 1.33 0 011.799 1.529c-.11.483-.483.863-.964.983zm-4.045 4.113a1.33 1.33 0 01-1.672-.824 1.32 1.32 0 011.522-1.794c.483.113.863.487.986.967a1.292 1.292 0 01-.836 1.65zm-23.413 16.007a1.358 1.358 0 01-1.672-.862 1.322 1.322 0 01.866-1.583 1.331 1.331 0 011.643.756c.225.7-.145 1.448-.837 1.689zm20.812 13.545a1.33 1.33 0 01-1.587-.873 1.322 1.322 0 012.115-1.421c.378.32.547.827.435 1.31a1.32 1.32 0 01-.963.984zm-27.028 8.898a1.33 1.33 0 01-1.671-.863 1.32 1.32 0 01.865-1.582 1.328 1.328 0 011.643.756c.225.699-.145 1.448-.837 1.688zm20.506-24.38a1.33 1.33 0 01-1.673-.825 1.322 1.322 0 011.522-1.794c.484.114.864.486.987.968a1.299 1.299 0 01-.836 1.65zm-57.858.457a1.304 1.304 0 01-1.652-.842c-.12-.33-.097-.695.061-1.008.16-.312.44-.545.776-.642a1.314 1.314 0 011.69 1.52c-.095.457-.43.828-.875.972zm-21.15 25.55c-.458.189-.984.104-1.363-.217a1.333 1.333 0 01-.436-1.312c.111-.483.484-.863.964-.984a1.331 1.331 0 011.586.872c.22.66-.108 1.376-.75 1.64zm22.514 23.496c-.68.2-1.396-.184-1.608-.862a1.294 1.294 0 01.83-1.618c.674-.22 1.401.14 1.635.81.108.337.08.702-.081 1.014-.161.314-.44.55-.777.655zm15.933-28.516a1.327 1.327 0 01-1.67-.864 1.32 1.32 0 01.865-1.582 1.331 1.331 0 011.643.757c.226.699-.146 1.447-.838 1.689zm-48.427-7.502a1.271 1.271 0 01-1.653-.843 1.297 1.297 0 01.818-1.67 1.33 1.33 0 011.61.919 1.294 1.294 0 01-.775 1.594zm64.13-27.57a1.357 1.357 0 01-1.691-.843c-.23-.694.145-1.44.838-1.67a1.33 1.33 0 011.675.836 1.321 1.321 0 01-.822 1.677zm.054 86.736a1.277 1.277 0 01-1.654-.842 1.3 1.3 0 01.073-1.002 1.29 1.29 0 01.764-.648 1.314 1.314 0 011.69 1.52c-.095.457-.429.828-.873.973zm-41.54-.116a1.301 1.301 0 01-1.628-.842 1.294 1.294 0 01.826-1.63 1.303 1.303 0 011.638.822 1.322 1.322 0 01-.837 1.65zm93.729-15.637a1.328 1.328 0 01-1.8-1.53c.111-.482.484-.863.965-.983a1.33 1.33 0 011.673.823 1.35 1.35 0 01-.838 1.69zm-4.058 26.898a1.33 1.33 0 01-1.673-.823c-.19-.46-.108-.985.212-1.363a1.323 1.323 0 011.31-.431c.484.112.864.487.987.968a1.292 1.292 0 01-.837 1.65zm33.306-50.314a1.33 1.33 0 01-1.8-1.529c.112-.482.484-.862.965-.984a1.33 1.33 0 011.585.872c.22.661-.108 1.377-.75 1.641zm-62.164 10.716a1.33 1.33 0 01-1.585-.87 1.322 1.322 0 012.115-1.424c.378.322.546.828.434 1.31a1.319 1.319 0 01-.964.985zm55.087-57.723a1.333 1.333 0 01-1.674-.824 1.321 1.321 0 011.522-1.794c.484.112.865.486.987.967a1.292 1.292 0 01-.836 1.65zm-5.153-30.834c-.458.19-.984.104-1.363-.217a1.333 1.333 0 01-.436-1.312c.11-.482.484-.862.964-.984a1.331 1.331 0 011.586.872 1.32 1.32 0 01-.751 1.641zm-33.532 12.353a1.329 1.329 0 01-1.672-.823 1.317 1.317 0 01.856-1.668 1.303 1.303 0 011.653.842 1.27 1.27 0 01-.837 1.649zm-28.81 6.703a1.326 1.326 0 01-1.672-.863 1.32 1.32 0 01.866-1.583 1.331 1.331 0 011.643.757 1.349 1.349 0 01-.837 1.689zm-28.81 4.846a1.33 1.33 0 01-1.931-1.526 1.32 1.32 0 011.135-.947 1.331 1.331 0 011.586.872c.22.66-.109 1.377-.751 1.64l-.038-.04zm7.409 22.336a1.271 1.271 0 01-1.652-.844 1.294 1.294 0 01.817-1.668c.336-.108.7-.079 1.014.084.313.162.55.442.657.778a1.297 1.297 0 01-.836 1.65zm-33.466 6.844a1.332 1.332 0 01-1.671-.863 1.32 1.32 0 01.865-1.582 1.33 1.33 0 011.643.756c.225.7-.145 1.448-.837 1.689zm-9.08-10.261a1.33 1.33 0 01-1.584-.871 1.322 1.322 0 012.114-1.423c.378.321.547.827.435 1.31-.11.483-.483.864-.964.984zm-18.343-1.317a1.328 1.328 0 01-1.671-.864 1.294 1.294 0 01.836-1.649 1.329 1.329 0 011.673.824 1.35 1.35 0 01-.838 1.689z"
})), /*#__PURE__*/React.createElement("g", {
  opacity: 0.87
}, /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M170.021 200.524l-17.559 24.47-.094-.063 17.576-24.449z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M211.922 235.714l-.022.097-59.496-10.8.022-.097zM169.912 200.539l41.907 35.281z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M211.938 235.813l-33.377 18.3-.055-.1 33.377-18.3z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M211.862 235.855l41.02 21.049-41.02-21.05z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M231.602 274.526l-.08.037-19.641-38.772.1-.055z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M252.941 256.86l-21.36 17.724-.055-.1 21.359-17.685z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M252.961 256.841l-10.937 52.23-.097-.024 10.937-52.229z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M242.026 309.032l-.119.034-10.403-34.524.098-.016zM202.606 294.762l30.153-20.176-30.153 20.176z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M231.56 274.603l-48.23 6.576-.016-.098 48.25-6.595zM178.467 254.07l52.997 20.566z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M211.958 235.794l-28.569 45.368-.115-.043 28.589-45.387z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M211.96 235.755l-10.473 58.871-.097-.023 10.473-58.87z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M201.47 294.568l-.081.075-18.565-13.522.062-.094zm-49.048-69.537l-40.724 8.279-.017-.098 40.706-8.299z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M152.189 276.246l-.098.016.274-51.292.079.004z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M178.564 254.035l-.08.075-26.12-29.1.081-.076z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M178.561 254.113l-26.393 22.19-.076-.08 26.393-22.191z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M183.39 281.123l-.118.035-4.787-27.087.097-.016z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M178.562 254.073l-12.647 46.07-.077-.041 12.628-46.052z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M183.369 281.18l-17.454 18.963-.096-.062 17.475-18.98z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M183.333 281.1l-.002.08-31.203-4.878.023-.096z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M152.151 276.206l-.023.096-25.592-5.492.022-.097z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M152.17 276.226l-.08.075-40.432-42.992.081-.076z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M126.596 270.754l-.1.055-14.836-37.54.099-.016zM126.492 270.795l24.182 24.063z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M126.555 270.83L94.997 283.16l-.016-.099 31.557-12.328zm24.276 23.972l-.097-.024 1.357-18.516.098-.016z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M165.88 300.063l-.024.097-15.105-5.322.062-.095z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M168.305 321.181l-.098.016-2.388-21.077.098-.016z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M165.875 300.18l-31.181 3.919-.017-.098 31.202-3.938zm-15.084-5.34l-43.8-.923-.017-.098 43.8.922z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M150.81 294.82l-16.096 9.26-.075-.08 16.115-9.24z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M150.79 294.84l-66.21 21.376-.016-.099 66.21-21.376zm-43.776-1.02l-.063.096-11.992-10.759.061-.095z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M107.01 293.898L84.6 316.197l-.057-.06 22.411-22.3zM106.878 293.92l21.61 12.185zM134.694 304.099l-6.085 2.004-.055-.099 6.105-2.023z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M128.65 306.066l-4.693 14.78-.097-.024 4.692-14.78z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M128.609 306.103l-44.03 10.113-.015-.099 44.029-10.112zm27.134 22.63l-.022.098-31.804-7.948.023-.097z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M123.917 320.883l-39.338-4.667-.015-.099 39.356 4.688zM123.852 320.888l44.352.365-44.352-.365zM168.283 321.24l-12.503 7.572-.075-.08 12.523-7.593z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M186.666 338.486l-.023.096-30.922-9.751.043-.117z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M230.994 337.63l-75.253-8.818.002-.079 75.274 8.8zm17.396 10.487l-.024.097-61.703-9.65.003-.078z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M208.187 323.562l-21.484 15.003-.076-.08 21.524-15.003z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M245.532 326.455l-58.85 12.13-.016-.099 58.831-12.149zm2.877 21.682l-.063.096-17.352-10.604.023-.097z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M245.552 326.437l-14.519 11.194-.055-.1 14.499-11.174z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M231.017 337.532l-.023.097-22.846-14.068.042-.077z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M227.121 323.006l-18.954.575.004-.117 18.954-.576z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M208.19 323.484l-.042.077-17.583-10.73.062-.095z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M231.601 274.565l-23.393 48.978-.077-.042 23.374-48.998zm14.05 51.25l-.098.016-3.646-16.765.12-.034z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M242.004 309.089l-14.842 13.88-.076-.082 14.843-13.879z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M241.984 309.108l-51.38 3.725-.016-.098 51.38-3.725zm-10.93 28.465l-.098.016-3.891-14.644.098-.016z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M249.03 348.238l-.08.076-21.866-25.349.06-.056z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M227.182 322.95l-.117-.005 4.439-48.403.117.005zm-36.537-10.154l-3.923 25.75-.096-.022 3.922-25.751z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M192.063 313.062l-23.78 8.178-.036-.08 23.8-8.196zm9.424-18.436l-10.824 18.19-.094-.063 10.823-18.188z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#333",
  d: "M107.196 292.44c.587.09 1.063.525 1.205 1.101a1.462 1.462 0 01-2.187 1.591 1.467 1.467 0 01-.68-1.483c.127-.792.87-1.33 1.662-1.209zm19.565-23.087c.586.09 1.062.526 1.204 1.102a1.461 1.461 0 01-2.186 1.591 1.473 1.473 0 01-.681-1.484c.128-.79.869-1.33 1.662-1.208zm2.034 35.253c.8.134 1.349.884 1.234 1.687a1.457 1.457 0 01-1.671 1.207 1.47 1.47 0 01-1.221-1.67 1.459 1.459 0 011.659-1.224zm6.106-2.024c.8.135 1.348.884 1.234 1.687a1.458 1.458 0 01-1.64 1.067 1.47 1.47 0 01-1.237-1.524 1.427 1.427 0 011.643-1.23zm31.199-3.898a1.48 1.48 0 011.234 1.687 1.47 1.47 0 01-1.682 1.228 1.481 1.481 0 01-1.233-1.687 1.467 1.467 0 011.682-1.227zm-13.766-23.859a1.464 1.464 0 011.254 1.667 1.485 1.485 0 01-1.682 1.229 1.47 1.47 0 01-1.235-1.667c.118-.8.863-1.35 1.663-1.229zm31.201 4.876c.8.135 1.349.885 1.234 1.688a1.458 1.458 0 01-1.662 1.209 1.498 1.498 0 01-1.234-1.687 1.458 1.458 0 011.662-1.209zm-32.538 13.66c.791.131 1.333.874 1.214 1.668a1.43 1.43 0 01-1.644 1.229 1.498 1.498 0 01-1.233-1.687c.127-.792.869-1.33 1.662-1.208zm57.395 28.723a1.47 1.47 0 011.216 1.667 1.485 1.485 0 01-1.683 1.228 1.47 1.47 0 01-1.215-1.666c.132-.8.88-1.345 1.683-1.228zm33.798-14.454a1.47 1.47 0 011.204 1.103 1.46 1.46 0 01-2.186 1.59 1.473 1.473 0 01-.68-1.484c.127-.79.869-1.33 1.662-1.208zm-10.383-34.543a1.47 1.47 0 011.214 1.668 1.485 1.485 0 01-1.683 1.227 1.473 1.473 0 01-1.213-1.685c.129-.8.882-1.342 1.682-1.21zm-30.234 20.136a1.482 1.482 0 011.234 1.686 1.47 1.47 0 01-1.683 1.229 1.477 1.477 0 01-.926-2.385c.33-.41.854-.612 1.375-.53zm44.146 31.735c.8.134 1.348.884 1.234 1.686a1.457 1.457 0 01-1.662 1.21 1.497 1.497 0 01-1.235-1.686 1.457 1.457 0 011.662-1.21zm-77.25-5.178a1.444 1.444 0 011.235 1.647c-.133.8-.88 1.346-1.683 1.23a1.472 1.472 0 01-1.273-.892 1.462 1.462 0 011.72-1.985zm43.656-85.466c.8.135 1.348.884 1.233 1.688a1.458 1.458 0 01-1.661 1.209 1.498 1.498 0 01-1.234-1.687 1.457 1.457 0 011.662-1.208zm40.922 21.122a1.47 1.47 0 011.215 1.668 1.484 1.484 0 01-1.683 1.227 1.47 1.47 0 01-1.214-1.666c.132-.8.879-1.345 1.683-1.228zm-100.438-31.903c.517.078.954.427 1.147.914a1.46 1.46 0 01-1.576 1.982 1.47 1.47 0 01-1.214-1.666 1.427 1.427 0 011.643-1.23zm17.658-24.524a1.47 1.47 0 011.215 1.666c-.132.8-.88 1.346-1.682 1.228a1.47 1.47 0 01-1.215-1.666c.132-.8.878-1.345 1.682-1.228zm-58.287 32.865c.8.134 1.348.884 1.233 1.687a1.484 1.484 0 01-1.681 1.228 1.496 1.496 0 01-1.234-1.687c.132-.8.879-1.345 1.682-1.228zm66.788 20.721a1.5 1.5 0 011.234 1.688 1.458 1.458 0 01-1.662 1.208 1.497 1.497 0 01-1.235-1.686c.128-.792.87-1.33 1.663-1.208zm-83.622 29.026a1.444 1.444 0 011.235 1.647 1.46 1.46 0 01-2.358.925 1.468 1.468 0 01-.539-1.363 1.458 1.458 0 011.662-1.21zm-10.361 33.117a1.47 1.47 0 011.205 1.102 1.461 1.461 0 01-2.187 1.59 1.47 1.47 0 01-.68-1.483 1.458 1.458 0 011.662-1.209zm39.378 4.63c.8.134 1.349.883 1.234 1.687a1.458 1.458 0 01-1.663 1.208 1.497 1.497 0 01-1.233-1.686 1.457 1.457 0 011.662-1.21zm31.782 7.965a1.5 1.5 0 011.235 1.688 1.458 1.458 0 01-1.662 1.209 1.496 1.496 0 01-1.234-1.687 1.458 1.458 0 011.662-1.21zm30.942 9.773c.587.09 1.064.526 1.206 1.102a1.46 1.46 0 01-2.187 1.591 1.467 1.467 0 01-.68-1.483c.127-.792.869-1.33 1.662-1.209zm3.923-25.75c.8.134 1.348.883 1.234 1.686a1.458 1.458 0 01-1.662 1.21 1.496 1.496 0 01-1.234-1.688 1.458 1.458 0 011.662-1.209zm36.519 10.133c.52.082.959.436 1.15.927a1.47 1.47 0 01-1.6 1.988 1.47 1.47 0 01-1.214-1.667c.122-.8.86-1.354 1.664-1.248zm3.985 14.744a1.47 1.47 0 011.212 1.677 1.457 1.457 0 01-1.664 1.215 1.469 1.469 0 01-1.23-1.663c.132-.8.878-1.345 1.682-1.228zm17.202 10.443a1.443 1.443 0 011.214 1.666 1.457 1.457 0 01-1.097 1.201 1.467 1.467 0 01-1.598-2.192 1.46 1.46 0 011.48-.675z"
})), /*#__PURE__*/React.createElement("g", {
  opacity: 0.71
}, /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M212.435 57.048l-17.577 24.449-.095-.062 17.577-24.45z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M254.338 92.199l-.023.097-59.516-10.78.022-.098z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M254.357 92.22l-.081.075-41.918-35.25.08-.075z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M254.354 92.297l-33.397 18.32-.056-.1 33.398-18.32z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M254.267 92.302l40.998 21.091-40.998-21.09z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M274.018 131.01l-.1.056-19.642-38.771.1-.055z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M295.375 113.364l-21.378 17.705-.076-.081 21.38-17.704z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M295.377 113.326l-10.957 52.248-.097-.024 10.957-52.247z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M284.421 165.535l-.098.015-10.404-34.484.079-.037zM243.787 151.131l30.11-20.056z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M273.976 131.088l-48.232 6.615-.016-.098 48.232-6.616z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M273.98 131.01l-.043.076-53.02-20.471.024-.097z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M254.374 92.278l-28.59 45.387-.094-.062 28.589-45.386z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M254.374 92.278l-10.471 58.833-.097-.023 10.471-58.833z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M243.885 151.052l-.061.096-18.584-13.542.041-.076zm-49.047-69.536l-40.706 8.298-.035-.118 40.724-8.278z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M194.603 132.77l-.117-.005.275-51.29.099-.017z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M220.96 110.538l-.061.057-26.12-29.1.061-.057zM194.49 132.844l26.375-22.187z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M225.787 137.627l-.1.015-4.807-27.067.098-.017z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M220.977 110.598l-12.646 46.03-.097-.023 12.627-46.05z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M225.765 137.684l-17.454 18.963-.076-.081 17.455-18.963z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M225.748 137.586l-.022.097-31.202-4.877.022-.097z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M194.546 132.71l-.022.096-25.574-5.472.023-.097z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M194.586 132.71l-.08.076-40.432-42.993.081-.075z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M168.992 127.258l-.08.036-14.857-37.521.099-.016zM168.891 127.278l24.183 24.063-24.183-24.063z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M168.97 127.316l-31.538 12.348-.056-.1 31.558-12.328zm24.277 23.97l-.118-.004 1.357-18.517.117.005z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M208.274 156.567l-.023.097-15.065-5.321.023-.097z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M210.719 177.705l-.118-.004-2.387-21.077.098-.017z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M208.29 156.665l-31.2 3.937-.017-.098 31.201-3.937zm-15.104-5.322l-43.8-.922.004-.117 43.8.922z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M193.226 151.344l-16.117 9.24-.054-.1 16.115-9.24z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M193.226 151.344l-66.23 21.357-.037-.08 66.21-21.376zm-43.817-1.02l-.062.095-11.973-10.777.06-.056z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M149.406 150.402l-22.372 22.3-.096-.062 22.411-22.299z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M171.027 162.51l-.062.096-21.618-12.187.062-.095z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M177.09 160.602l-6.086 2.005-.016-.098 6.085-2.005z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M171.044 162.57l-4.691 14.778-.077-.041 4.671-14.76z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M171.004 162.607l-44.029 10.112-.016-.098 44.029-10.112zm27.155 22.611l-.023.098-31.823-7.93.022-.096z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M166.313 177.386l-39.338-4.667.004-.117 39.356 4.688z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M210.658 177.761l-44.345-.375.022-.096 44.327.354z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M210.679 177.742l-12.504 7.574-.054-.1 12.52-7.553z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M229.1 194.991l-.041.076-30.923-9.751.023-.098z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M273.39 194.133l-75.254-8.817.023-.098 75.253 8.818zm17.395 10.488l-.004.117-61.722-9.67.022-.097z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M250.603 180.047l-21.505 15.022-.076-.081 21.524-15.002z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M287.927 182.96l-58.849 12.128-.016-.099 58.849-12.128zm2.877 21.681l-.042.076-17.373-10.584.042-.076z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M287.948 182.94l-14.52 11.194-.055-.1 14.5-11.174zM250.52 180.083l22.82 14.062-22.82-14.062zM269.537 179.49l-18.955.576-.015-.099 18.954-.575z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M250.606 179.97l-.062.094L233 169.337l.022-.097z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M273.997 131.069l-23.394 48.978-.077-.042 23.393-48.978zm14.05 51.25l-.099.016-3.625-16.785.098-.015z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M284.4 165.593l-14.843 13.878-.075-.08 14.86-13.859zM232.944 169.365l51.356-3.737z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M273.45 194.076l-.098.017-3.891-14.645.097-.016z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M291.426 204.742l-.08.075-21.866-25.348.08-.075zM273.967 131.097l-4.329 48.41zM233.06 169.28l-3.922 25.752-.117-.005 3.922-25.75z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M234.458 169.566l-23.78 8.176-.036-.079 23.8-8.195zm9.424-18.436L233.06 169.32l-.095-.062 10.823-18.189z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#333",
  d: "M149.591 148.943c.384.052.73.255.963.565.234.31.331.7.273 1.083a1.485 1.485 0 01-1.683 1.228 1.47 1.47 0 01-1.215-1.667c.127-.791.87-1.33 1.662-1.208zm19.585-23.105a1.47 1.47 0 011.214 1.667 1.485 1.485 0 01-1.682 1.228 1.469 1.469 0 01-1.214-1.667c.132-.8.878-1.346 1.682-1.228zm2.034 35.292a1.47 1.47 0 011.215 1.666 1.458 1.458 0 01-1.662 1.21 1.47 1.47 0 01-1.215-1.667 1.458 1.458 0 011.662-1.21zm6.085-2.005c.384.05.73.255.964.564.232.31.33.702.272 1.083-.133.8-.88 1.346-1.683 1.229a1.47 1.47 0 01-1.215-1.666 1.456 1.456 0 011.662-1.21zm31.241-3.975a1.47 1.47 0 011.205 1.103 1.46 1.46 0 01-2.186 1.59 1.467 1.467 0 01-.68-1.484 1.458 1.458 0 011.661-1.209zm-13.768-23.82a1.47 1.47 0 011.215 1.667 1.458 1.458 0 01-1.662 1.208 1.441 1.441 0 01-1.235-1.647c.132-.8.88-1.346 1.683-1.228zm31.183 4.856a1.482 1.482 0 011.234 1.688 1.47 1.47 0 01-1.683 1.228 1.482 1.482 0 01-1.233-1.688 1.47 1.47 0 011.682-1.228zm-32.56 13.679a1.467 1.467 0 011.254 1.668 1.485 1.485 0 01-1.683 1.229 1.497 1.497 0 01-1.233-1.688c.128-.791.87-1.33 1.663-1.208zm57.397 28.723a1.47 1.47 0 011.205 1.102 1.461 1.461 0 01-2.187 1.59 1.47 1.47 0 01-.68-1.483c.127-.791.87-1.33 1.662-1.208zm33.898-14.549a1.47 1.47 0 011.214 1.668 1.484 1.484 0 01-1.681 1.227 1.47 1.47 0 01-1.215-1.666c.132-.8.879-1.345 1.683-1.228zm-10.41-34.327a1.47 1.47 0 011.205 1.1 1.462 1.462 0 01-2.186 1.592 1.473 1.473 0 01-.681-1.484c.128-.79.869-1.33 1.662-1.208zm-30.208 19.959a1.471 1.471 0 011.071 1.645 1.455 1.455 0 01-1.518 1.23 1.44 1.44 0 01-1.296-1.59 1.485 1.485 0 011.743-1.285zm44.046 31.79c.388.054.739.26.975.574.236.313.336.708.28 1.094-.134.8-.88 1.346-1.683 1.228-.8-.12-1.353-.867-1.235-1.666s.863-1.351 1.663-1.23zm-77.23-5.196a1.47 1.47 0 011.215 1.666c-.132.8-.879 1.346-1.682 1.228a1.47 1.47 0 01-1.215-1.666c.132-.8.878-1.345 1.682-1.228zm43.636-85.446a1.496 1.496 0 011.194 1.723 1.457 1.457 0 01-1.662 1.21 1.47 1.47 0 01-1.215-1.666 1.432 1.432 0 011.684-1.268zm41.022 21.067a1.47 1.47 0 011.215 1.667 1.431 1.431 0 01-1.643 1.228 1.469 1.469 0 01-1.254-1.666c.131-.801.88-1.347 1.682-1.23zM195.044 80.039a1.47 1.47 0 011.214 1.666 1.485 1.485 0 01-1.682 1.228 1.47 1.47 0 01-1.215-1.666c.132-.8.879-1.346 1.683-1.228zm17.558-24.47c.8.135 1.348.884 1.233 1.687a1.458 1.458 0 01-1.662 1.209 1.497 1.497 0 01-1.233-1.686 1.457 1.457 0 011.662-1.21zM154.32 88.317c.8.134 1.348.884 1.233 1.686a1.458 1.458 0 01-1.661 1.21 1.465 1.465 0 01-.975-.574 1.462 1.462 0 01-.28-1.094c.132-.8.88-1.345 1.683-1.228zm66.824 20.8c.8.136 1.349.886 1.234 1.689a1.484 1.484 0 01-1.682 1.227 1.498 1.498 0 01-1.194-1.725 1.486 1.486 0 011.643-1.19zm-83.525 29.05c.8.133 1.349.883 1.234 1.686a1.485 1.485 0 01-1.683 1.227 1.497 1.497 0 01-1.233-1.686c.131-.8.88-1.346 1.682-1.228zm-10.417 33.055c.791.13 1.334.873 1.214 1.667a1.459 1.459 0 01-1.663 1.249 1.497 1.497 0 01-1.233-1.688c.132-.8.878-1.345 1.681-1.227zm39.337 4.667a1.498 1.498 0 011.234 1.688 1.485 1.485 0 01-1.683 1.227 1.497 1.497 0 01-1.233-1.686 1.484 1.484 0 011.682-1.228zm31.822 7.968a1.443 1.443 0 011.236 1.648 1.485 1.485 0 01-1.683 1.229 1.47 1.47 0 01-1.072-1.644 1.456 1.456 0 011.52-1.232zm30.943 9.734a1.47 1.47 0 011.215 1.667 1.485 1.485 0 01-1.683 1.228 1.47 1.47 0 01-1.214-1.667c.132-.8.88-1.345 1.683-1.227zm3.998-25.67a1.47 1.47 0 011.212 1.676 1.458 1.458 0 01-1.664 1.216 1.47 1.47 0 01-1.23-1.664c.132-.8.878-1.345 1.682-1.228zm36.441 10.092c.587.09 1.064.526 1.206 1.102a1.46 1.46 0 01-2.187 1.59 1.467 1.467 0 01-.68-1.483c.127-.792.869-1.33 1.662-1.209zm3.894 14.605c.8.134 1.348.884 1.233 1.687a1.458 1.458 0 01-1.663 1.208 1.441 1.441 0 01-1.235-1.647 1.463 1.463 0 011.665-1.248zm17.41 10.585a1.47 1.47 0 011.216 1.667 1.485 1.485 0 01-1.683 1.228 1.47 1.47 0 01-1.215-1.666c.132-.8.88-1.345 1.683-1.228z"
})), /*#__PURE__*/React.createElement("g", {
  opacity: 0.84
}, /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M272.155 254.34l14.233-7.295.018.059-14.234 7.295z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M260.809 227.619l.02-.058 25.598 19.485-.06.057z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M260.79 227.598l.059-.017 11.324 26.78-.058.017z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M260.81 227.58l20.243-.568-.001.04-20.243.567zM246.598 207.818l14.307 19.87z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M260.851 204.54l.079.002-.081 23.04-.06.016z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M246.48 207.725l14.392-3.204.017.059-14.41 3.184z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M246.48 207.725l17.789-21.998.038.04-17.808 21.979z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M264.269 185.727l.04.001-3.4 18.833-.058-.021z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M260.892 204.501l19.085-2.172.017.059-19.105 2.192z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M260.91 204.521l24.417 8.557-.02.02-24.438-8.539z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M260.87 204.56l.04-.039 20.163 22.472-.04.038z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M260.81 227.58l24.498-14.522.017.06-24.516 14.5z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M260.79 227.559l19.187-25.23.038.04-19.186 25.23z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M279.975 202.367l.06-.017 5.502 10.873-.04.037zm6.413 44.678l21.299 5.94-.022.058-21.278-5.96z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M298.874 222.917l.058.021-12.506 24.147-.058-.022z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M281.033 227.03l.06-.016 5.314 20.051-.04-.002z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M281.035 226.992l17.878-4.074-.001.04-17.86 4.093z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M285.287 213.077l.058.021-4.273 13.934-.058-.02z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M281.035 226.992l17.13-18.662.039.041-17.132 18.661z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M285.308 213.058l12.858-4.728.018.06-12.86 4.727z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M285.306 213.097l.04-.037 13.587 9.84-.04.037zm13.587 9.84l.04-.038 10.789 8.78-.021.058z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M298.893 222.937l.059-.017 8.735 30.064-.041.039z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M309.682 231.716l.059-.017-2.035 21.306-.06-.022zM303.999 214.505l.06-.017 5.682 17.211-.06.017z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M309.722 231.679l17.898 1.81.017.058-17.936-1.81zm-5.723-17.174l.059.022-5.126 8.411-.037-.04z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M298.164 208.37l.04-.038 5.854 6.156-.04.038z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M302.11 197.804l.059.023-3.965 10.544-.059-.021z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M298.186 208.312l15.717 5.697-.02.058-15.719-5.697zm5.872 6.176l20.504 11.032-.02.058-20.524-11.052z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M304.02 214.486l9.883-.477-.02.058-9.846.479z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M304.02 214.486l36.54 5.914-.02.058-36.503-5.912zm20.502 11.071l.06-.017 3.077 7.95-.04.038z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M324.543 225.5l16.017-5.1.018.059-16.016 5.1z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M317.246 214.562h.04l7.295 10.978-.059.017z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M313.903 214.009l3.364.533-.002.04-3.383-.515z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M317.246 214.562l5.803-5.866.038.04-5.803 5.866z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M317.267 214.542l23.293 5.858-.02.058-23.275-5.877zm-7.382-17.254l.04-.037 13.145 11.426-.022.057z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M323.07 208.677l17.51 11.743-.04.038-17.492-11.724z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M302.15 197.806l20.92 10.871-.022.057-20.939-10.89z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M302.15 197.806l7.738-.557.017.06-7.756.536z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M297.584 185.229l.04-.038 12.302 12.06-.04.037z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M276.392 174.914l33.534 22.337-.04.037-33.514-22.355zm-5.695-9.18l.04-.037 26.888 19.494-.04.038z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M283.786 187.048l13.82-1.877-.001.039-13.801 1.898z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M266.817 176.654l30.788 8.517v.039l-30.809-8.498zm3.88-10.92l.04-.037 5.655 9.217-.02.019z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M266.797 176.673l9.575-1.78.019.06-9.576 1.78z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M276.372 174.933l.02-.019 7.413 12.154-.02.02z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M274.686 182.747l9.12 4.321-.002.04-9.14-4.303z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M283.785 187.087l.02-.019 5.748 9.318-.058.018z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M260.872 204.52l22.914-17.472.018.06-22.895 17.453zm5.722-27.58l.058.02-2.324 8.789-.06-.022z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M264.29 185.708l10.396-2.961-.001.04-10.378 2.98zM264.215 185.806l25.22 10.65-25.22-10.65z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M276.353 174.912l.058.023-1.706 7.832-.04-.001z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M270.43 165.53l.04.001 4.235 17.236-.04-.001z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M274.665 182.766l.04.001-13.796 21.794-.037-.04zm14.831 13.599l8.09-11.176.057.022-8.11 11.194z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M288.886 195.912l13.264 1.894-.022.058-13.244-1.912zm-8.909 6.417l9.52-5.964.037.04-9.52 5.964z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#333",
  d: "M324.09 226.186a.778.778 0 01-.178-1.08.77.77 0 011.081-.177.745.745 0 01.178 1.082.772.772 0 01-1.08.176zm-14.84 6.16a.77.77 0 11.9-1.254c.348.25.429.731.18 1.078a.775.775 0 01-1.08.175zm7.545-17.137a.8.8 0 111.131-1.076c.169.284.15.64-.05.9a.771.771 0 01-1.081.176zm-3.363-.534a.773.773 0 11.901-1.256.777.777 0 01.18 1.08.77.77 0 01-1.081.177zm-15.718-5.697a.773.773 0 11.901-1.256.8.8 0 01.199 1.1.772.772 0 01-1.1.156zm.748 14.588a.772.772 0 11.9-1.254.774.774 0 01-.323 1.39.779.779 0 01-.578-.136zm-13.587-9.84a.77.77 0 01-.18-1.081.772.772 0 01.706-.318.78.78 0 01.63.452.773.773 0 01-1.157.948zm18.693 1.408a.772.772 0 111.05-1.083.773.773 0 01-1.05 1.083zm-20.235-27.399a.773.773 0 01-.158-1.1.774.774 0 011.081-.176c.347.25.427.736.179 1.082a.8.8 0 01-1.102.194zm-19.516-1.36a.772.772 0 01-.31-.517.772.772 0 01.152-.584.801.801 0 011.082-.175c.267.28.298.711.072 1.025a.798.798 0 01-.996.25zm-3.397 18.793a.773.773 0 01.932-1.231.773.773 0 11-.932 1.231zm19.124-2.172a.773.773 0 01-.18-1.081.774.774 0 011.258.905.77.77 0 01-1.078.176zm-13.198-25.675a.773.773 0 11.901-1.256.773.773 0 01.18 1.081.745.745 0 01-1.08.175zm35.352 21.133a.773.773 0 11.902-1.257.773.773 0 11-.901 1.256zm-41.34 29.773a.773.773 0 11.901-1.254c.347.25.427.732.18 1.079a.774.774 0 01-1.081.176zm-14.33-19.854a.771.771 0 11.9-1.254c.35.25.43.732.182 1.08a.775.775 0 01-1.08.175zm39.888 39.339a.8.8 0 01.923-1.276.777.777 0 01.158 1.1.77.77 0 01-1.081.176zm-14.333 7.389a.77.77 0 01-.18-1.081.8.8 0 011.1-.195.777.777 0 01.16 1.1.777.777 0 01-1.08.176zm35.632-1.45a.801.801 0 01-.198-1.101.77.77 0 011.099-.155.774.774 0 11-.901 1.256zm-26.612-25.99a.772.772 0 11.9-1.255.774.774 0 01-.324 1.39.779.779 0 01-.578-.136zm46.566 6.475a.773.773 0 01.932-1.23.773.773 0 01-.349 1.386.775.775 0 01-.583-.156zm12.92-13.07a.773.773 0 11.901-1.256.772.772 0 11-.901 1.256zm-17.436-11.623a.801.801 0 01-.159-1.1.776.776 0 011.26.906.8.8 0 01-1.1.194zm-13.217-11.546a.774.774 0 01-.18-1.08.803.803 0 011.278.926.77.77 0 01-1.098.154zm-12.302-12.06a.8.8 0 01.923-1.276c.168.123.281.31.31.518a.772.772 0 01-.153.584.772.772 0 01-1.08.175zm-8.07 11.195a.772.772 0 11.901-1.253.774.774 0 01-.324 1.39.778.778 0 01-.578-.135zm-14.85-13.618a.777.777 0 01-.178-1.081.775.775 0 011.08-.176.745.745 0 01.179 1.082c-.12.166-.3.28-.503.31a.771.771 0 01-.578-.135zm1.687-7.854a.784.784 0 11.941-1.255.785.785 0 11-.94 1.256zm-5.635-9.196a.802.802 0 01-.197-1.101.803.803 0 011.278.926.775.775 0 01-1.08.175z"
})), /*#__PURE__*/React.createElement("g", {
  opacity: 0.27
}, /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M171.863 86.106l-7.559 7.54-.037-.04 7.577-7.52z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M184.467 100.834l-.02.02-20.162-7.228.02-.02z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M184.467 100.834l-.02.02-12.605-14.73.04-.037z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M184.466 100.874l-12.752 4.437.002-.038 12.751-4.439z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M197.549 110.578v.04l-13.103-9.764.021-.02z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M189.08 115.525l-.04-.002-4.594-14.67.021-.019zM189.91 116.383l8.513-4.976zM197.568 110.599l-6.857 17.591-.057-.022 6.875-17.571z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M190.692 128.17l-.02.019-1.631-12.666.04.002z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M189.06 115.544l-11.685 5.259-.017-.06 11.703-5.239z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M189.06 115.544l-17.239-.496.001-.039 17.239.495z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M189.061 115.504l-.001.04-17.346-10.233.002-.038z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M184.466 100.874L171.84 115.03l-.019-.02 12.606-14.176z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M184.486 100.855l-7.11 19.908h-.039l7.11-19.91z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M177.376 120.763l-.02.02-5.708-5.8.02-.018zm-13.091-27.137l-14.692.536v-.039l14.694-.536zM164.393 93.694l-3.075 17.874zM171.734 105.293l-.02.018-7.429-11.685.02-.02z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M171.714 105.311l-10.503 6.202v-.04l10.505-6.2z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M171.841 115.03l-.039-.002-.106-9.736.038.001z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M171.734 105.293l-7.113 15.335-.02-.02 7.095-15.316z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M171.841 115.03l-7.201 5.619-.039-.041 7.221-5.599zM161.136 111.57l10.598 3.527zM161.212 111.474l-.001.039-8.642-3.405.02-.019z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M161.23 111.494l-.02.019-11.636-17.371.02-.019z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M152.589 108.09l-.02.018-2.995-13.966.038.002zm7.082 9.777l-.02.019-7.082-9.778.02-.019zM140.768 110.644l11.75-2.466z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M159.67 117.905l-.019-.02 1.54-6.393.04.002z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M164.641 120.61l-.04.037-4.95-2.761.02-.019z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M164.235 128.138l-.019-.02.385-7.51.02.02z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M164.62 120.628l-11.143-.428.001-.04 11.123.448zm-4.95-2.723l-15.265-2.865.001-.04 15.265 2.867z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M159.67 117.905l-6.173 2.276-.019-.02 6.173-2.275z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M159.67 117.905l-24.39 3.601v-.039l24.371-3.581zm-15.243-2.923l-.04.037-3.546-4.449.02-.02z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M144.425 115.021l-9.145 6.485v-.039l9.126-6.466z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M151.258 120.529l-.02.018-6.852-5.528.04-.037z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M153.497 120.181l-2.259.366v-.039l2.24-.347z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M151.258 120.529l-2.488 4.892-.018-.02 2.487-4.893z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M151.238 120.547l-15.958.96v-.04l15.959-.959zm8.186 9.466l-.02.02-10.672-4.614.02-.018z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M148.75 125.44l-13.47-3.934v-.039l13.472 3.934z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M164.235 128.138l-15.485-2.699.002-.038 15.485 2.698z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M164.235 128.138l-4.812 1.915-.02-.02 4.813-1.915z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M169.647 135.235l-.02.02-10.223-5.223.02-.019z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M185.185 137.505l-25.781-7.473.02-.019 25.762 7.453zm5.453 4.676l-.001.038-21.01-6.965.02-.019z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M178.045 131.263l-8.38 3.992-.018-.02 8.379-3.993zM169.557 135.329l21.275-.803-21.275.803zM190.657 142.201l-.02.018-5.452-4.714.02-.018z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M190.914 134.47l-5.729 3.035v-.039l5.71-3.054z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M185.205 137.487l-.02.018-7.18-6.244.02-.019z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M184.677 132.19l-6.653-.908.002-.04 6.653.91zm-6.651-.948l-.02.02-5.49-4.755.02-.02z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M189.06 115.544l-11.015 15.719-.02-.02 11.016-15.72zM191 134.24l-.04-.002-.287-6.05.02-.018z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M190.691 128.209l-5.993 3.963-.02-.02 5.995-4.002z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M190.673 128.189l-18.157-1.682.001-.04 18.175 1.703zm-5.468 9.298l-.039-.002-.508-5.315.04.002z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M190.87 142.267l-.04-.001-6.172-10.096.04-.037z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M184.698 132.172l-.02-.02 4.363-16.629.04.002zm-12.162-5.684l-2.87 8.767h-.04l2.87-8.769z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M173.018 126.681l-8.783 1.457-.019-.02 8.804-1.475zm4.357-5.878l-4.839 5.685-.04-.002 4.841-5.724z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#333",
  d: "M144.541 114.497c.269.105.413.4.33.678a.497.497 0 01-.656.307.5.5 0 01-.33-.638.523.523 0 01.657-.347zm8.282-6.966c.27.105.413.4.33.676a.524.524 0 01-.656.309.495.495 0 01-.33-.637.523.523 0 01.656-.348zm-1.412 12.515c.262.101.399.39.31.656a.494.494 0 01-.637.329.527.527 0 01-.35-.659.551.551 0 01.677-.326zm2.24-.348a.5.5 0 01.31.656.5.5 0 01-.636.329.527.527 0 01-.35-.658.551.551 0 01.675-.327zm11.021.54a.5.5 0 01.331.638.52.52 0 01-.656.348.528.528 0 01-.35-.659.524.524 0 01.676-.326zm-3.308-9.208a.498.498 0 01.33.637.52.52 0 01-.656.348.555.555 0 01-.33-.677c.1-.262.39-.397.656-.308zm10.61 3.496c.271.105.415.4.331.677a.52.52 0 01-.601.447.504.504 0 01-.331-.637.522.522 0 01.602-.487zm-12.17 2.877c.133.04.246.133.31.257.066.123.08.267.039.4a.55.55 0 01-.675.328.528.528 0 01-.311-.657.494.494 0 01.637-.329zm18.434 13.34c.262.101.398.39.31.656a.498.498 0 01-.637.329.526.526 0 01-.35-.658.524.524 0 01.677-.328zm12.587-3.037a.526.526 0 01.35.658.525.525 0 01-.656.308.504.504 0 01-.3-.249.506.506 0 01-.03-.39.494.494 0 01.636-.328zm-1.613-12.645a.495.495 0 01.33.637.523.523 0 01-.656.348.555.555 0 01-.329-.677.5.5 0 01.655-.308zM177.51 120.3a.526.526 0 01.35.658.524.524 0 01-.656.309.496.496 0 01-.33-.638.496.496 0 01.636-.33zm13.557 13.65c.27.104.414.4.33.677a.525.525 0 01-.656.308.504.504 0 01-.33-.638.52.52 0 01.656-.347zm-26.698-6.314a.523.523 0 01.349.658.513.513 0 01-.268.305.515.515 0 01-.406.021.526.526 0 01-.311-.656.493.493 0 01.636-.328zm20.23-27.264a.528.528 0 01.35.658.551.551 0 01-.676.327.527.527 0 01-.31-.656.491.491 0 01.636-.33zm13.102 9.725a.522.522 0 01.33.675.489.489 0 01-.248.3.491.491 0 01-.388.03.523.523 0 01-.35-.659.518.518 0 01.256-.31.518.518 0 01.4-.036zm-33.263-16.954a.527.527 0 01.35.659.579.579 0 01-.675.326.525.525 0 01-.31-.655.496.496 0 01.636-.33zm7.578-7.52a.528.528 0 01.31.657.494.494 0 01-.637.329.496.496 0 01-.33-.637.52.52 0 01.657-.348zm-22.29 8.037a.499.499 0 01.35.657.524.524 0 01-.655.31.506.506 0 01-.301-.25.506.506 0 01-.03-.39.494.494 0 01.636-.327zm22.162 11.15a.527.527 0 01.31.657.492.492 0 01-.636.328.527.527 0 01-.35-.658c.105-.269.399-.41.676-.327zm-30.8 5.34c.263.102.4.39.312.657a.492.492 0 01-.636.328.527.527 0 01-.35-.658.58.58 0 01.675-.327zm-5.756 10.968a.5.5 0 01.33.638.492.492 0 01-.635.328.527.527 0 01-.35-.658.497.497 0 01.655-.308zm13.572 3.801c.27.104.414.4.33.677a.525.525 0 01-.656.308.504.504 0 01-.33-.638.52.52 0 01.656-.347zm10.653 4.632a.528.528 0 01.35.658.55.55 0 01-.676.326.526.526 0 01-.31-.656.497.497 0 01.636-.328zm10.243 5.202c.27.105.412.4.33.677a.525.525 0 01-.656.308.504.504 0 01-.331-.637.52.52 0 01.657-.348zm2.927-8.707a.528.528 0 01.31.656.495.495 0 01-.636.329.527.527 0 01-.35-.658c.105-.269.4-.41.676-.327zm12.104 5.623a.526.526 0 01.35.658.524.524 0 01-.675.327.5.5 0 01-.33-.638.52.52 0 01.655-.347zm.488 5.334a.5.5 0 01.33.637.525.525 0 01-.656.348.556.556 0 01-.33-.677.525.525 0 01.656-.308zm5.47 4.735a.5.5 0 01.332.637.493.493 0 01-.637.328.523.523 0 01-.35-.658c.1-.26.39-.397.656-.307z"
})), /*#__PURE__*/React.createElement("g", {
  opacity: 0.3
}, /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M276.012 135.696l-7.577 7.52-.019-.02 7.578-7.52z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M288.616 150.425l-.04.038-20.141-7.247.001-.038z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M288.616 150.425l-.04.038-12.584-14.747.02-.02z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M288.596 150.444l-12.733 4.458.003-.039 12.711-4.438zm13.103 9.725l-.02.019-13.103-9.725.04-.038z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M293.21 165.095l-.04.038-4.594-14.67.04-.038zm8.487-4.887l-8.488 4.927-.02-.02 8.51-4.946z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M301.718 160.19l-6.876 17.57h-.04l6.876-17.572z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M294.842 177.76h-.04l-1.632-12.627.04-.038z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M293.209 165.135l-11.703 5.238.001-.039 11.683-5.22z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M293.209 165.135l-17.257-.517v-.038l17.258.515z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M293.21 165.095l-.04.038-17.307-10.23.003-.04z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M288.596 150.444l-12.606 14.177-.057-.022 12.644-14.174zM288.658 150.543l-7.086 19.912zM281.526 170.355l-.02.018-5.71-5.799.021-.019zm-13.091-27.139l-14.712.517.001-.04 14.712-.515z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M265.36 161.104l-.019-.02 3.075-17.888.039.002z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M275.866 154.863l-.02.02-7.411-11.667.02-.018z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M275.863 154.902l-10.503 6.202-.019-.02 10.525-6.22z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M275.971 164.6l-.038-.001-.088-9.716h.039z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M275.884 154.883l-7.114 15.335-.019-.02 7.094-15.315z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M275.97 164.639l-7.2 5.58-.019-.021 7.202-5.618z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M275.971 164.6l-.02.018-10.59-3.514v-.04zM265.361 161.064v.04l-8.643-3.405.002-.04z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M265.361 161.064l-.04.038-11.598-17.37.02-.019z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M256.739 157.68l-.04-.001-2.976-13.946.02-.02zm7.061 9.796l-.02.019-7.062-9.796.02-.02z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M256.718 157.699l-11.728 2.463.002-.04 11.728-2.462zm7.1 9.797l-.037-.04 1.56-6.373.02.02z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M268.751 170.198l-.001.04-4.97-2.743.02-.019z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M268.366 177.708l-.02.02.385-7.511.04.001z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M268.75 170.237l-11.123-.447v-.039l11.124.447zm-4.97-2.742l-15.244-2.884.02-.02 15.225 2.865z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M263.819 167.496l-6.192 2.294v-.039l6.154-2.295z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M263.819 167.496l-24.39 3.601.002-.04 24.35-3.601zm-15.262-2.904l-.02.019-3.566-4.47.04.002z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M248.555 164.63l-9.126 6.467-.019-.02 9.128-6.506z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M255.388 170.1l-.02.018-6.832-5.507.02-.02zm2.239-.31l-2.24.348.001-.039 2.24-.348z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M255.407 170.12l-2.506 4.872-.04-.002 2.507-4.872z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M255.387 170.138l-15.958.959.002-.04 15.957-.958zm8.167 9.485l-.02.019-10.653-4.632.02-.018z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M252.88 175.01l-13.47-3.934.02-.019 13.47 3.935zm15.466 2.717l-15.465-2.717.02-.018 15.465 2.716z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M268.384 177.728l-4.811 1.915-.038-.04 4.812-1.915z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M273.796 184.826l-.02.019-10.243-5.203.02-.02z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M289.334 187.096l-25.8-7.454.02-.02 25.782 7.434zM273.833 184.574l20.745 7.674z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M282.173 180.873l-8.397 3.972.001-.04 8.38-3.992z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M295.044 184.041l-21.268.804.001-.04 21.268-.803zM289.213 187.203l5.49 4.65-5.49-4.65z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M295.044 184.041l-5.71 3.055-.019-.02 5.73-3.074z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M289.336 187.056l-.022.059-7.16-6.263.02-.019z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M288.807 181.761l-6.634-.888.002-.04 6.653.909zm-6.632-.928l-.02.02-5.509-4.776.02-.019z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M293.209 165.135l-11.015 15.719-.038-.04 11.034-15.7zm1.92 18.714l-.04-.001-.286-6.089.04.002z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M294.822 177.78l-5.975 3.982-.038-.04 5.994-3.963z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M294.822 177.78l-18.157-1.682.001-.04 18.157 1.682zm-5.467 9.297l-.04-.002-.508-5.314.02-.02z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M295 191.838l-.04.037-6.153-10.114.02-.02zM293.29 165.213l-4.366 16.63zM276.686 176.079l-2.89 8.747-.039-.002 2.889-8.747z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "gray",
  d: "M277.149 176.253l-8.765 1.475-.037-.04 8.803-1.475zm4.357-5.88l-4.84 5.725-.02-.02 4.841-5.726z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#333",
  d: "M248.71 164.109c.268.105.412.4.329.676a.524.524 0 01-.656.308.497.497 0 01-.33-.637.518.518 0 01.656-.347zm8.22-6.871c.26.1.398.39.31.655a.491.491 0 01-.249.3.491.491 0 01-.387.03.528.528 0 01-.35-.659.55.55 0 01.676-.326zm-1.389 12.378c.27.105.414.4.33.677a.524.524 0 01-.656.308.5.5 0 01-.33-.638.526.526 0 01.656-.348zm2.24-.348a.525.525 0 01.33.677.497.497 0 01-.637.328.523.523 0 01-.35-.658.522.522 0 01.656-.347zm11.142.467c.262.102.398.39.311.657a.498.498 0 01-.637.329.526.526 0 01-.35-.658.524.524 0 01.676-.328zm-3.429-9.134a.525.525 0 01.35.657.526.526 0 11-.986-.33.496.496 0 01.636-.328zm10.63 3.515c.261.116.4.403.33.677a.523.523 0 01-.655.308.496.496 0 01-.33-.637.55.55 0 01.656-.348zm-12.171 2.878a.47.47 0 01.31.655.506.506 0 01-.636.33.51.51 0 01-.33-.638.525.525 0 01.656-.347zm18.355 13.375a.527.527 0 01.349.659.523.523 0 01-.655.307.498.498 0 01-.33-.637.496.496 0 01.636-.33zm12.667-3.072a.495.495 0 01.33.637.523.523 0 01-.656.348.556.556 0 01-.33-.677.524.524 0 01.656-.308zm-1.632-12.666a.527.527 0 01.24.926.525.525 0 01-.566.059.506.506 0 01-.298-.261.51.51 0 01-.013-.396.497.497 0 01.637-.328zm-11.684 5.26a.496.496 0 01.33.637.52.52 0 01-.656.347.555.555 0 01-.33-.677c.1-.261.39-.397.656-.308zm13.618 13.592a.507.507 0 11-.306.966.526.526 0 01-.35-.658.497.497 0 01.656-.308zm-26.76-6.258a.524.524 0 11-.306 1.003.528.528 0 01-.094-.966.524.524 0 01.402-.037zm20.231-27.263a.497.497 0 01.33.638.523.523 0 01-.655.346.522.522 0 01-.33-.676.523.523 0 01.656-.31zm13.083 9.743a.528.528 0 01.35.658.525.525 0 01-.656.308.507.507 0 11.307-.967zm-33.318-17.052a.499.499 0 01.33.637.52.52 0 01-.656.348.555.555 0 01-.33-.677c.1-.262.39-.397.656-.308zm7.652-7.44c.262.102.4.39.31.657a.494.494 0 01-.637.329.526.526 0 01-.348-.658.55.55 0 01.675-.327zm-22.229 7.98a.526.526 0 01.35.658.58.58 0 01-.676.327.528.528 0 01-.31-.656.497.497 0 01.636-.329zm22.156 11.308a.528.528 0 01.35.658.524.524 0 01-.676.326.528.528 0 01-.311-.656.495.495 0 01.637-.328zm-30.949 5.178a.496.496 0 01.33.637.526.526 0 01-.656.348.555.555 0 01-.33-.678.497.497 0 01.655-.308zm-5.58 10.915a.528.528 0 01.35.658.55.55 0 01-.676.326.526.526 0 01-.31-.656.492.492 0 01.249-.3.491.491 0 01.387-.028zm13.45 3.953c.27.104.414.399.33.676a.525.525 0 01-.656.308.504.504 0 01-.3-.249.506.506 0 01-.03-.389.518.518 0 01.256-.31.518.518 0 01.4-.036zm10.694 4.593c.261.102.398.39.31.655a.491.491 0 01-.636.33.527.527 0 01-.35-.659.58.58 0 01.675-.326zm10.221 5.222a.507.507 0 11-.305.965.525.525 0 01-.35-.658.501.501 0 01.26-.296.502.502 0 01.395-.012zm2.77-8.674c.261.027.463.244.472.506a.55.55 0 01-.675.327.526.526 0 01-.31-.656.496.496 0 01.513-.177zm12.283 5.571c.268.105.413.4.33.677a.525.525 0 01-.656.308.503.503 0 01-.331-.638.52.52 0 01.657-.347zm.506 5.354a.5.5 0 01.33.638.523.523 0 01-.657.347.527.527 0 01-.328-.676.5.5 0 01.26-.297.504.504 0 01.395-.012zm5.493 4.637a.527.527 0 01.35.659.524.524 0 11-.985-.33.496.496 0 01.636-.329z"
}))));

function SvgHomeBg(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 604,
    height: 613
  }, props), _ref);
}

export default SvgHomeBg;